const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2122 2122",
    style: {
      enableBackground: "new 0 0 2122 2122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.012,
    y: 0.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 2121.293,
    height: 2121.301
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#357E99"
    },
    d: "M341.348,1676.281c-13.906-9.031-21.281-18.441-21.281-28.117 c0-67.98,363.094-123.086,811.004-123.086c447.898,0,810.992,55.105,810.992,123.086c0,53.195-222.352,98.504-533.676,115.699 c-11.332,65.98-282.023,118.781-614.355,118.781c-339.535,0-614.777-55.109-614.777-123.09 C179.254,1727.438,240.719,1698.203,341.348,1676.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#357E99"
    },
    d: "M1727.098,1810.426c80.371,0,145.527,13.047,145.527,29.133c0,16.098-65.156,29.141-145.527,29.141 c-80.379,0-145.527-13.043-145.527-29.141C1581.57,1823.473,1646.719,1810.426,1727.098,1810.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#357E99"
    },
    d: "M342.027,1557.965c-50.016,0-90.558-8.117-90.558-18.133c0-10.008,40.543-18.129,90.558-18.129 c50.008,0,90.555,8.121,90.555,18.129C432.582,1549.848,392.035,1557.965,342.027,1557.965z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEDBF0"
    },
    d: "M1753.992,929.07c1.625,382.914-307.477,694.648-690.391,696.273 c-382.914,1.629-694.641-307.465-696.266-690.379c-1.629-382.918,307.465-694.644,690.379-696.273 C1440.629,237.066,1752.363,546.152,1753.992,929.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCE8F3"
    },
    d: "M1753.98,926.148c-1.48-176.469-69.902-352.43-205.113-486.508 c-135.219-134.07-311.762-200.977-488.23-200.965L1753.98,926.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88CDEC"
    },
    d: "M553.496,459.301c-254.613,272.844-247.863,700.5,18.973,965.07 c266.832,264.574,694.531,267.691,965.203,10.773L553.496,459.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1216.32,332.148 1284.238,349.191 1216.465,366.805 1199.426,434.723 1181.816,366.953  1113.898,349.918 1181.66,332.293 1198.703,264.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1319.727,427.379 1346.512,434.102 1319.785,441.043 1313.07,467.82 1306.121,441.102  1279.344,434.383 1306.063,427.438 1312.789,400.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1123.965,414.516 1150.734,421.238 1124.023,428.18 1117.301,454.957 1110.363,428.238  1083.586,421.52 1110.305,414.574 1117.02,387.797  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "947.5,420.414 964.543,352.5 982.16,420.266 1050.074,437.309 982.305,454.918  965.273,522.836 947.644,455.074 879.73,438.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1042.73,317.012 1049.441,290.234 1056.391,316.953 1083.168,323.672 1056.457,330.617  1049.727,357.395 1042.789,330.676 1016.012,323.953  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1029.867,512.769 1036.582,485.992 1043.527,512.711 1070.313,519.43 1043.598,526.379  1036.871,553.148 1029.926,526.43 1003.148,519.719  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C5CA"
    },
    d: "M1186.402,1736.188c0,11.16,66.887,20.195,149.41,20.195c82.512,0,149.418-9.035,149.418-20.195 c0-11.145-66.906-20.188-149.418-20.188C1253.289,1716,1186.402,1725.043,1186.402,1736.188z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C3C5CA"
    },
    cx: 1577.438,
    cy: 1670.152,
    rx: 149.418,
    ry: 49.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E35163"
    },
    points: "1503.113,1586.652 1645.484,1586.652 1632.113,1576.918 1516.488,1576.918  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1503.113,
    y: 1586.652,
    style: {
      fill: "#C94757"
    },
    width: 142.371,
    height: 11.461
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792027"
    },
    d: "M1561.836,1083.285c0,6.875,5.586,12.453,12.461,12.453c6.887,0,12.465-5.578,12.465-12.453 c0-6.887-5.578-12.473-12.465-12.473C1567.422,1070.813,1561.836,1076.398,1561.836,1083.285z M1566.477,1083.285 c0-4.328,3.496-7.836,7.82-7.836s7.828,3.508,7.828,7.836c0,4.316-3.504,7.816-7.828,7.816S1566.477,1087.602,1566.477,1083.285 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1564.273,
    y: 1091.402,
    style: {
      fill: "#C1C1C4"
    },
    width: 20.047,
    height: 468.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1564.273,
    y: 1091.402,
    style: {
      fill: "#F9F9F9"
    },
    width: 5.895,
    height: 468.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1578.164,
    y: 1091.402,
    style: {
      fill: "#979597"
    },
    width: 6.156,
    height: 468.336
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B22E3C"
    },
    d: "M1555.328,1575.898h37.945c4.227,0,7.648,3.426,7.648,7.648h-53.242 C1547.68,1579.324,1551.105,1575.898,1555.328,1575.898z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1558.129,
    y: 1558.539,
    style: {
      fill: "#B22E3C"
    },
    width: 32.332,
    height: 18.379
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560.059,
    y: 1091.402,
    style: {
      fill: "#B22E3C"
    },
    width: 28.484,
    height: 8.676
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E35163"
    },
    points: "1454.242,1681.367 1500.613,1589.207 1647.98,1589.207 1694.352,1681.367  1638.09,1625.809 1511.07,1625.809  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B22E3C"
    },
    points: "1508.844,1625.238 1639.75,1625.238 1647.98,1589.207 1500.613,1589.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C94757"
    },
    points: "1454.242,1681.367 1694.352,1681.367 1639.75,1625.238 1508.844,1625.238  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1194.09,374.398c40.5-16.371,68.156,68.953,68.156,68.953S1157.086,393.152,1194.09,374.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#223B56"
    },
    d: "M1210.461,388.027c21.344-8.629,51.785,55.324,51.785,55.324S1190.953,397.902,1210.461,388.027z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1345.074,374.398c-40.5-16.371-68.156,68.953-68.156,68.953S1382.078,393.152,1345.074,374.398z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#223B56"
    },
    d: "M1328.711,388.027c-21.352-8.629-51.793,55.324-51.793,55.324S1348.219,397.902,1328.711,388.027 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#223B56"
    },
    d: "M1251.141,440.277c0,11.715,9.5,21.223,21.227,21.223c11.723,0,21.223-9.508,21.223-21.223 c0-11.727-9.5-21.23-21.223-21.23C1260.641,419.047,1251.141,428.551,1251.141,440.277z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1383.438,589.797c-2.566,0.66,35.535-214.074-117.316-145.328 c80.633,41.758,114.75,145.988,114.75,145.988"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1163.469,589.797c2.57,0.66-43.582-214.074,109.266-145.328 c-80.633,41.758-106.695,145.988-106.695,145.988"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1376.766,589.797c0,0-18.23,118.934,39.941,133.297c-9.625,11.684-79.344,43.836-144.34,6.211 L1376.766,589.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1178.223,589.797c0,0,18.23,118.934-39.941,133.297c9.629,11.684,79.344,43.836,144.344,6.211 L1178.223,589.797z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "1370.902,1711.746 1438.203,1726.035 1438.203,1742.125 1337.461,1742.125  1337.461,1711.746  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A828F"
    },
    d: "M1407.531,1244.195l-17.879,218.852l-18.75,246.367c0,0-14.977,20.25-33.734,0l-21.449-146.508 l8.047-99.859l-46.672-218.852H1407.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M1342.309,1246.523l24.34,217.961l-15.027,255.613c-4.926-0.609-14.453-8.352-14.453-8.352 l-21.449-146.512l8.047-99.855l-46.672-218.855H1342.309z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "1240.473,1711.746 1263.875,1711.746 1280.848,1726.035 1280.848,1742.125  1222.758,1742.125 1222.758,1726.035  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A828F"
    },
    d: "M1202.797,1246.523l6.25,218.41l30.375,246.813c0,0,15.488,12.566,23.547-1.047l21.445-146.512 l-8.047-99.859l39.313-217.805H1202.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M1243.027,1721.797c17.27,0,31.27,2.25,31.27,5.027h-44.988 C1229.309,1724.047,1225.758,1721.797,1243.027,1721.797z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D68552",
      strokeWidth: 42.8818,
      strokeMiterlimit: 10
    },
    d: "M1371.422,801.699 c-0.441,0.894,54.555,57.523,68.547,228.805l7.746,178.273"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1462.004,922.894c-3.57-141.152-112.789-184.484-112.789-184.484l-22.113,102.297 c49.172,16.086,58.965,82.188,58.965,82.188S1457.535,922.894,1462.004,922.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1142.191,801.699c0,0,89.832,127.531,44.012,317.254 c62.16,51.156,221.328-132.098,221.328-244.594s-59.27-128.645-87.262-138.172h-145.879 C1151.75,744.106,1142.191,768.676,1142.191,801.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M1335.293,736.188c38.41,20.445,59.266,69.086,59.266,114.344h-28.891 c-3.703-64.316-8.469-97.672-53.145-114.344H1335.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M1197.152,736.188c38.414,20.445,59.27,69.086,59.27,114.344l-13.02,17.324 c-20.016-70.133-24.344-114.996-69.012-131.668H1197.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27425F"
    },
    d: "M1174.391,1259.906c21.715,117.727,13.672,194.355,13.672,194.355 c126.684,28.754,247.047-6.066,247.047-6.066l-34.605-390.383l7.027-207.281c-26.379-31.789-132.902-25.672-165.281,0 c17.93,187.496-58.648,250.535-58.648,250.535S1152.672,1186.508,1174.391,1259.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1394.559,940.547c-4.316,0-16.867,63.664-16.867,139.695c0,76.023,14.188,137.672,18.504,137.672 c4.313,0-2.883-61.648-2.883-137.672C1393.313,1004.211,1398.867,940.547,1394.559,940.547z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27425F"
    },
    d: "M1348.262,736.188c38.422,20.445,59.27,69.086,59.27,114.344h-28.895 c-4.465-72.359-24.414-97.672-69.086-114.344H1348.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1336.055,736.188c-4.316-0.027,49.691,30.519,49.449,82.184l8.609,95.887 c9.094,0.039,7.789,7.699,8.258-91.457C1402.609,771.129,1340.379,736.207,1336.055,736.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27425F"
    },
    d: "M1213.105,736.188c53.859,16.672,59.262,69.086,59.262,114.344h-30.117 c1.793-67.297-18.621-94.301-67.859-114.344H1213.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1200.266,736.188c-4.32-0.027,49.691,30.519,49.438,82.184l8.621,66.352 c9.09,0.043,8.246-19.898,8.246-61.922C1266.57,771.129,1204.582,736.207,1200.266,736.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M1262.199,931.398c0,41.516,27.602,75.18,61.648,75.18c34.051,0,61.656-33.664,61.656-75.18 c0-41.516-27.605-32.035-61.656-32.035C1289.801,899.363,1262.199,889.883,1262.199,931.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M1262.219,932.133c0-0.254-0.02-0.492-0.02-0.734c0-41.516,27.602-32.035,61.648-32.035 c34.051,0,61.656-9.48,61.656,32.035c0,0.242-0.031,0.481-0.035,0.734H1262.219z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D68552",
      strokeWidth: 42.8818,
      strokeMiterlimit: 10
    },
    d: "M1172.609,814.574 c0.199,0.977-22.613,78.563,93.512,205.246l195.109-74.191"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M1452.621,889.742c0,0-38.305,22.66-20.391,44.633c17.918,21.969,25.301-11.856,25.301-11.856 L1452.621,889.742z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B89021"
    },
    d: "M1443.617,924.566c-1.379-2.117-11.641-4.813-11.641-4.813s4.727-18.211,20.645-30.012 C1445.082,901.547,1444.797,919.211,1443.617,924.566z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4D9A6"
    },
    points: "1046.168,510.949 913.082,733.449 822.434,709.168 865.719,636.805 876.32,636.063  871.543,627.063 927.023,534.305 927.027,534.301 941.023,527.879 933.301,523.801 981.91,442.551  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "916.922,727.008 826.273,702.746 828.863,698.414 919.516,722.684  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "923.371,716.223 832.723,691.961 835.316,687.625 925.977,711.891  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "929.828,705.445 839.176,681.172 841.762,676.852 932.426,701.113  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "936.277,694.66 845.625,670.387 848.223,666.059 938.875,690.324  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "942.734,683.871 852.086,659.594 854.664,655.273 945.328,679.547  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "949.184,673.086 858.535,648.813 861.121,644.477 951.773,668.758  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "955.637,662.309 864.984,638.035 865.719,636.805 876.32,636.063 958.223,657.973  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "962.086,651.516 871.426,627.246 874.023,622.914 964.672,647.191  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "1041.52,518.731 977.258,450.324 974.668,454.66 1038.93,523.051  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "1035.07,529.504 970.809,461.117 968.215,465.449 1032.477,533.836  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "1028.621,540.297 964.355,471.902 961.754,476.234 1026.027,544.629  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "1022.168,551.078 957.906,482.684 955.313,487.012 1019.582,555.406  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "1015.719,561.859 951.457,493.473 948.859,497.805 1013.125,566.195  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "1009.262,572.648 945,504.254 942.406,508.574 1006.672,576.981  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "1002.809,583.43 938.543,515.035 936.164,519.035 1000.219,587.766  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "989.809,605.168 924.992,537.719 922.598,541.715 987.227,609.496  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "986.652,610.449 919.43,547 917.043,550.992 984.059,614.777  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "967.16,643.039 877.063,617.828 879.453,613.836 969.746,638.707  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "972.238,634.547 884.531,605.336 886.93,601.336 974.828,630.211  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "975.844,628.527 893.359,590.582 895.754,586.59 978.434,624.188  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "983.785,615.231 911.348,560.508 908.961,564.508 981.199,619.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "978.656,623.82 900.973,577.852 903.363,573.867 981.25,619.492  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3AD84"
    },
    points: "996.363,594.215 936.137,530.121 931.48,532.254 993.769,598.547  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3AD84"
    },
    d: "M956.23,631.188c81.68-141.277,25.68-188.637,25.68-188.637l64.258,68.398l-133.086,222.5 l-34.457-9.227C909.078,708.648,930.93,673.488,956.23,631.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792027"
    },
    d: "M1735.43,1056.566c-7.203-4.313-16.543-1.969-20.852,5.242s-1.961,16.539,5.246,20.852 c7.207,4.309,16.531,1.957,20.852-5.242C1744.977,1070.211,1742.641,1060.871,1735.43,1056.566z M1732.523,1061.418 c4.531,2.707,6.004,8.574,3.297,13.098c-2.711,4.523-8.578,6-13.098,3.297c-4.527-2.703-6.004-8.57-3.289-13.102 C1722.145,1060.18,1728.004,1058.715,1732.523,1061.418z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1361.213,
    y: 454.948,
    transform: "matrix(0.5133 -0.8582 0.8582 0.5133 -67.7149 1596.0935)",
    style: {
      fill: "#C1C1C4"
    },
    width: 24.457,
    height: 805.607
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1374.279,
    y: 447.539,
    transform: "matrix(0.5133 -0.8582 0.8582 0.5133 -59.156 1596.3733)",
    style: {
      fill: "#F9F9F9"
    },
    width: 7.188,
    height: 805.605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1365.336,
    y: 462.221,
    transform: "matrix(0.5133 -0.8582 0.8582 0.5133 -76.0654 1595.9125)",
    style: {
      fill: "#979597"
    },
    width: 7.509,
    height: 805.606
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C94757"
    },
    points: "903.758,731.18 918.203,739.824 954.063,712.656 1047.242,556.887 1054.207,512.449  1039.766,503.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B22E3C"
    },
    points: "903.758,731.18 911.621,735.875 1047.629,508.508 1039.766,503.801  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E35163"
    },
    d: "M1043.684,559.231c-2.418-1.449-18.242,9.039-54.273,69.266 c-36.031,60.242-35.797,79.418-33.379,80.856c2.422,1.465,7-12.16,43.035-72.402 C1035.098,576.715,1046.109,560.676,1043.684,559.231z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E35163"
    },
    points: "1009.293,593.07 968,662.106 990.188,675.371 1031.48,606.348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C94757"
    },
    points: "1009.293,593.07 968,662.106 980.008,669.281 1021.297,600.254  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B22E3C"
    },
    d: "M1022.715,621.004l-23.758,39.723c-2.648,4.422-8.375,5.859-12.797,3.215l33.34-55.742 C1023.922,610.844,1025.363,616.574,1022.715,621.004z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000.197,
    y: 635.708,
    transform: "matrix(0.5133 -0.8582 0.8582 0.5133 -58.262 1189.8628)",
    style: {
      fill: "#B22E3C"
    },
    width: 39.459,
    height: 21.182
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1697.204,
    y: 1056.51,
    transform: "matrix(0.5135 -0.8581 0.8581 0.5135 -76.948 1987.8939)",
    style: {
      fill: "#B22E3C"
    },
    width: 34.75,
    height: 10.59
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAC52F"
    },
    points: "1410.305,1005.238 1478.301,968.016 1443.535,923.25 1364.953,946.852  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M1443.535,923.25c0,0-8.805-23.25,14.41-40.578c23.199-17.316,62.699,34.586,62.09,47.512 c-0.605,12.91-8.922,33.414-41.734,37.832C1445.492,972.441,1443.535,923.25,1443.535,923.25z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1179.234,962.894c-83.773-113.66-26.563-208.738-26.563-208.738l75.527,57.84 c-28.965,42.871,10.996,104.328,10.996,104.328S1182.758,960.16,1179.234,962.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M1230.234,738.41c20.078,16.41,12.242,24.492,59.25,24.492c35.156,0,38.785-8.082,18.715-24.492 H1230.234z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M1344.508,607.988c0,14.391,9.723,26.063,21.723,26.063c11.992,0,21.719-11.672,21.719-26.063 c0-14.395-9.727-26.059-21.719-26.059C1354.23,581.93,1344.508,593.594,1344.508,607.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M1152.672,607.988c0,14.391,9.723,26.063,21.719,26.063s21.715-11.672,21.715-26.063 c0-14.395-9.719-26.059-21.715-26.059S1152.672,593.594,1152.672,607.988z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M1251.762,749.668l46.301-3.035h0.051c-0.117-3.254-0.074-30.781,0.02-55.023l-46.445-0.184 C1251.461,746.004,1251.668,748.566,1251.762,749.668z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M1258.785,733.504c0,0,41.539,10.269,39.348-41.895l-46.445-0.184 C1251.688,691.426,1249.398,733.504,1258.785,733.504z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M1164.492,555.09c0,70.352,48.297,165.461,107.875,165.461s107.879-95.109,107.879-165.461 c0-70.348-48.301-89.305-107.879-89.305S1164.492,484.742,1164.492,555.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1195.805,538.82c-8.832,31.644-25.316,46.598-11.844,101.879 c-0.199,2.121-18.043-41.129-22.801-101.879H1195.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1360.754,640.773c0.367,4.023,112.711-215.117-177.242-199.726 c17.082,14.293-9.121,61.492-27.801,70.145c-13.52,31.07,42.582,90.984,116.656-4.281c0,0,2.461,43.461,86.168,62.898 C1365.602,586.234,1361.059,611.766,1360.754,640.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1301.809,672.496c0,12.703-13.184,22.992-29.441,22.992c-16.262,0-29.445-10.289-29.445-22.992 H1301.809z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DADE"
    },
    points: "1257.707,621.309 1254.504,607.988 1253.293,622.684 1242.922,659.484 1276.918,661.711  1249.051,655.957  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1257.707,578.156l-19.992-1.848c0,0-12.078,6.832-33.848,6.832 C1213.762,587.516,1257.707,578.156,1257.707,578.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1282.625,578.156l20-1.848c0,0,12.078,6.832,33.844,6.832 C1326.57,587.516,1282.625,578.156,1282.625,578.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1232.023,609.625c0,9.09,2.543,16.465,5.691,16.465c3.141,0,5.688-7.375,5.688-16.465 c0-9.094-2.547-16.449-5.688-16.449C1234.566,593.176,1232.023,600.531,1232.023,609.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1301.148,609.625c0,9.09,2.551,16.465,5.695,16.465c3.137,0,5.68-7.375,5.68-16.465 c0-9.094-2.543-16.449-5.68-16.449C1303.699,593.176,1301.148,600.531,1301.148,609.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1236.832,593.379v9.652c0,0-7.344-0.324-8.633-7.699 C1230.129,598.223,1236.832,593.379,1236.832,593.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M1306.129,593.379v9.652c0,0-7.355-0.324-8.641-7.699 C1299.418,598.223,1306.129,593.379,1306.129,593.379z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M1406.172,1247.613c0,0-5.375-39.387,22.824-42.215c28.199-2.848,1.395,20.363,1.395,20.363l0,0 c0,0-9.406,32.684-17.527,33.758C1409.473,1259.973,1406.172,1247.613,1406.172,1247.613z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAC52F"
    },
    points: "1483.426,1138.973 1485.348,1214.234 1429.117,1221.242 1410.063,1148.117  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M1429.117,1221.242c0,0-5.809,31.117-1.672,59.785c4.137,28.656,48.684,11.086,57.395,1.527 c8.719-9.543,20.563-41.973,0.508-68.32C1465.313,1187.883,1429.117,1221.242,1429.117,1221.242z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C5CA"
    },
    d: "M945.355,1726.434c0,6.32,53.68,11.457,119.91,11.457c66.223,0,119.906-5.137,119.906-11.457 c0-6.324-53.684-11.453-119.906-11.453C999.035,1714.98,945.355,1720.109,945.355,1726.434z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E96F4C"
    },
    d: "M990.57,1571.27v-30.898l15.356-21.895l30.461,5.73c0,0,26.535,5.836,26.641,30.379 c0,9.582-3.723,21.195-9.785,30.715l6.652,128.758c0,8.762-7.102,15.852-15.852,15.852h-34.496 c-8.758,0-15.844-7.09-15.844-15.852l6.649-128.758C993.945,1584.219,990.57,1577.285,990.57,1571.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M994.359,1569.281c4.121-45.023,63.746-3.926,53.527,12.734l5.316,128.719 c0,6.98-5.66,12.641-12.648,12.641h-27.527c-6.984,0-12.637-5.66-12.637-12.641l5.305-128.719 C999.512,1582.383,994.359,1576.922,994.359,1569.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M1055.406,1570.18c-4.445,5.621-9.316-11.801-22.996-20.012 c-13.676-8.223-34.23-8.953-29.777-14.57c4.441-5.613,32.344-11.301,46.031-3.09 C1062.344,1540.727,1059.844,1564.563,1055.406,1570.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M1027.281,1530.742c-0.883,1.352,9.32,1.766,17.598,7.141 c8.27,5.367,11.488,13.664,12.363,12.316c0.883-1.348-1.793-10.184-10.07-15.559 C1038.895,1529.273,1028.152,1529.395,1027.281,1530.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M1016.625,1553.117c-1.824,1.168,10.926,8.027,18.668,19.984 c7.738,11.965,7.523,24.508,9.34,23.332c1.813-1.176,2.996-14.066-4.734-26.031 C1032.16,1558.445,1018.434,1551.938,1016.625,1553.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M1026.926,1537.125c-0.656,2.199,0.598,4.504,2.793,5.156s4.504-0.605,5.156-2.797 c0.652-2.203-0.609-4.508-2.801-5.156C1029.875,1533.676,1027.57,1534.93,1026.926,1537.125z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C08E"
    },
    points: "1004.023,1698.566 1049.57,1698.566 1046.375,1619.066 1007.227,1619.066  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD916C"
    },
    d: "M1012.789,1661.402c0,7.742,6.269,14.012,14.004,14.012l0,0 c7.742,0,14.008-6.27,14.008-14.012v-22.684c0-7.738-6.266-14.004-14.008-14.004l0,0c-7.734,0-14.004,6.266-14.004,14.004 V1661.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#957253"
    },
    d: "M1017.199,1660.57c0,5.297,4.297,9.582,9.594,9.582l0,0c5.301,0,9.594-4.285,9.594-9.582 v-21.004c0-5.301-4.293-9.598-9.594-9.598l0,0c-5.297,0-9.594,4.297-9.594,9.598V1660.57z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 1013.496,
    y: 1677.227,
    style: {
      fill: "#957253"
    },
    width: 26.602,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1013.496,
    y: 1683.98,
    style: {
      fill: "#957253"
    },
    width: 26.602,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1013.496,
    y: 1690.727,
    style: {
      fill: "#957253"
    },
    width: 26.602,
    height: 3.684
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M986.926,1532.195c3.191,2.496,7.797,1.922,10.289-1.277l3.172-4.063 c2.48-3.195,1.914-7.813-1.281-10.289l-6.992-5.445c-3.203-2.492-7.809-1.922-10.297,1.273l-3.164,4.063 c-2.492,3.203-1.922,7.813,1.281,10.301L986.926,1532.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M996.809,1514.773l2.297,1.793c3.195,2.477,3.762,7.094,1.281,10.289l-3.172,4.063 c-2.492,3.199-7.098,3.773-10.289,1.277l-1.731-1.336L996.809,1514.773z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M990.363,1538.324c0.848,0.664,2.063,0.508,2.719-0.34l13.141-16.871 c0.656-0.844,0.508-2.063-0.336-2.715l-5.121-3.98c-0.84-0.656-2.063-0.512-2.715,0.336l-13.141,16.871 c-0.652,0.844-0.5,2.066,0.344,2.723L990.363,1538.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M984.684,1532.031l6.289,4.898c0.746,0.582,1.824,0.449,2.398-0.289l11.609-14.91 c0.578-0.746,0.449-1.82-0.301-2.406l-6.293-4.898c0.688-0.535,1.668-0.574,2.379-0.008l5.121,3.98 c0.844,0.652,0.992,1.871,0.336,2.715l-13.141,16.871c-0.656,0.848-1.871,1.004-2.719,0.34l-5.109-3.977 C984.531,1533.789,984.324,1532.828,984.684,1532.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M997.375,1517.566c0.199-0.254,0.555-0.309,0.805-0.105l6.539,5.09l-0.715,0.906l-6.531-5.082 C997.219,1518.184,997.176,1517.813,997.375,1517.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M995.441,1520.043c0.199-0.25,0.559-0.301,0.816-0.105l6.531,5.09l-0.707,0.914l-6.539-5.094 C995.293,1520.66,995.246,1520.297,995.441,1520.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M993.512,1522.523c0.199-0.258,0.555-0.297,0.809-0.102l6.543,5.086l-0.711,0.91l-6.543-5.086 C993.359,1523.133,993.316,1522.773,993.512,1522.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M991.582,1525c0.195-0.254,0.555-0.293,0.805-0.102l6.539,5.094l-0.707,0.906l-6.539-5.086 C991.43,1525.617,991.383,1525.254,991.582,1525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M989.648,1527.484c0.199-0.258,0.559-0.297,0.809-0.105l6.539,5.09l-0.707,0.906l-6.539-5.09 C989.496,1528.094,989.449,1527.734,989.648,1527.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M987.719,1529.965c0.199-0.262,0.555-0.297,0.805-0.102l6.543,5.086l-0.707,0.91l-6.543-5.09 C987.566,1530.57,987.519,1530.207,987.719,1529.965z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "1002.762,1523.797 1003.207,1523.223 996.258,1517.816 995.82,1518.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "1000.828,1526.281 1001.277,1525.707 994.328,1520.309 993.883,1520.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "998.894,1528.75 999.344,1528.188 992.394,1522.781 991.957,1523.348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "996.969,1531.234 997.414,1530.664 990.465,1525.262 990.027,1525.824  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "995.043,1533.719 995.48,1533.145 988.531,1527.742 988.094,1528.309  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "993.102,1536.199 993.551,1535.625 986.609,1530.219 986.164,1530.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "1004.691,1521.316 1004.59,1520.328 998.191,1515.344 997.75,1515.91  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#406F95"
    },
    d: "M979.762,1520.023c1.246,1.734,4.766,1.336,7.875-0.879c3.098-2.219,4.609-5.43,3.367-7.156 c-1.238-1.738-4.773-1.34-7.867,0.875C980.035,1515.086,978.519,1518.289,979.762,1520.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#708AAB"
    },
    d: "M980.055,1519.152c0.316,0.434,1.695-2.699,4.391-4.629c2.691-1.934,5.68-1.914,5.367-2.352 c-0.316-0.438-3.406-0.691-6.094,1.238C981.019,1515.332,979.738,1518.711,980.055,1519.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#708AAB"
    },
    d: "M982.008,1520.043c0.609,0.469,1.477,0.363,1.953-0.242c0.473-0.609,0.363-1.484-0.242-1.953 c-0.605-0.473-1.48-0.367-1.957,0.242C981.293,1518.699,981.398,1519.566,982.008,1520.043z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1070.332,
    y: 1501.184,
    style: {
      fill: "#E96F4C"
    },
    width: 13.195,
    height: 12.371
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070.547,
    y: 1501.184,
    style: {
      fill: "#B65738"
    },
    width: 5.137,
    height: 12.371
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.742,
    y: 1501.184,
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    width: 2.563,
    height: 12.371
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1061.523,1524.957c-0.125-0.691-0.207-1.414-0.207-2.156v-2.191 c0-6.383,5.18-11.563,11.555-11.563h8.121c6.379,0,11.559,5.18,11.559,11.563v2.191c0,0.742-0.078,1.465-0.203,2.156H1061.523 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1061.523,1524.957c-0.125-0.691-0.207-1.414-0.207-2.156v-3.391l31.234-1.102v4.492 c0,0.742-0.078,1.465-0.203,2.156H1061.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#406F95"
    },
    d: "M1068.309,1511.234c-0.945,1.492,2.945,3.336,8.711,4.129 c5.762,0.793,11.215,0.219,12.168-1.266c0.953-1.488-2.945-3.34-8.711-4.125 C1074.715,1509.18,1069.266,1509.75,1068.309,1511.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#708AAB"
    },
    d: "M1069.68,1511.023c-0.242,0.367,4.996-0.234,10.004,0.438c4.992,0.691,7.875,2.414,8.121,2.031 c0.238-0.375-2.445-2.258-7.445-2.938C1075.352,1509.863,1069.926,1510.641,1069.68,1511.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#708AAB"
    },
    d: "M1071.355,1512.543c0,0.555,0.578,1.012,1.289,1.012c0.73,0,1.305-0.457,1.305-1.012 c0-0.566-0.574-1.02-1.305-1.02C1071.934,1511.523,1071.355,1511.977,1071.355,1512.543z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1057.188,1530.219c0,1.258,1.016,2.277,2.266,2.277h34.949c1.266,0,2.281-1.02,2.281-2.277 v-7.621c0-1.262-1.016-2.281-2.281-2.281h-34.949c-1.25,0-2.266,1.02-2.266,2.281V1530.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1058.918,1520.391v9.383c0,1.105,0.898,2.012,2.012,2.012h32.012 c1.109,0,2.012-0.906,2.012-2.012v-9.383c0.992,0.25,1.73,1.137,1.73,2.207v7.621c0,1.258-1.016,2.277-2.281,2.277h-34.949 c-1.25,0-2.266-1.02-2.266-2.277v-7.621C1057.188,1521.527,1057.926,1520.641,1058.918,1520.391z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1091.309,1521.715c0.379,0,0.676,0.305,0.676,0.68v9.742h-1.352v-9.742 C1090.633,1522.02,1090.934,1521.715,1091.309,1521.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1087.605,1521.715c0.379,0,0.688,0.305,0.688,0.68v9.742h-1.363v-9.742 C1086.93,1522.02,1087.238,1521.715,1087.605,1521.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1083.914,1521.715c0.379,0,0.68,0.305,0.68,0.68v9.742h-1.359v-9.742 C1083.234,1522.02,1083.547,1521.715,1083.914,1521.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1080.219,1521.715c0.375,0,0.68,0.305,0.68,0.68v9.742h-1.359v-9.742 C1079.539,1522.02,1079.844,1521.715,1080.219,1521.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1076.52,1521.715c0.379,0,0.68,0.305,0.68,0.68v9.742h-1.359v-9.742 C1075.84,1522.02,1076.141,1521.715,1076.52,1521.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1072.824,1521.715c0.371,0,0.676,0.305,0.676,0.68v9.742h-1.355v-9.742 C1072.145,1522.02,1072.449,1521.715,1072.824,1521.715z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1089.418,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.844,
    height: 10.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1085.715,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.844,
    height: 10.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1082.027,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.836,
    height: 10.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.328,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.844,
    height: 10.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074.633,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.836,
    height: 10.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070.934,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.848,
    height: 10.355
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "1093.109,1531.227 1093.953,1530.414 1093.953,1520.871 1093.109,1520.871  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1069.121,1521.715c0.379,0,0.688,0.305,0.688,0.68v9.742h-1.359v-9.742 C1068.449,1522.02,1068.754,1521.715,1069.121,1521.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1065.43,1521.715c0.375,0,0.68,0.305,0.68,0.68v9.742h-1.359v-9.742 C1064.75,1522.02,1065.051,1521.715,1065.43,1521.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1061.73,1521.715c0.383,0,0.68,0.305,0.68,0.68v9.742h-1.359v-9.742 C1061.051,1522.02,1061.359,1521.715,1061.73,1521.715z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1067.23,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.844,
    height: 10.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.539,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.84,
    height: 10.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1059.84,
    y: 1520.871,
    style: {
      fill: "#406F95"
    },
    width: 0.848,
    height: 10.355
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B65738"
    },
    d: "M1071.156,1500.117c0,0.59,0.477,1.066,1.066,1.066h9.426c0.59,0,1.066-0.477,1.066-1.066l0,0 c0-0.578-0.477-1.055-1.066-1.055h-9.426C1071.633,1499.063,1071.156,1499.539,1071.156,1500.117L1071.156,1500.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7CC5D0"
    },
    d: "M1040.707,1554.586c0-20.004,16.215-23.48,36.23-23.48c20.008,0,36.227,3.477,36.227,23.48 c0,9.582-3.727,21.195-9.793,30.715l6.66,128.758c0,8.762-7.094,15.852-15.852,15.852h-34.496 c-8.75,0-15.844-7.09-15.844-15.852l6.645-128.758C1044.426,1575.781,1040.707,1564.168,1040.707,1554.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7D7E0"
    },
    d: "M1048.031,1557.516c1.059-25,60.219,7.84,50,24.5l5.313,128.719 c0,6.98-5.664,12.641-12.645,12.641h-27.531c-6.977,0-12.641-5.66-12.641-12.641l5.309-128.719 C1050.996,1574.422,1048.031,1565.156,1048.031,1557.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7D7E0"
    },
    d: "M1105.984,1570.316c-3.879,4.918-8.133-10.313-20.098-17.504 c-11.961-7.184-29.926-7.824-26.043-12.73c3.895-4.906,28.281-9.875,40.242-2.691 C1112.055,1544.57,1109.867,1565.41,1105.984,1570.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M1081.395,1535.84c-0.766,1.18,8.156,1.551,15.391,6.242 c7.23,4.695,10.039,11.945,10.809,10.762c0.766-1.168-1.57-8.902-8.797-13.594 C1091.555,1534.555,1082.164,1534.66,1081.395,1535.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M1066.758,1553.117c-1.816,1.168,10.938,8.027,18.68,19.984 c7.727,11.965,7.523,24.508,9.336,23.332s2.988-14.066-4.738-26.031C1082.301,1558.445,1068.57,1551.938,1066.758,1553.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M1081.086,1541.418c-0.57,1.926,0.527,3.938,2.441,4.496c1.926,0.582,3.938-0.52,4.512-2.434 c0.566-1.922-0.527-3.934-2.445-4.512C1083.672,1538.402,1081.652,1539.504,1081.086,1541.418z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1051.699,1700.535 1102.168,1700.535 1099.16,1617.098 1055.785,1617.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E96F4C"
    },
    points: "1054.16,1698.566 1099.703,1698.566 1096.508,1619.066 1057.363,1619.066  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C05C3C"
    },
    d: "M1062.922,1661.402c0,7.742,6.273,14.012,14.016,14.012l0,0 c7.73,0,14.004-6.27,14.004-14.012v-22.684c0-7.738-6.273-14.004-14.004-14.004l0,0c-7.742,0-14.016,6.266-14.016,14.004 V1661.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#843F25"
    },
    d: "M1067.344,1660.57c0,5.297,4.297,9.582,9.594,9.582l0,0c5.301,0,9.59-4.285,9.59-9.582 v-21.004c0-5.301-4.289-9.598-9.59-9.598l0,0c-5.297,0-9.594,4.297-9.594,9.598V1660.57z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 1063.629,
    y: 1677.227,
    style: {
      fill: "#843F25"
    },
    width: 26.602,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.629,
    y: 1683.98,
    style: {
      fill: "#843F25"
    },
    width: 26.602,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.629,
    y: 1690.727,
    style: {
      fill: "#843F25"
    },
    width: 26.602,
    height: 3.684
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1099.383,1578.344v-18.543l30.754,15.867c-10.996,19.766-7.168,7.508-13.48,5.348 l-10.008-3.402c0.047,20.105-23.402,24.047-23.402,17.82C1100.039,1592.039,1099.383,1578.344,1099.383,1578.344z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1109,1577.707l10.012,3.398c2.652,0.906,3.516,3.602,4.445,4.949 c-2.91,2.766-2.438-3.551-6.801-5.039l-10.008-3.402L1109,1577.707z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1099.383,1578.344v-18.543l2.348,1.219v17.406c0,0,0.668,13.695-16.129,17.094 c0,1.41,1.211,2.285,3.063,2.586c-3.141,0.219-5.418-0.734-5.418-2.672 C1100.039,1592.039,1099.383,1578.344,1099.383,1578.344z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1075.094,
    y: 1552.773,
    style: {
      fill: "#2D4A6A"
    },
    width: 11.074,
    height: 11.816
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.094,
    y: 1559.801,
    style: {
      fill: "#182F46"
    },
    width: 11.074,
    height: 4.598
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.094,
    y: 1554.129,
    style: {
      fill: "#406F95"
    },
    width: 11.074,
    height: 2.301
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E96F4C"
    },
    points: "1144.707,1551.961 1166.051,1575.203 1158.586,1589.754 1130.137,1589.754  1125.402,1581.023 1094.199,1565.188 1084.762,1565.188 1084.762,1551.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    points: "1159.367,1580.219 1138.02,1556.977 1084.762,1556.977 1084.762,1551.961  1144.707,1551.961 1166.051,1575.203 1158.586,1589.754  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M1090.41,1554.004c0,0.813,10.977,1.469,24.512,1.469s24.504-0.656,24.504-1.469 c0-0.809-10.969-1.477-24.504-1.477S1090.41,1553.195,1090.41,1554.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M1147.891,1558.906c2.648,2.879,4.309,5.645,3.719,6.195 c-0.586,0.539-3.211-1.355-5.855-4.23c-2.652-2.871-4.316-5.645-3.719-6.195 C1142.625,1554.133,1145.246,1556.023,1147.891,1558.906z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7CC5D0"
    },
    d: "M1097.395,1664.625h-0.012c0-0.027,27.977-18.91,31.191-65.297h32.84l22.918,130.582h-68.434 c-19.48,0-35.27-15.793-35.27-35.27C1080.629,1681.949,1087.336,1670.836,1097.395,1664.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7D7E0"
    },
    d: "M1102.543,1664.625h-0.008c0-0.027,28.133-17.012,31.02-58.727h24.355l20.594,117.438h-59.313 c-17.52,0-31.727-14.195-31.727-31.723C1087.465,1680.203,1093.496,1670.211,1102.543,1664.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M1136.477,1609.516c-2.113-1.02-1.316,13.418-8.555,28.539 c-7.238,15.141-19.391,22.918-17.277,23.941c2.125,1.008,15.145-6.055,22.383-21.18 C1140.273,1625.688,1138.602,1610.523,1136.477,1609.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M1140.324,1611.031c-0.563,1.914,0.527,3.93,2.449,4.5c1.918,0.57,3.934-0.531,4.504-2.445 c0.57-1.918-0.523-3.941-2.445-4.508C1142.918,1608.012,1140.895,1609.105,1140.324,1611.031z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E96F4C"
    },
    d: "M1112.027,1673c2.008-0.973,10.504-5.426,16.707-14.359h24.949l9.664,55.094h-39.676 c-12.145,0-22.031-9.887-22.031-22.027C1101.641,1684.043,1105.531,1677.059,1112.027,1673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1099.383,1691.707c0,13.418,10.871,24.293,24.289,24.293h42.379l-10.465-59.625h-28.059 c-6.574,10.145-16.609,14.637-16.609,14.645l0,0h0.004C1103.996,1675.297,1099.383,1682.957,1099.383,1691.707z  M1101.641,1691.707c0-7.664,3.891-14.648,10.387-18.707c2.008-0.973,10.504-5.426,16.707-14.359h24.949l9.664,55.094 h-39.676C1111.527,1713.734,1101.641,1703.848,1101.641,1691.707z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C05C3C"
    },
    d: "M1128.945,1686.414c0,5.172,4.184,9.355,9.355,9.355l0,0c5.164,0,9.348-4.184,9.348-9.355 v-15.145c0-5.164-4.184-9.352-9.348-9.352l0,0c-5.172,0-9.355,4.188-9.355,9.352V1686.414z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#843F25"
    },
    d: "M1131.891,1685.852c0,3.535,2.875,6.41,6.41,6.41l0,0c3.535,0,6.406-2.875,6.406-6.41 v-14.023c0-3.535-2.871-6.402-6.406-6.402l0,0c-3.535,0-6.41,2.867-6.41,6.402V1685.852z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 1118.723,
    y: 1696.98,
    style: {
      fill: "#843F25"
    },
    width: 38.68,
    height: 2.457
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1118.723,
    y: 1701.488,
    style: {
      fill: "#843F25"
    },
    width: 38.68,
    height: 2.457
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1118.723,
    y: 1705.992,
    style: {
      fill: "#843F25"
    },
    width: 38.68,
    height: 2.461
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M1123.789,1597.578c0,1.258,1.016,2.281,2.273,2.281h34.949c1.258,0,2.27-1.023,2.27-2.281 v-7.625c0-1.25-1.012-2.273-2.27-2.273h-34.949c-1.258,0-2.273,1.023-2.273,2.273V1597.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1125.516,1587.758v9.379c0,1.105,0.902,2.008,2.016,2.008h32.012 c1.113,0,2.012-0.902,2.012-2.008v-9.379c0.996,0.242,1.727,1.129,1.727,2.195v7.625c0,1.258-1.012,2.281-2.27,2.281h-34.949 c-1.258,0-2.273-1.023-2.273-2.281v-7.625C1123.789,1588.887,1124.527,1588.004,1125.516,1587.758z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1157.91,1589.07c0.375,0,0.676,0.305,0.676,0.684v9.746h-1.355v-9.746 C1157.23,1589.375,1157.539,1589.07,1157.91,1589.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1154.223,1589.07c0.363,0,0.672,0.305,0.672,0.684v9.746h-1.367v-9.746 C1153.527,1589.375,1153.84,1589.07,1154.223,1589.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1150.512,1589.07c0.383,0,0.68,0.305,0.68,0.684v9.746h-1.355v-9.746 C1149.836,1589.375,1150.148,1589.07,1150.512,1589.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1146.82,1589.07c0.375,0,0.676,0.305,0.676,0.684v9.746h-1.352v-9.746 C1146.145,1589.375,1146.445,1589.07,1146.82,1589.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1143.121,1589.07c0.375,0,0.684,0.305,0.684,0.684v9.746h-1.363v-9.746 C1142.441,1589.375,1142.746,1589.07,1143.121,1589.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1139.426,1589.07c0.375,0,0.676,0.305,0.676,0.684v9.746h-1.355v-9.746 C1138.746,1589.375,1139.055,1589.07,1139.426,1589.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1156.02,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.848,
    height: 10.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.324,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.84,
    height: 10.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.625,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.852,
    height: 10.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1144.93,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.844,
    height: 10.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1141.23,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.848,
    height: 10.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1137.535,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.848,
    height: 10.351
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#406F95"
    },
    points: "1159.711,1598.582 1160.57,1597.77 1160.57,1588.23 1159.711,1588.23  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1135.738,1589.07c0.363,0,0.664,0.305,0.664,0.684v9.746h-1.348v-9.746 C1135.055,1589.375,1135.355,1589.07,1135.738,1589.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1132.027,1589.07c0.383,0,0.684,0.305,0.684,0.684v9.746h-1.359v-9.746 C1131.352,1589.375,1131.652,1589.07,1132.027,1589.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#182F46"
    },
    d: "M1128.34,1589.07c0.371,0,0.672,0.305,0.672,0.684v9.746h-1.352v-9.746 C1127.66,1589.375,1127.961,1589.07,1128.34,1589.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1133.836,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.844,
    height: 10.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130.137,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.848,
    height: 10.351
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126.445,
    y: 1588.23,
    style: {
      fill: "#406F95"
    },
    width: 0.848,
    height: 10.351
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C5CA"
    },
    d: "M959.191,1723.484c0,27.199-122.492,49.246-273.586,49.246 c-151.102,0-273.594-22.047-273.594-49.246c0-27.203,122.492-49.25,273.594-49.25 C836.699,1674.234,959.191,1696.281,959.191,1723.484z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C94757"
    },
    d: "M658.168,1717.129c0,15.328-38.777,27.742-86.606,27.742c-47.82,0-86.594-12.414-86.594-27.742 c0,0-25.637-169.523-24.836-172.82c19.355-8.344,69.754-9.492,111.43-9.492c54.238,0,101.762,0.148,112.231,12.789 C683.793,1547.605,658.168,1715.203,658.168,1717.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E35163"
    },
    d: "M473.832,1580.883l19.145,133.203c0,11.824,29.879,21.398,66.746,21.398 C559.723,1735.484,530.773,1537.688,473.832,1580.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B22E3C"
    },
    d: "M678.805,1580.238l4.988-32.633c-10.469-12.641-57.992-12.789-112.231-12.789 c-41.676,0-92.074,1.148-111.43,9.492c-0.223,0.945-1.32-6.109,1.563,14.254 C461.695,1558.563,625.023,1607.246,678.805,1580.238z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M692.594,1536.563h-11.625c1.238,11.965,1.898,32.285,1.898,38.469 c0,54.09-56.039,97.938-110.063,97.938c-54.016,0-110.066-43.848-110.066-97.938c0-6.184,0.664-26.504,1.902-38.469H453.02 c-2.188,9.223-3.395,18.832-3.395,28.723c0,68.117,55.156,123.332,123.18,123.332c68.027,0,123.18-55.215,123.18-123.332 C695.984,1555.395,694.785,1545.785,692.594,1536.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5AE2E"
    },
    d: "M455.898,1536.563c-1.004,12.84-1.523,29.875-1.523,35.609 c0,58.207,60.297,105.387,118.43,105.387s118.438-47.18,118.438-105.387c0-5.734-0.531-22.77-1.539-35.609h-8.734 c1.238,11.965,1.898,32.285,1.898,38.469c0,54.09-56.039,97.938-110.063,97.938c-54.016,0-110.066-43.848-110.066-97.938 c0-6.184,0.664-26.504,1.902-38.469H455.898z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#843F25"
    },
    d: "M628.391,1657.949c0,2.23,24.531,28.719-53.078,33.129c-68.68,0-51.371-27.41-51.371-29.637 c0-2.234,24.625-0.586,53.32-0.586C605.973,1660.855,628.391,1655.723,628.391,1657.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#693017"
    },
    d: "M526.34,1670.23c2.449-3.84,6.742-6.398,11.633-6.398c7.324,0,13.301,3.641,13.766,10.852 c0.063,0.004,0.129,0.012,0.188,0.016c0.938-6.719,6.695-9.836,13.664-9.836c7.219,0,13.145,3.488,13.746,10.555 c0.035-0.004,0.074-0.004,0.117-0.008c0.606-7.059,6.52-10.547,13.75-10.547c6.41,0,11.797,2.324,13.336,8.258 c0.18-0.023,0.34-0.051,0.512-0.074c0.445-7.211,6.43-10.863,13.754-10.863c3.703,0,7.047,1.457,9.523,3.813 c1.746-4.027-3.215-7.656-3.215-8.266c0-1.348-21.863,1.742-49.852,1.742c-27.977,0-51.984-0.992-51.984,0.352 C525.277,1660.547,520.375,1665.664,526.34,1670.23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E35163"
    },
    d: "M698.523,1540.297c0,15.332-56.863,27.758-127,27.758c-70.16,0-127.02-12.426-127.02-27.758 c0,0,0-17.832,0.895-21.133c21.91-8.344,78.953-9.48,126.125-9.48c61.363,0,115.156,0.133,127,12.781 C698.523,1522.465,698.523,1538.383,698.523,1540.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D04A5A"
    },
    d: "M698.523,1519.969c0,16.711-56.863,30.25-127,30.25c-70.16,0-127.02-13.539-127.02-30.25 c0-16.715,56.859-30.262,127.02-30.262C641.66,1489.707,698.523,1503.254,698.523,1519.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B22E3C"
    },
    d: "M684.789,1519.465c0,13.668-50.711,24.75-113.266,24.75c-62.574,0-113.285-11.082-113.285-24.75 c0-13.672,50.711-24.75,113.285-24.75C634.078,1494.715,684.789,1505.793,684.789,1519.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7CC5D0"
    },
    d: "M679.519,1522.465c0,12.008-48.351,21.75-107.996,21.75c-59.656,0-108.016-9.742-108.016-21.75 c0-12.012,48.359-21.746,108.016-21.746C631.168,1500.719,679.519,1510.453,679.519,1522.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69A9B1"
    },
    d: "M609.582,1538.867c-69.855,0-126.469-11.402-126.469-25.473c0-1.297,0.484-2.574,1.414-3.82 c-13.203,3.605-21.02,8.063-21.02,12.891c0,12.008,48.359,21.75,108.016,21.75c30.43,0,57.93-2.539,77.563-6.621 C636.652,1538.418,623.379,1538.867,609.582,1538.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7D7E0"
    },
    d: "M587.688,1503.645c-13.266,0-25.695,0.707-36.453,1.945c6.492-0.375,13.344-0.582,20.434-0.582 c40.664,0,73.637,6.637,73.637,14.832c0,5.516-14.977,10.328-37.184,12.883c30.727-1.789,53.203-7.488,53.203-14.246 C661.324,1510.281,628.359,1503.645,587.688,1503.645z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M566.074,1508.82c0,2.863-2.316,5.184-5.172,5.184c-2.867,0-5.191-2.32-5.191-5.184 c0-2.855,2.324-5.176,5.191-5.176C563.758,1503.645,566.074,1505.965,566.074,1508.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M563.16,1505.348c0.637,1-0.398,2.773-2.309,3.965c-1.902,1.188-3.945,1.336-4.574,0.336 c-0.633-1.008,0.414-2.789,2.309-3.977C560.492,1504.488,562.547,1504.336,563.16,1505.348z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M581.918,1501.828c0,2.859-2.324,5.18-5.188,5.18c-2.859,0-5.18-2.32-5.18-5.18 c0-2.863,2.32-5.184,5.18-5.184C579.594,1496.645,581.918,1498.965,581.918,1501.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M579.008,1498.348c0.633,1-0.41,2.785-2.313,3.961c-1.898,1.191-3.949,1.34-4.59,0.332 c-0.621-0.996,0.414-2.777,2.32-3.961C576.328,1497.488,578.383,1497.34,579.008,1498.348z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M596.195,1525.156c0,2.855-2.32,5.172-5.18,5.172c-2.859,0-5.18-2.316-5.18-5.172 c0-2.871,2.32-5.188,5.18-5.188C593.875,1519.969,596.195,1522.285,596.195,1525.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M593.289,1521.672c0.625,1.004-0.406,2.777-2.309,3.961c-1.91,1.195-3.961,1.34-4.59,0.336 c-0.613-1.008,0.414-2.781,2.32-3.969C590.609,1520.809,592.668,1520.664,593.289,1521.672z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M632.883,1515.488c0,2.867-2.324,5.184-5.184,5.184c-2.867,0-5.188-2.316-5.188-5.184 c0-2.859,2.32-5.18,5.188-5.18C630.559,1510.309,632.883,1512.629,632.883,1515.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M629.973,1512.008c0.617,1.008-0.41,2.785-2.309,3.973c-1.914,1.191-3.961,1.336-4.59,0.332 c-0.625-1.004,0.414-2.777,2.313-3.969C627.293,1511.156,629.34,1511.012,629.973,1512.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M646.879,1503.645c0,2.859-2.324,5.176-5.188,5.176c-2.863,0-5.176-2.316-5.176-5.176 s2.313-5.184,5.176-5.184C644.555,1498.461,646.879,1500.785,646.879,1503.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M643.965,1500.168c0.633,0.996-0.402,2.777-2.308,3.965c-1.902,1.184-3.953,1.336-4.586,0.328 c-0.617-0.996,0.41-2.777,2.309-3.961C641.289,1499.309,643.348,1499.16,643.965,1500.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M619.773,1530.676c0,2.859-2.328,5.18-5.184,5.18c-2.863,0-5.183-2.32-5.183-5.18 c0-2.863,2.32-5.184,5.183-5.184C617.445,1525.492,619.773,1527.813,619.773,1530.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M616.863,1527.195c0.629,1.004-0.422,2.789-2.316,3.973c-1.898,1.184-3.945,1.328-4.578,0.324 c-0.621-0.996,0.414-2.773,2.313-3.969C614.191,1526.344,616.234,1526.191,616.863,1527.195z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M653.023,1532.867c-0.289,1.777-2.801,2.848-5.629,2.387c-2.832-0.457-4.883-2.27-4.598-4.043 c0.285-1.777,2.809-2.844,5.637-2.387C651.258,1529.281,653.32,1531.094,653.023,1532.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M650.508,1530.246c0.523,0.723-0.676,1.656-2.68,2.09c-2,0.434-4.035,0.199-4.555-0.52 c-0.523-0.73,0.676-1.668,2.676-2.098C647.945,1529.281,649.988,1529.527,650.508,1530.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M656.727,1528.996c0,1.801-2.32,3.258-5.18,3.258c-2.867,0-5.184-1.457-5.184-3.258 c0-1.789,2.316-3.258,5.184-3.258C654.406,1525.738,656.727,1527.207,656.727,1528.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M653.82,1526.813c0.625,0.629-0.414,1.75-2.313,2.492c-1.906,0.742-3.953,0.836-4.586,0.211 c-0.625-0.629,0.41-1.75,2.309-2.492C651.141,1526.27,653.191,1526.184,653.82,1526.813z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M664.004,1530.676c0,1.793-2.324,3.258-5.176,3.258c-2.867,0-5.188-1.465-5.188-3.258 s2.32-3.254,5.188-3.254C661.68,1527.422,664.004,1528.883,664.004,1530.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M661.09,1528.488c0.633,0.633-0.41,1.75-2.308,2.496c-1.898,0.742-3.957,0.84-4.57,0.203 c-0.637-0.629,0.395-1.746,2.309-2.484C658.426,1527.953,660.473,1527.859,661.09,1528.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M666.512,1525.738c0,1.801-2.324,3.258-5.188,3.258c-2.859,0-5.18-1.457-5.18-3.258 c0-1.785,2.32-3.254,5.18-3.254C664.188,1522.484,666.512,1523.953,666.512,1525.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M663.605,1523.559c0.629,0.629-0.41,1.742-2.316,2.488c-1.902,0.75-3.961,0.84-4.582,0.215 c-0.621-0.633,0.406-1.75,2.316-2.496C660.93,1523.016,662.98,1522.926,663.605,1523.559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M675.648,1525.156c0,1.789-2.32,3.25-5.184,3.25c-2.855,0-5.176-1.461-5.176-3.25 c0-1.805,2.32-3.27,5.176-3.27C673.328,1521.887,675.648,1523.352,675.648,1525.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M672.75,1522.957c0.617,0.633-0.414,1.75-2.32,2.496c-1.906,0.746-3.949,0.844-4.574,0.211 c-0.629-0.637,0.41-1.75,2.309-2.496C670.07,1522.422,672.125,1522.336,672.75,1522.957z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M643.238,1521.004c0,1.797-2.316,3.254-5.18,3.254c-2.867,0-5.176-1.457-5.176-3.254 c0-1.801,2.309-3.254,5.176-3.254C640.922,1517.75,643.238,1519.203,643.238,1521.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M640.336,1518.816c0.617,0.633-0.41,1.75-2.309,2.496c-1.906,0.738-3.969,0.836-4.59,0.207 c-0.625-0.637,0.41-1.746,2.313-2.496C637.656,1518.281,639.707,1518.184,640.336,1518.816z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M618.598,1518.184c0,1.797-2.32,3.246-5.176,3.246c-2.863,0-5.184-1.449-5.184-3.246 s2.32-3.254,5.184-3.254C616.277,1514.93,618.598,1516.387,618.598,1518.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M615.699,1515.992c0.617,0.633-0.414,1.742-2.316,2.492c-1.906,0.746-3.961,0.84-4.586,0.215 c-0.633-0.637,0.41-1.75,2.313-2.492C613.008,1515.461,615.07,1515.359,615.699,1515.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C7E6EB"
    },
    cx: 629.246,
    cy: 1485.234,
    rx: 5.184,
    ry: 5.18
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M631.527,1481.762c0.621,0.992-0.414,2.777-2.32,3.961c-1.906,1.188-3.957,1.34-4.57,0.336 c-0.633-1.012,0.395-2.789,2.309-3.977C628.848,1480.898,630.894,1480.746,631.527,1481.762z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M654.269,1480.055c0,2.859-2.32,5.18-5.184,5.18c-2.859,0-5.18-2.32-5.18-5.18 c0-2.863,2.32-5.184,5.18-5.184C651.949,1474.871,654.269,1477.191,654.269,1480.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M651.359,1476.578c0.629,1-0.414,2.773-2.316,3.965c-1.902,1.188-3.953,1.336-4.574,0.324 c-0.629-1.004,0.406-2.77,2.308-3.961C648.688,1475.715,650.73,1475.574,651.359,1476.578z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M586.891,1515.461c0,2.059-1.672,3.723-3.723,3.723c-2.063,0-3.734-1.664-3.734-3.723 c0-2.063,1.672-3.723,3.734-3.723C585.219,1511.738,586.891,1513.398,586.891,1515.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M584.797,1512.961c0.449,0.715-0.297,1.996-1.66,2.844c-1.375,0.855-2.844,0.965-3.293,0.238 c-0.457-0.719,0.297-1.984,1.66-2.844C582.879,1512.344,584.352,1512.234,584.797,1512.961z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M598.656,1494.715c0,2.855-2.324,5.176-5.184,5.176c-2.867,0-5.184-2.32-5.184-5.176 c0-2.859,2.316-5.188,5.184-5.188C596.332,1489.527,598.656,1491.855,598.656,1494.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M595.758,1491.234c0.617,1-0.422,2.773-2.32,3.969c-1.91,1.184-3.957,1.332-4.574,0.324 c-0.633-1.004,0.395-2.777,2.309-3.965C593.07,1490.375,595.121,1490.227,595.758,1491.234z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M614.59,1486.563c0,2.863-2.316,5.176-5.183,5.176c-2.859,0-5.176-2.313-5.176-5.176 s2.316-5.176,5.176-5.176C612.273,1481.387,614.59,1483.699,614.59,1486.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M611.68,1483.086c0.633,1-0.402,2.781-2.313,3.969c-1.91,1.184-3.953,1.332-4.574,0.328 c-0.633-1,0.406-2.781,2.316-3.965C609.012,1482.234,611.059,1482.078,611.68,1483.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M665.18,1510.309c0,2.863-2.32,5.18-5.191,5.18c-2.855,0-5.172-2.316-5.172-5.18 s2.316-5.184,5.172-5.184C662.859,1505.125,665.18,1507.445,665.18,1510.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M662.269,1506.832c0.625,1.004-0.406,2.785-2.32,3.965c-1.898,1.191-3.949,1.336-4.578,0.332 c-0.625-1.004,0.41-2.777,2.32-3.973C659.59,1505.973,661.641,1505.828,662.269,1506.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M670.355,1488.047c0,2.863-2.316,5.184-5.176,5.184c-2.863,0-5.191-2.32-5.191-5.184 c0-2.855,2.328-5.176,5.191-5.176C668.039,1482.871,670.355,1485.191,670.355,1488.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M667.449,1484.57c0.629,1-0.41,2.781-2.309,3.961c-1.918,1.191-3.953,1.34-4.586,0.336 c-0.625-1.004,0.414-2.777,2.309-3.969C664.769,1483.715,666.824,1483.566,667.449,1484.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M638.059,1469.688c0,2.863-2.324,5.184-5.176,5.184c-2.871,0-5.184-2.32-5.184-5.184 c0-2.859,2.313-5.18,5.184-5.18C635.734,1464.508,638.059,1466.828,638.059,1469.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M635.148,1466.207c0.633,1.004-0.406,2.789-2.313,3.973c-1.898,1.188-3.949,1.328-4.578,0.324 c-0.629-1,0.402-2.773,2.309-3.965C632.473,1465.355,634.527,1465.211,635.148,1466.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M676.828,1512.484c0,2.855-2.32,5.172-5.18,5.172c-2.863,0-5.188-2.316-5.188-5.172 c0-2.867,2.324-5.184,5.188-5.184C674.508,1507.301,676.828,1509.617,676.828,1512.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M673.918,1509c0.629,1.008-0.41,2.781-2.309,3.969c-1.914,1.18-3.961,1.336-4.586,0.332 c-0.633-1.008,0.41-2.781,2.309-3.969C671.238,1508.141,673.293,1508,673.918,1509z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E6EB"
    },
    d: "M664.004,1520.672c0,2.859-2.324,5.18-5.176,5.18c-2.867,0-5.188-2.32-5.188-5.18 s2.32-5.184,5.188-5.184C661.68,1515.488,664.004,1517.813,664.004,1520.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F2EE"
    },
    d: "M661.09,1517.191c0.633,1.004-0.41,2.781-2.308,3.973c-1.898,1.18-3.957,1.332-4.57,0.328 c-0.637-1.008,0.395-2.777,2.309-3.961C658.426,1516.332,660.473,1516.191,661.09,1517.191z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D68552",
      strokeWidth: 44.7954,
      strokeMiterlimit: 10
    },
    d: "M692.004,762.488 c0.457,0.934-61.078,99.281-75.699,278.203l-18.922,220.406"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M646.148,1267.711c0,0,5.613-41.129-23.848-44.094c-29.469-2.965-1.453,21.277-1.453,21.277l0,0 c0,0,9.82,34.141,18.309,35.258C642.695,1280.633,646.148,1267.711,646.148,1267.711z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAC52F"
    },
    points: "565.441,1154.223 563.422,1232.852 622.176,1240.176 642.078,1163.781  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M622.176,1240.176c0,0,6.063,32.496,1.742,62.438c-4.316,29.945-50.856,11.59-59.957,1.613 c-9.098-9.98-21.484-43.859-0.539-71.375C584.363,1205.32,622.176,1240.176,622.176,1240.176z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M597.383,889.098c3.723-147.449,117.828-192.719,117.828-192.719l23.082,106.859 c-51.359,16.805-61.594,85.859-61.594,85.859S602.051,889.098,597.383,889.098z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "692.555,1713.145 622.246,1728.078 622.246,1744.871 741.699,1744.871 741.699,1713.145  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M931.461,762.488c-7.152,116.555-43.254,402.172-43.254,402.172 c-84.098,0-233.918-208.758-233.918-326.266c0-117.516,61.906-134.391,91.141-144.34h152.394 C921.484,702.328,931.461,728,931.461,762.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M729.738,694.055c-40.121,21.359-61.906,72.164-61.906,119.453h30.176 c3.871-67.195,8.852-102.031,55.512-119.453H729.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M874.043,694.055c-40.125,21.359-61.902,72.164-61.902,119.453h30.172 c3.879-67.195,8.848-102.031,55.512-119.453H874.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27425F"
    },
    d: "M654.289,1224.719l18.664,228.637l19.602,257.359c0,0,29.859,21.148,49.461,0l22.391-153.047 l-8.395-104.313l34.531-228.637H654.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M722.414,1227.164l-11.199,227.691l15.695,267.023c5.148-0.648,15.105-8.734,15.105-8.734 l22.391-153.047l-8.395-104.316l34.531-228.617H722.414z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#27425F"
    },
    points: "909.059,1227.164 654.289,1227.164 654.289,813.508 853.07,813.508 829.117,988.988  909.059,1086.043  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "869.703,1713.145 826.922,1713.145 809.195,1728.078 809.195,1744.871  888.207,1744.871 888.207,1728.078  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27425F"
    },
    d: "M909.059,1227.164l-6.527,228.152l-31.734,257.828c0,0-23.332,20.059-42.93-1.09 l-22.398-153.059l8.398-104.305l-41.059-227.527H909.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M848.699,1723.645c-18.043,0-32.656,2.352-32.656,5.254h65.324 C881.367,1725.996,866.746,1723.645,848.699,1723.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27425F"
    },
    d: "M716.195,694.055c-40.133,21.359-61.906,72.164-61.906,119.453h30.168 c4.672-75.59,25.512-102.031,72.18-119.453H716.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27425F"
    },
    d: "M857.391,694.055c-56.273,17.422-61.914,72.164-61.914,119.453h31.453 c-1.859-70.305,19.465-98.508,70.894-119.453H857.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M806.105,897.981c0,43.367-28.836,78.527-64.406,78.527c-35.563,0-64.406-35.16-64.406-78.527 c0-43.371,28.844-33.461,64.406-33.461C777.269,864.519,806.105,854.609,806.105,897.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M806.074,898.746c0-0.258,0.031-0.508,0.031-0.766c0-43.371-28.836-33.461-64.406-33.461 c-35.563,0-64.406-9.91-64.406,33.461c0,0.258,0.031,0.508,0.039,0.766H806.074z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D68552",
      strokeWidth: 44.7954,
      strokeMiterlimit: 10
    },
    d: "M931.461,762.488 c0.469,0.934,79.32,101.055,64.699,279.977l-260.063,23.641"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1021.043,889.098c-3.731-147.449-117.816-192.719-117.816-192.719l-23.094,106.859 c51.356,16.805,61.594,85.859,61.594,85.859S1016.375,889.098,1021.043,889.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M667.832,909.664c4.512,0,8.16,64.383,8.16,143.805s-3.648,143.813-8.16,143.813 c-4.504,0-8.16-64.391-8.16-143.813S663.328,909.664,667.832,909.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M728.945,694.055c4.504-0.023-51.914,31.883-51.652,85.856l-8.992,100.156 c-9.492,0.047-8.137,8.051-8.629-95.531C659.418,730.555,724.438,694.074,728.945,694.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4A6A"
    },
    d: "M870.797,694.055c4.508-0.023-51.91,31.883-51.656,85.856l-8.996,69.308 c-9.492,0.051-8.617-20.781-8.617-64.683C801.527,730.555,866.285,694.074,870.797,694.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M839.496,696.379c-20.988,17.141-83.77,64.254-95.789,49.555 c-12.019-14.715-6.633-32.414,14.344-49.555H839.496z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M720.117,560.141c0,15.031-10.156,27.227-22.688,27.227c-12.535,0-22.688-12.195-22.688-27.227 c0-15.035,10.152-27.223,22.688-27.223C709.961,532.918,720.117,545.106,720.117,560.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M920.519,560.141c0,15.031-10.16,27.227-22.695,27.227c-12.531,0-22.684-12.195-22.684-27.227 c0-15.035,10.152-27.223,22.684-27.223C910.359,532.918,920.519,545.106,920.519,560.141z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M817.008,708.141l-48.375-3.172h-0.047c0.125-3.394,0.074-32.156-0.027-57.48l48.527-0.195 C817.309,704.316,817.094,706.988,817.008,708.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DADE"
    },
    d: "M809.668,691.258c0,0-43.391,10.73-41.109-43.77l48.527-0.195 C817.086,647.293,819.465,691.258,809.668,691.258z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D68552"
    },
    d: "M908.164,504.883c0,73.48-50.453,172.832-112.688,172.832 c-62.23,0-112.691-99.352-112.691-172.832c0-73.492,50.461-93.289,112.691-93.289 C857.711,411.594,908.164,431.391,908.164,504.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M875.457,487.879c9.223,33.063,26.449,48.68,12.379,106.434 c0.203,2.203,18.844-42.969,23.809-106.434H875.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M703.141,594.391c-0.379,4.207-48.852-121.227-4.836-193.926 c7.16,22.715,21.313,22.715,21.313,22.715s24.367-85.527,127.836-67.793c-17.859,14.93,0,27.996,0,27.996 s27.508-33.656,111.238,16.742c0,0,9.031,62.82-49.758,94.434c-58.797,31.613-102.656-7.586-126.457-22.52 c0,0-54.871-3.238-77.012,48.215C698.078,537.406,702.828,564.082,703.141,594.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M764.73,627.523c0,13.27,13.766,24.027,30.746,24.027c16.988,0,30.758-10.758,30.758-24.027 H764.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DADE"
    },
    points: "810.328,549.277 825.73,614.008 790.715,616.258 817.652,612.91  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M808.227,525.41c0.395-1.879,11.031-5.156,11.031-5.156l47.773,16.305 C867.031,536.559,807.066,530.977,808.227,525.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M779.559,525.41c-0.391-1.879-11.023-5.156-11.023-5.156l-47.793,16.305 C720.742,536.559,780.715,530.977,779.559,525.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M837.621,561.848c0,9.496-2.656,17.195-5.941,17.195c-3.273,0-5.949-7.699-5.949-17.195 c0-9.496,2.676-17.192,5.949-17.192C834.965,544.656,837.621,552.352,837.621,561.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B0900"
    },
    d: "M765.41,561.848c0,9.496-2.664,17.195-5.949,17.195c-3.281,0-5.941-7.699-5.941-17.195 c0-9.496,2.66-17.192,5.941-17.192C762.746,544.656,765.41,552.352,765.41,561.848z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M705.465,1011.781c0,0,46.113-5.84,45.406,23.766c-0.695,29.602-28.457,6.43-28.457,6.43 L705.465,1011.781z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B89021"
    },
    d: "M735.199,1034.75c-0.215-2.633,6.516-11.438,6.516-11.438s-15.563-11.992-36.25-11.531 C719.242,1016.703,730.789,1031.086,735.199,1034.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792027"
    },
    d: "M711.254,1204.832c5.848,0,10.57-4.73,10.57-10.578c0-5.84-4.723-10.566-10.57-10.566 c-5.844,0-10.566,4.727-10.566,10.566C700.688,1200.102,705.41,1204.832,711.254,1204.832z M711.254,1187.617 c3.668,0,6.641,2.973,6.641,6.637c0,3.668-2.973,6.652-6.641,6.652c-3.664,0-6.645-2.984-6.645-6.652 C704.609,1190.59,707.59,1187.617,711.254,1187.617z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 702.746,
    y: 920.055,
    style: {
      fill: "#C1C1C4"
    },
    width: 17.019,
    height: 267.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.746,
    y: 920.055,
    style: {
      fill: "#F9F9F9"
    },
    width: 5,
    height: 267.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 714.535,
    y: 920.055,
    style: {
      fill: "#979597"
    },
    width: 5.23,
    height: 267.313
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 619.23,
    y: 833.016,
    style: {
      fill: "#11646F"
    },
    width: 184.262,
    height: 62.098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.23,
    y: 835.977,
    style: {
      fill: "#1A828F"
    },
    width: 184.262,
    height: 62.109
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.703,898.086h2.41c0.211-0.266,0.344-0.594,0.344-0.957 c0-0.859-0.691-1.551-1.547-1.551c-0.793,0-1.441,0.598-1.531,1.375v0.344C741.418,897.59,741.527,897.863,741.703,898.086 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.019,889.227c-0.457,0.719-0.238,1.668,0.492,2.121c0.719,0.453,1.68,0.23,2.133-0.492 c0.449-0.719,0.223-1.676-0.496-2.133C748.422,888.273,747.477,888.488,747.019,889.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M745.707,886.566c-0.277,0.426-0.144,0.988,0.289,1.254c0.414,0.269,0.98,0.137,1.242-0.285 c0.273-0.43,0.152-0.988-0.277-1.258C746.527,886.016,745.973,886.141,745.707,886.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M744.625,891.328c-0.168,0.273-0.086,0.629,0.188,0.797 c0.266,0.176,0.633,0.098,0.805-0.188c0.164-0.266,0.09-0.621-0.188-0.793 C745.148,890.969,744.801,891.055,744.625,891.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.984,878.668c0.055,0.629,0.602,1.09,1.227,1.031c0.637-0.059,1.094-0.609,1.039-1.238 c-0.055-0.621-0.609-1.082-1.238-1.027C743.391,877.488,742.922,878.039,742.984,878.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.902,880.504c-0.234,0.019-0.41,0.23-0.391,0.461c0.023,0.242,0.231,0.41,0.469,0.391 c0.234-0.02,0.41-0.223,0.391-0.461C743.34,880.66,743.137,880.484,742.902,880.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M752.316,883.168c0.637-0.059,1.09-0.602,1.035-1.231c-0.063-0.629-0.609-1.098-1.238-1.035 c-0.625,0.051-1.086,0.606-1.031,1.234C751.133,882.758,751.691,883.223,752.316,883.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M749.738,880.445c-0.367,0.027-0.644,0.348-0.609,0.715c0.039,0.383,0.359,0.644,0.73,0.613 c0.367-0.031,0.633-0.359,0.605-0.734C750.434,880.68,750.102,880.402,749.738,880.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M750.609,884.441c0.031,0.234,0.234,0.402,0.473,0.391c0.231-0.027,0.406-0.234,0.387-0.469 c-0.02-0.238-0.227-0.414-0.469-0.395C750.766,883.992,750.594,884.207,750.609,884.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M751.633,876.578c0.547-0.316,0.723-1.02,0.406-1.559c-0.32-0.547-1.02-0.726-1.563-0.406 c-0.543,0.316-0.719,1.012-0.402,1.559C750.387,876.719,751.086,876.894,751.633,876.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M750.91,877.594c-0.316,0.192-0.426,0.602-0.242,0.926c0.195,0.316,0.605,0.422,0.922,0.234 c0.317-0.195,0.43-0.598,0.242-0.914C751.641,877.523,751.234,877.41,750.91,877.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M753.473,875.277c-0.199,0.117-0.262,0.383-0.145,0.59c0.117,0.199,0.379,0.266,0.578,0.141 c0.207-0.113,0.281-0.383,0.164-0.574C753.945,875.227,753.68,875.16,753.473,875.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M743.625,869.996c-0.637,0.059-1.098,0.609-1.035,1.231 c0.051,0.629,0.609,1.098,1.227,1.035c0.625-0.055,1.094-0.606,1.039-1.234S744.25,869.941,743.625,869.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.977,870.141c-0.035-0.316-0.289-0.551-0.598-0.586v1.309 C741.734,870.816,741.996,870.508,741.977,870.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.117,873.531c0.023,0.238,0.223,0.41,0.465,0.391c0.238-0.02,0.406-0.223,0.398-0.469 c-0.023-0.234-0.238-0.398-0.473-0.383C742.273,873.09,742.102,873.297,742.117,873.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.313,876.035c0.019,0.234,0.223,0.41,0.457,0.394c0.238-0.008,0.406-0.207,0.406-0.441 c-0.019-0.234-0.215-0.422-0.449-0.406C742.492,875.594,742.309,875.793,742.313,876.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M745.957,875.211c0.473,0.234,1.043,0.035,1.266-0.441c0.234-0.469,0.039-1.031-0.441-1.262 c-0.469-0.231-1.035-0.035-1.258,0.434C745.289,874.422,745.484,874.988,745.957,875.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M744.168,875.457c-0.129,0.277-0.016,0.609,0.266,0.738 c0.277,0.144,0.613,0.016,0.742-0.258c0.133-0.277,0.019-0.613-0.262-0.738 C744.641,875.063,744.305,875.172,744.168,875.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.418,876.543c0.172,0.078,0.391,0.008,0.469-0.172c0.082-0.18,0.008-0.383-0.172-0.477 c-0.164-0.086-0.391-0.008-0.477,0.164C747.16,876.242,747.234,876.453,747.418,876.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M746.73,882c0.465,0.223,1.035,0.027,1.27-0.438c0.23-0.481,0.027-1.043-0.449-1.273 c-0.469-0.231-1.039-0.027-1.258,0.445C746.055,881.199,746.254,881.766,746.73,882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M744.938,882.234c-0.137,0.281-0.023,0.617,0.258,0.75c0.277,0.129,0.609,0.02,0.746-0.266 c0.133-0.281,0.016-0.605-0.262-0.742C745.398,881.84,745.074,881.961,744.938,882.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M748.172,883.32c0.188,0.082,0.402,0.008,0.48-0.16c0.086-0.18,0.008-0.395-0.168-0.488 c-0.18-0.078-0.383-0.012-0.477,0.172C747.926,883.019,748,883.231,748.172,883.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M752.852,893.352c0.719,0.457,1.68,0.234,2.129-0.488c0.457-0.727,0.234-1.68-0.484-2.133 c-0.731-0.453-1.684-0.234-2.141,0.492C751.906,891.938,752.125,892.902,752.852,893.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M751.043,888.578c-0.27,0.422-0.141,0.984,0.289,1.25c0.426,0.258,0.984,0.133,1.25-0.285 c0.27-0.43,0.141-0.992-0.285-1.258C751.867,888.019,751.313,888.148,751.043,888.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M749.965,893.332c-0.168,0.274-0.086,0.633,0.192,0.801 c0.269,0.172,0.629,0.086,0.793-0.184c0.176-0.27,0.094-0.629-0.184-0.801 C750.492,892.977,750.137,893.059,749.965,893.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M749.785,898.086h1.223c0.684-0.297,1.066-1.043,0.887-1.785 c-0.195-0.828-1.031-1.34-1.863-1.137c-0.828,0.199-1.34,1.043-1.141,1.871 C749.012,897.527,749.352,897.891,749.785,898.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.844,895.699c-0.129-0.488-0.621-0.785-1.102-0.672 c-0.488,0.121-0.785,0.613-0.668,1.102c0.121,0.492,0.613,0.793,1.098,0.672 C747.668,896.68,747.965,896.191,747.844,895.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M756.684,895.789c-0.723,0.453-0.945,1.406-0.484,2.129c0.031,0.063,0.07,0.117,0.121,0.168 h2.367c0.41-0.5,0.488-1.227,0.121-1.813C758.359,895.555,757.402,895.336,756.684,895.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.617,894.371c0.426-0.269,0.555-0.824,0.289-1.254 c-0.266-0.422-0.828-0.559-1.254-0.293c-0.426,0.273-0.558,0.836-0.289,1.258 C756.637,894.512,757.191,894.633,757.617,894.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.41,896.828c-0.164-0.27-0.527-0.359-0.805-0.188c-0.266,0.18-0.355,0.531-0.184,0.797 c0.176,0.277,0.531,0.356,0.805,0.191C754.496,897.453,754.574,897.098,754.41,896.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M756.695,887.32c0.629-0.059,1.09-0.609,1.027-1.238c-0.055-0.625-0.598-1.09-1.23-1.031 c-0.621,0.051-1.09,0.602-1.031,1.23C755.512,886.91,756.066,887.375,756.695,887.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.227,885.926c0.379-0.035,0.645-0.363,0.617-0.73c-0.039-0.363-0.356-0.645-0.731-0.609 c-0.367,0.039-0.641,0.356-0.609,0.727C753.543,885.68,753.863,885.957,754.227,885.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.988,888.586c0.027,0.234,0.234,0.41,0.465,0.379c0.234-0.008,0.41-0.211,0.398-0.453 c-0.027-0.238-0.234-0.414-0.477-0.395C755.152,888.144,754.977,888.352,754.988,888.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.66,873.348c0.633-0.055,1.094-0.621,1.047-1.238c-0.059-0.625-0.609-1.086-1.238-1.031 c-0.621,0.055-1.09,0.605-1.031,1.234C756.492,872.938,757.039,873.398,757.66,873.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.488,871.344c0.027,0.371,0.356,0.641,0.719,0.606c0.363-0.031,0.645-0.348,0.606-0.723 c-0.027-0.375-0.352-0.637-0.731-0.609C754.723,870.648,754.445,870.981,754.488,871.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M756.82,874.539c-0.023-0.238-0.234-0.414-0.461-0.383 c-0.246,0.008-0.414,0.223-0.391,0.469c0.016,0.223,0.23,0.394,0.465,0.379 C756.664,874.984,756.848,874.773,756.82,874.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.031,880.734c0.625-0.059,1.098-0.621,1.039-1.238 c-0.066-0.629-0.621-1.094-1.234-1.035c-0.633,0.059-1.098,0.609-1.039,1.238 C755.852,880.324,756.406,880.785,757.031,880.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.57,879.336c0.375-0.035,0.645-0.355,0.609-0.727c-0.027-0.375-0.352-0.645-0.723-0.609 c-0.375,0.027-0.637,0.359-0.609,0.719C753.879,879.098,754.207,879.367,754.57,879.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M755.719,881.543c-0.238,0.019-0.414,0.223-0.387,0.457c0.02,0.234,0.227,0.402,0.461,0.383 c0.234-0.02,0.41-0.223,0.387-0.461C756.16,881.688,755.953,881.512,755.719,881.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M761.621,879.191c-0.477-0.227-1.039-0.027-1.273,0.445 c-0.219,0.477-0.023,1.047,0.449,1.277c0.469,0.227,1.039,0.027,1.258-0.445 C762.289,879.992,762.09,879.422,761.621,879.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759,881.148c-0.129,0.27-0.016,0.606,0.266,0.742c0.281,0.129,0.609,0.016,0.738-0.262 c0.137-0.277,0.027-0.609-0.258-0.742C759.473,880.742,759.141,880.867,759,881.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M762.715,882.063c0.094-0.176,0.012-0.391-0.168-0.477c-0.168-0.09-0.379-0.016-0.469,0.168 c-0.086,0.176-0.023,0.391,0.172,0.469C762.418,882.313,762.641,882.242,762.715,882.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M746.328,845.488c-0.449,0.73-0.23,1.68,0.492,2.133c0.731,0.453,1.684,0.231,2.133-0.496 c0.457-0.723,0.238-1.672-0.496-2.129C747.738,844.543,746.781,844.762,746.328,845.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M745.016,842.836c-0.273,0.43-0.141,0.992,0.289,1.25c0.422,0.273,0.988,0.145,1.25-0.285 c0.266-0.422,0.137-0.984-0.285-1.246C745.84,842.281,745.281,842.414,745.016,842.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M743.945,847.602c-0.18,0.269-0.098,0.625,0.18,0.797c0.273,0.172,0.629,0.09,0.793-0.188 c0.172-0.266,0.098-0.629-0.18-0.797C744.465,847.242,744.109,847.328,743.945,847.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M752.309,850.664c-0.453,0.723-0.234,1.68,0.488,2.129c0.723,0.457,1.68,0.238,2.129-0.488 c0.457-0.727,0.234-1.68-0.496-2.133C753.719,849.719,752.758,849.938,752.309,850.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M751.281,849.269c0.418,0.262,0.984,0.137,1.254-0.293c0.262-0.422,0.137-0.984-0.289-1.258 c-0.43-0.262-0.992-0.137-1.258,0.289C750.723,848.438,750.852,849,751.281,849.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M750.711,852.586c-0.266-0.168-0.629-0.09-0.805,0.188 c-0.164,0.266-0.074,0.629,0.188,0.801c0.281,0.168,0.637,0.086,0.805-0.184 C751.074,853.117,750.988,852.754,750.711,852.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M749.5,841.148c0.633-0.055,1.094-0.609,1.031-1.238c-0.055-0.629-0.606-1.086-1.231-1.027 c-0.629,0.047-1.098,0.602-1.039,1.227C748.32,840.738,748.875,841.207,749.5,841.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.035,839.75c0.383-0.031,0.645-0.363,0.617-0.723c-0.039-0.371-0.355-0.644-0.73-0.609 c-0.367,0.031-0.637,0.355-0.609,0.723C746.352,839.516,746.672,839.789,747.035,839.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.809,842.414c0.008,0.23,0.219,0.41,0.453,0.391c0.242-0.023,0.41-0.23,0.383-0.465 c-0.012-0.238-0.226-0.41-0.457-0.391C747.953,841.965,747.785,842.18,747.809,842.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.602,844.609c0.633-0.047,1.086-0.605,1.039-1.234 c-0.059-0.625-0.609-1.094-1.238-1.035c-0.625,0.059-1.082,0.613-1.027,1.238 C756.426,844.207,756.977,844.664,757.602,844.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.414,842.606c0.031,0.367,0.359,0.644,0.738,0.617c0.359-0.035,0.633-0.367,0.602-0.734 c-0.035-0.367-0.359-0.633-0.731-0.605C754.652,841.914,754.375,842.242,754.414,842.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M755.902,845.883c0.02,0.234,0.227,0.41,0.461,0.391c0.234-0.023,0.414-0.23,0.387-0.469 c-0.027-0.234-0.227-0.41-0.465-0.391C756.047,845.434,755.883,845.644,755.902,845.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M756.918,838.019c0.543-0.316,0.723-1.012,0.406-1.555 c-0.141-0.238-0.348-0.394-0.582-0.488h-0.801c-0.059,0.019-0.117,0.039-0.184,0.078c-0.535,0.324-0.715,1.016-0.398,1.555 C755.68,838.16,756.375,838.336,756.918,838.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.109,839.281c-0.184-0.316-0.594-0.426-0.91-0.242c-0.316,0.188-0.43,0.602-0.238,0.926 c0.184,0.316,0.594,0.418,0.918,0.231C757.191,840.012,757.305,839.598,757.109,839.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759.352,836.875c-0.125-0.211-0.383-0.273-0.586-0.156 c-0.211,0.121-0.273,0.383-0.144,0.586c0.105,0.203,0.375,0.27,0.578,0.156 C759.402,837.336,759.473,837.074,759.352,836.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M744.574,836.25c0.027,0.629,0.57,1.113,1.203,1.078c0.621-0.035,1.105-0.566,1.07-1.199 c0-0.055-0.02-0.102-0.027-0.152h-2.223C744.582,836.066,744.559,836.16,744.574,836.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M744.031,838.617c0.019,0.363,0.332,0.652,0.699,0.625c0.375-0.019,0.656-0.332,0.633-0.707 c-0.016-0.363-0.324-0.648-0.703-0.621C744.297,837.934,744.008,838.238,744.031,838.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M748.457,837.43c-0.012-0.234-0.215-0.418-0.449-0.402 c-0.234,0.008-0.418,0.211-0.398,0.445c0.004,0.238,0.207,0.414,0.449,0.406 C748.289,837.859,748.477,837.664,748.457,837.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M751.574,842.176c-0.234,0.469-0.027,1.043,0.445,1.266 c0.465,0.227,1.035,0.035,1.262-0.434c0.226-0.477,0.039-1.047-0.449-1.277 C752.363,841.504,751.805,841.703,751.574,842.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M750.477,844.43c0.289,0.133,0.621,0.02,0.758-0.262c0.125-0.277,0.008-0.613-0.27-0.746 c-0.281-0.141-0.609-0.02-0.746,0.266C750.082,843.957,750.207,844.289,750.477,844.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M753.465,844.762c0.176,0.094,0.391,0.016,0.473-0.16c0.082-0.18,0.016-0.391-0.172-0.477 c-0.168-0.094-0.383-0.019-0.477,0.16C753.211,844.469,753.281,844.68,753.465,844.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M761.98,848.762c0.625-0.063,1.086-0.609,1.035-1.238c-0.059-0.621-0.617-1.09-1.238-1.027 c-0.625,0.055-1.094,0.609-1.027,1.227C760.801,848.352,761.348,848.816,761.98,848.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759.516,847.367c0.375-0.027,0.645-0.359,0.613-0.73c-0.035-0.363-0.359-0.641-0.731-0.602 c-0.363,0.027-0.644,0.355-0.605,0.727C758.813,847.125,759.156,847.398,759.516,847.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M760.277,850.027c0.023,0.242,0.23,0.414,0.465,0.391c0.234-0.024,0.41-0.223,0.387-0.461 c-0.023-0.238-0.231-0.41-0.465-0.394C760.426,849.586,760.258,849.797,760.277,850.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M762.621,840.09c-0.055-0.629-0.609-1.09-1.234-1.031c-0.629,0.051-1.09,0.602-1.039,1.234 c0.059,0.625,0.621,1.094,1.234,1.023C762.211,841.266,762.672,840.719,762.621,840.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759.73,839.203c-0.031-0.367-0.355-0.645-0.723-0.613 c-0.367,0.039-0.648,0.363-0.613,0.734c0.039,0.367,0.359,0.641,0.738,0.609 C759.492,839.898,759.769,839.574,759.73,839.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759.883,842.594c0.02,0.234,0.227,0.414,0.465,0.391c0.234-0.02,0.41-0.234,0.387-0.469 c-0.02-0.234-0.227-0.402-0.469-0.391C760.031,842.152,759.863,842.359,759.883,842.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M763.144,844.461c0.469,0.223,1.039,0.027,1.274-0.449c0.223-0.473,0.027-1.039-0.449-1.262 c-0.469-0.234-1.039-0.039-1.266,0.438C762.477,843.668,762.672,844.227,763.144,844.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M761.621,845.441c0.273,0.133,0.605,0.012,0.738-0.266c0.137-0.273,0.02-0.602-0.262-0.746 c-0.277-0.129-0.609-0.012-0.738,0.266C761.223,844.969,761.344,845.309,761.621,845.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M764.426,845.305c-0.082,0.172-0.008,0.387,0.172,0.473c0.172,0.09,0.391,0.012,0.477-0.164 c0.082-0.18,0.004-0.395-0.164-0.477C764.734,845.051,764.519,845.121,764.426,845.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M744.07,865.434c-0.457,0.727-0.234,1.684,0.488,2.137c0.723,0.453,1.68,0.227,2.133-0.492 c0.461-0.723,0.23-1.672-0.492-2.133C745.473,864.492,744.519,864.715,744.07,865.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.75,862.789c-0.266,0.422-0.141,0.98,0.293,1.258c0.43,0.262,0.98,0.129,1.254-0.289 c0.262-0.43,0.137-0.992-0.293-1.258C743.574,862.234,743.016,862.356,742.75,862.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.676,867.543c-0.172,0.273-0.09,0.641,0.184,0.801c0.273,0.176,0.633,0.098,0.809-0.18 c0.16-0.273,0.082-0.629-0.195-0.805C742.211,867.188,741.855,867.277,741.676,867.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M750.531,872.742c0.723,0.453,1.68,0.234,2.141-0.492c0.453-0.727,0.234-1.676-0.492-2.133 c-0.731-0.453-1.688-0.23-2.137,0.492C749.586,871.336,749.805,872.285,750.531,872.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M749.019,869.215c0.426,0.262,0.981,0.137,1.246-0.293c0.266-0.422,0.141-0.984-0.289-1.246 c-0.43-0.27-0.984-0.141-1.258,0.289C748.457,868.387,748.582,868.945,749.019,869.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.652,872.719c-0.172,0.266-0.082,0.629,0.184,0.809c0.27,0.172,0.629,0.078,0.797-0.191 c0.176-0.266,0.086-0.637-0.188-0.797C748.184,872.367,747.816,872.445,747.652,872.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.238,861.094c0.629-0.055,1.09-0.609,1.039-1.227c-0.066-0.637-0.609-1.098-1.242-1.043 c-0.625,0.063-1.094,0.609-1.031,1.23C746.063,860.684,746.613,861.148,747.238,861.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M744.781,859.699c0.367-0.035,0.637-0.356,0.605-0.727 c-0.027-0.375-0.359-0.641-0.727-0.609c-0.363,0.031-0.648,0.363-0.609,0.727 C744.082,859.461,744.414,859.734,744.781,859.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M745.539,862.356c0.023,0.242,0.227,0.414,0.465,0.394c0.234-0.023,0.406-0.231,0.387-0.469 c-0.031-0.234-0.223-0.402-0.469-0.383C745.688,861.918,745.519,862.121,745.539,862.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M755.34,864.559c0.629-0.055,1.094-0.609,1.035-1.23c-0.055-0.633-0.617-1.094-1.234-1.031 c-0.633,0.047-1.086,0.605-1.031,1.227C754.168,864.148,754.711,864.609,755.34,864.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M752.148,862.555c0.039,0.375,0.367,0.645,0.731,0.609c0.367-0.027,0.641-0.359,0.609-0.727 c-0.027-0.371-0.356-0.637-0.731-0.609C752.394,861.863,752.121,862.191,752.148,862.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M753.641,865.832c0.02,0.234,0.227,0.406,0.469,0.387c0.23-0.023,0.398-0.23,0.387-0.469 c-0.027-0.238-0.231-0.406-0.477-0.383C753.797,865.387,753.609,865.59,753.641,865.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.652,857.969c0.551-0.32,0.73-1.016,0.41-1.563c-0.316-0.531-1.012-0.727-1.559-0.402 c-0.547,0.316-0.731,1.016-0.41,1.559C753.41,858.106,754.113,858.289,754.652,857.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M754.848,859.223c-0.184-0.317-0.594-0.418-0.91-0.234c-0.328,0.191-0.43,0.602-0.242,0.922 c0.188,0.313,0.594,0.422,0.918,0.234S755.043,859.551,754.848,859.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.094,856.82c-0.121-0.203-0.391-0.273-0.594-0.152c-0.199,0.117-0.27,0.387-0.152,0.586 c0.117,0.203,0.375,0.277,0.586,0.152C757.137,857.289,757.207,857.019,757.094,856.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M746.848,853.66c0.629-0.055,1.082-0.609,1.027-1.242c-0.059-0.621-0.609-1.082-1.231-1.031 c-0.629,0.051-1.094,0.609-1.027,1.234C745.668,853.25,746.215,853.711,746.848,853.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M743.66,851.656c0.031,0.367,0.352,0.645,0.723,0.606c0.371-0.031,0.645-0.356,0.606-0.723 c-0.031-0.375-0.356-0.637-0.723-0.613C743.894,850.961,743.625,851.285,743.66,851.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M745.144,854.922c0.012,0.242,0.223,0.414,0.461,0.395c0.234-0.02,0.41-0.234,0.391-0.469 c-0.023-0.234-0.231-0.406-0.469-0.391C745.293,854.477,745.117,854.691,745.144,854.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.313,856.203c0.027,0.629,0.566,1.113,1.195,1.074c0.625-0.039,1.113-0.57,1.078-1.195 c-0.039-0.625-0.574-1.113-1.195-1.082C742.758,855.043,742.277,855.574,742.313,856.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.762,858.566c0.02,0.367,0.34,0.652,0.703,0.625c0.375-0.016,0.652-0.336,0.633-0.703 c-0.016-0.367-0.328-0.652-0.699-0.629C742.023,857.879,741.742,858.184,741.762,858.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M745.797,857.824c0.227-0.008,0.41-0.215,0.402-0.449c-0.012-0.234-0.219-0.418-0.453-0.402 c-0.238,0.008-0.414,0.215-0.406,0.445C745.348,857.66,745.551,857.84,745.797,857.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M748.543,855.34c-0.227,0.469-0.027,1.043,0.437,1.266c0.473,0.234,1.043,0.035,1.277-0.438 c0.219-0.469,0.02-1.043-0.453-1.277C749.34,854.668,748.777,854.867,748.543,855.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M747.195,856.84c-0.133,0.289-0.023,0.617,0.258,0.754c0.281,0.133,0.609,0.016,0.746-0.258 c0.137-0.281,0.012-0.617-0.258-0.75C747.668,856.457,747.324,856.566,747.195,856.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M750.434,857.93c0.176,0.09,0.394,0.008,0.477-0.164c0.09-0.18,0.012-0.395-0.168-0.477 c-0.172-0.09-0.391-0.02-0.477,0.16C750.188,857.629,750.258,857.84,750.434,857.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M749.309,862.121c-0.231,0.477-0.027,1.043,0.438,1.273c0.48,0.223,1.047,0.027,1.273-0.445 c0.223-0.473,0.035-1.043-0.438-1.266C750.102,861.449,749.539,861.652,749.309,862.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M748.223,864.379c0.281,0.133,0.609,0.012,0.746-0.266c0.129-0.273,0.012-0.609-0.258-0.746 c-0.289-0.137-0.617-0.012-0.746,0.266C747.828,863.906,747.941,864.234,748.223,864.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M751.199,864.715c0.176,0.082,0.391,0.012,0.481-0.168c0.086-0.18,0.012-0.391-0.164-0.477 c-0.184-0.086-0.398-0.012-0.488,0.164C750.941,864.41,751.019,864.625,751.199,864.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759.715,868.707c0.633-0.051,1.098-0.609,1.035-1.234c-0.055-0.625-0.609-1.09-1.234-1.035 c-0.633,0.051-1.09,0.621-1.039,1.238C758.535,868.305,759.098,868.762,759.715,868.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.266,867.316c0.359-0.035,0.633-0.363,0.594-0.727 c-0.031-0.371-0.359-0.648-0.723-0.609c-0.367,0.027-0.637,0.359-0.602,0.723 C756.563,867.078,756.887,867.344,757.266,867.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M758.016,869.984c0.02,0.234,0.223,0.398,0.461,0.387c0.234-0.027,0.406-0.23,0.395-0.469 c-0.02-0.238-0.231-0.41-0.477-0.387C758.16,869.535,757.992,869.742,758.016,869.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M760.684,854.734c0.637-0.051,1.094-0.602,1.051-1.227c-0.059-0.633-0.621-1.09-1.246-1.039 c-0.617,0.059-1.09,0.609-1.031,1.238C759.516,854.336,760.066,854.793,760.684,854.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M758.844,852.617c-0.039-0.367-0.367-0.641-0.734-0.605 c-0.363,0.035-0.641,0.355-0.609,0.73c0.031,0.367,0.359,0.641,0.734,0.609 C758.594,853.313,758.871,852.981,758.844,852.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759.836,855.934c-0.012-0.234-0.223-0.414-0.461-0.391 c-0.234,0.019-0.406,0.23-0.391,0.465c0.023,0.238,0.23,0.41,0.469,0.391C759.688,856.371,759.863,856.168,759.836,855.934 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M760.355,860.035c-0.055-0.621-0.609-1.086-1.23-1.031c-0.629,0.059-1.09,0.613-1.035,1.238 c0.047,0.621,0.609,1.09,1.23,1.035C759.949,861.215,760.418,860.66,760.355,860.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M757.469,859.148c-0.039-0.363-0.359-0.637-0.727-0.602 c-0.367,0.027-0.637,0.359-0.602,0.723c0.027,0.371,0.352,0.641,0.727,0.609C757.234,859.84,757.5,859.519,757.469,859.148 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M758.469,862.469c-0.016-0.238-0.231-0.414-0.465-0.394 c-0.231,0.023-0.406,0.23-0.387,0.465c0.023,0.234,0.23,0.41,0.461,0.391C758.328,862.91,758.496,862.703,758.469,862.469z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M761.707,862.695c-0.473-0.234-1.043-0.031-1.269,0.441 c-0.231,0.469-0.019,1.039,0.449,1.262c0.473,0.231,1.035,0.043,1.27-0.426 C762.379,863.484,762.18,862.922,761.707,862.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M759.352,865.387c0.281,0.129,0.613,0.023,0.742-0.254c0.144-0.281,0.027-0.613-0.258-0.75 c-0.269-0.137-0.609-0.02-0.738,0.262C758.957,864.918,759.078,865.254,759.352,865.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M762.644,865.078c-0.176-0.082-0.391-0.008-0.476,0.168 c-0.09,0.184-0.012,0.398,0.172,0.481c0.168,0.09,0.375,0.012,0.469-0.172C762.898,865.387,762.82,865.172,762.644,865.078 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M767.418,891.348c0.723,0.453,1.68,0.23,2.129-0.492c0.457-0.719,0.234-1.676-0.492-2.133 c-0.719-0.449-1.68-0.234-2.133,0.504C766.473,889.945,766.688,890.894,767.418,891.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M765.887,887.82c0.434,0.269,0.992,0.137,1.262-0.285c0.27-0.43,0.137-0.988-0.289-1.258 c-0.426-0.262-0.984-0.137-1.254,0.289C765.344,886.992,765.465,887.555,765.887,887.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M765.332,891.144c-0.277-0.176-0.629-0.09-0.805,0.184 c-0.168,0.273-0.082,0.629,0.192,0.797c0.269,0.176,0.633,0.098,0.793-0.188 C765.684,891.672,765.605,891.316,765.332,891.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M760.582,891.305c-0.336,0.531-0.176,1.238,0.367,1.57c0.531,0.34,1.238,0.18,1.566-0.363 c0.348-0.531,0.18-1.234-0.348-1.57C761.621,890.609,760.914,890.769,760.582,891.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M760.539,889.121c-0.32-0.195-0.742-0.098-0.938,0.219c-0.199,0.32-0.102,0.723,0.215,0.922 c0.316,0.195,0.738,0.109,0.934-0.207C760.949,889.742,760.848,889.32,760.539,889.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M758.805,892.863c-0.121,0.199-0.059,0.469,0.141,0.59c0.199,0.133,0.469,0.07,0.602-0.133 c0.113-0.203,0.055-0.465-0.145-0.594C759.199,892.598,758.938,892.668,758.805,892.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M772.223,883.168c0.625-0.059,1.086-0.602,1.031-1.231 c-0.059-0.629-0.609-1.098-1.227-1.035c-0.633,0.051-1.098,0.606-1.047,1.234 C771.043,882.758,771.59,883.223,772.223,883.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M769.644,880.445c-0.363,0.027-0.637,0.348-0.609,0.715 c0.035,0.383,0.355,0.644,0.723,0.613c0.375-0.031,0.641-0.359,0.609-0.734 C770.336,880.68,770.012,880.402,769.644,880.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.523,884.441c0.02,0.234,0.223,0.402,0.457,0.391c0.238-0.027,0.414-0.234,0.398-0.469 c-0.023-0.238-0.238-0.414-0.473-0.395C770.672,883.992,770.496,884.207,770.523,884.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.379,874.613c-0.535,0.316-0.719,1.012-0.398,1.559 c0.316,0.547,1.008,0.723,1.555,0.406c0.539-0.316,0.727-1.02,0.406-1.559 C771.621,874.473,770.922,874.293,770.379,874.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M771.492,878.754c0.32-0.195,0.422-0.598,0.242-0.914c-0.191-0.316-0.605-0.43-0.922-0.246 c-0.316,0.192-0.422,0.602-0.242,0.926C770.762,878.836,771.176,878.941,771.492,878.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M773.23,875.867c0.121,0.199,0.379,0.266,0.586,0.141c0.207-0.113,0.266-0.383,0.156-0.574 c-0.117-0.207-0.387-0.273-0.59-0.156C773.176,875.394,773.109,875.66,773.23,875.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M765.41,876.484c0.473,0.223,1.039,0.027,1.266-0.445c0.231-0.473,0.031-1.047-0.445-1.273 c-0.465-0.227-1.035-0.027-1.262,0.441C764.738,875.684,764.938,876.25,765.41,876.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M763.871,877.469c0.281,0.125,0.617,0.016,0.75-0.262c0.141-0.273,0.019-0.617-0.262-0.754 c-0.273-0.125-0.605-0.016-0.746,0.266C763.48,877,763.602,877.328,763.871,877.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.688,877.324c-0.082,0.18-0.012,0.394,0.172,0.48c0.18,0.082,0.387,0.004,0.477-0.172 c0.094-0.176,0.004-0.395-0.172-0.477C766.988,877.074,766.781,877.148,766.688,877.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M760.258,885.414c-0.226,0.477-0.031,1.047,0.438,1.277c0.469,0.23,1.043,0.027,1.27-0.445 c0.23-0.473,0.031-1.047-0.441-1.273C761.055,884.746,760.48,884.941,760.258,885.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M758.906,886.926c-0.133,0.273-0.024,0.609,0.262,0.746c0.273,0.137,0.609,0.02,0.742-0.266 c0.141-0.273,0.02-0.613-0.258-0.738C759.375,886.531,759.039,886.648,758.906,886.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M762.629,887.84c0.078-0.18,0.012-0.387-0.172-0.473c-0.176-0.086-0.394-0.008-0.477,0.168 c-0.086,0.176-0.016,0.383,0.172,0.465C762.32,888.094,762.535,888.019,762.629,887.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M761.488,873.613c-0.305-0.426-0.902-0.516-1.324-0.207 c-0.426,0.313-0.516,0.906-0.203,1.324c0.305,0.43,0.906,0.516,1.324,0.211 C761.707,874.633,761.805,874.035,761.488,873.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M761.434,876.758c0.25-0.188,0.305-0.535,0.117-0.789c-0.18-0.246-0.523-0.297-0.777-0.117 c-0.246,0.188-0.301,0.531-0.117,0.777C760.84,876.879,761.191,876.934,761.434,876.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M763.215,873.785c-0.117-0.164-0.344-0.199-0.508-0.078c-0.16,0.113-0.195,0.34-0.066,0.504 c0.113,0.16,0.336,0.188,0.496,0.07C763.297,874.164,763.324,873.941,763.215,873.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M767.894,881.563c0.234-0.481,0.031-1.043-0.438-1.273 c-0.477-0.231-1.047-0.027-1.269,0.445c-0.227,0.465-0.035,1.031,0.445,1.266 C767.105,882.223,767.672,882.027,767.894,881.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M765.855,882.719c0.125-0.281,0.008-0.605-0.27-0.742c-0.273-0.137-0.609-0.016-0.75,0.258 c-0.133,0.281-0.016,0.617,0.273,0.75C765.383,883.113,765.715,883.004,765.855,882.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M768.559,883.16c0.094-0.18,0.008-0.395-0.164-0.488c-0.184-0.078-0.391-0.012-0.48,0.172 c-0.09,0.176-0.008,0.387,0.16,0.477C768.262,883.402,768.469,883.328,768.559,883.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M761.742,894.867c-0.223,0.473-0.027,1.047,0.445,1.277 c0.481,0.227,1.051,0.027,1.266-0.445c0.242-0.477,0.027-1.043-0.438-1.27 C762.547,894.199,761.973,894.398,761.742,894.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M760.398,896.383c-0.133,0.277-0.016,0.609,0.258,0.746 c0.281,0.129,0.617,0.012,0.758-0.262c0.129-0.281,0.012-0.617-0.27-0.75C760.867,895.981,760.539,896.098,760.398,896.383 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M763.949,896.82c-0.18-0.086-0.394-0.012-0.477,0.16c-0.09,0.188-0.012,0.394,0.164,0.484 c0.176,0.086,0.395,0.008,0.477-0.168C764.203,897.117,764.129,896.906,763.949,896.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M772.762,893.352c0.719,0.457,1.672,0.234,2.129-0.488c0.449-0.727,0.231-1.68-0.496-2.133 c-0.719-0.453-1.676-0.234-2.133,0.492C771.813,891.938,772.035,892.902,772.762,893.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.945,888.578c-0.262,0.422-0.137,0.984,0.289,1.25c0.422,0.258,0.988,0.133,1.25-0.285 c0.277-0.43,0.137-0.992-0.285-1.258C771.773,888.019,771.207,888.148,770.945,888.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.055,894.133c0.273,0.172,0.633,0.086,0.793-0.184c0.18-0.27,0.098-0.629-0.176-0.801 c-0.273-0.172-0.633-0.09-0.797,0.184C769.707,893.606,769.781,893.965,770.055,894.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M769.934,895.164c-0.828,0.199-1.336,1.043-1.141,1.871 c0.125,0.492,0.476,0.855,0.894,1.051h1.231c0.672-0.297,1.066-1.043,0.887-1.785 C771.598,895.473,770.762,894.961,769.934,895.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.648,895.027c-0.496,0.121-0.789,0.613-0.668,1.102 c0.121,0.492,0.613,0.793,1.098,0.672c0.492-0.121,0.789-0.609,0.668-1.102 C767.633,895.211,767.137,894.914,766.648,895.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.582,895.789c-0.719,0.453-0.941,1.406-0.488,2.129 c0.039,0.063,0.086,0.117,0.125,0.168h2.375c0.422-0.5,0.484-1.227,0.129-1.813 C778.262,895.555,777.309,895.336,776.582,895.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M777.519,894.371c0.082-0.051,0.141-0.105,0.188-0.164 c-0.144,0.031-0.301,0.008-0.434-0.074c-0.273-0.168-0.344-0.527-0.184-0.801c0.152-0.242,0.457-0.328,0.715-0.215l0,0 c-0.262-0.422-0.824-0.559-1.25-0.293c-0.43,0.273-0.559,0.836-0.289,1.258 C776.535,894.512,777.09,894.633,777.519,894.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M774.313,896.828c-0.172-0.27-0.527-0.359-0.801-0.188c-0.269,0.18-0.355,0.531-0.188,0.797 c0.176,0.277,0.543,0.356,0.809,0.191C774.406,897.453,774.484,897.098,774.313,896.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M777.629,886.082c-0.059-0.625-0.609-1.09-1.234-1.031c-0.637,0.051-1.082,0.602-1.035,1.23 c0.055,0.629,0.605,1.094,1.238,1.039C777.223,887.262,777.688,886.711,777.629,886.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M774.133,885.926c0.371-0.035,0.641-0.363,0.609-0.73c-0.031-0.363-0.352-0.645-0.727-0.609 c-0.371,0.039-0.641,0.356-0.605,0.727C773.449,885.68,773.766,885.957,774.133,885.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M775.355,888.965c0.242-0.008,0.402-0.211,0.395-0.453c-0.02-0.238-0.234-0.414-0.469-0.395 c-0.234,0.027-0.41,0.234-0.383,0.469C774.922,888.82,775.125,888.996,775.355,888.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M778.605,872.109c-0.051-0.625-0.609-1.086-1.23-1.031 c-0.633,0.055-1.094,0.605-1.031,1.234c0.051,0.625,0.609,1.086,1.227,1.035 C778.203,873.293,778.656,872.727,778.605,872.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M775.109,871.949c0.379-0.031,0.641-0.348,0.621-0.723 c-0.043-0.375-0.371-0.637-0.734-0.609c-0.371,0.031-0.648,0.363-0.606,0.727 C774.418,871.715,774.742,871.984,775.109,871.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.258,874.156c-0.234,0.008-0.41,0.223-0.391,0.469c0.023,0.223,0.227,0.394,0.469,0.379 c0.231-0.02,0.406-0.231,0.387-0.465C776.699,874.301,776.496,874.125,776.258,874.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M784.188,876.762c-0.629,0.051-1.09,0.609-1.031,1.234c0.047,0.629,0.613,1.086,1.234,1.031 c0.625-0.055,1.094-0.609,1.035-1.238C785.363,877.168,784.816,876.699,784.188,876.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M782.535,876.902c-0.027-0.371-0.355-0.641-0.727-0.602 c-0.367,0.027-0.641,0.348-0.606,0.719c0.031,0.371,0.356,0.641,0.723,0.606 C782.301,877.594,782.566,877.269,782.535,876.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M783.539,880.215c-0.023-0.234-0.227-0.406-0.461-0.383c-0.234,0.02-0.41,0.223-0.402,0.461 c0.031,0.23,0.234,0.414,0.48,0.391C783.394,880.664,783.559,880.453,783.539,880.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M775.996,877.613c-0.617,0.055-1.086,0.609-1.031,1.238 c0.055,0.625,0.609,1.082,1.242,1.023c0.621-0.047,1.082-0.598,1.023-1.227 C777.184,878.019,776.637,877.555,775.996,877.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M773.019,877.879c0.031,0.363,0.356,0.641,0.723,0.609c0.371-0.035,0.648-0.355,0.605-0.727 c-0.031-0.371-0.352-0.645-0.73-0.606C773.254,877.191,772.98,877.508,773.019,877.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M774.891,880.684c-0.238,0.023-0.414,0.234-0.387,0.469c0.012,0.234,0.227,0.41,0.461,0.391 c0.234-0.027,0.406-0.234,0.391-0.469C775.332,880.84,775.125,880.664,774.891,880.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M779.035,882.574c0.227-0.477,0.027-1.043-0.441-1.277 c-0.473-0.223-1.047-0.027-1.277,0.449c-0.227,0.461-0.027,1.043,0.445,1.266 C778.234,883.242,778.805,883.043,779.035,882.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.238,883.996c0.269,0.133,0.602,0.016,0.742-0.262c0.133-0.273,0.016-0.609-0.258-0.746 c-0.281-0.137-0.617-0.02-0.758,0.258C775.836,883.527,775.953,883.859,776.238,883.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M779.519,883.691c-0.176-0.086-0.391-0.012-0.476,0.16c-0.086,0.184,0,0.394,0.176,0.488 c0.172,0.082,0.379,0,0.469-0.172C779.777,883.988,779.699,883.773,779.519,883.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M782.102,892.863c0.461-0.727,0.234-1.68-0.48-2.133c-0.727-0.453-1.68-0.234-2.129,0.492 c-0.457,0.715-0.238,1.68,0.484,2.129C780.695,893.809,781.648,893.586,782.102,892.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M779.711,889.543c0.266-0.43,0.137-0.992-0.289-1.258c-0.426-0.266-0.988-0.137-1.254,0.293 c-0.27,0.422-0.137,0.984,0.277,1.25C778.883,890.086,779.441,889.961,779.711,889.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M777.09,893.332c-0.16,0.274-0.09,0.633,0.184,0.801c0.133,0.082,0.289,0.105,0.434,0.074 c0.152-0.031,0.285-0.121,0.371-0.258c0.176-0.27,0.09-0.629-0.184-0.801c-0.027-0.019-0.059-0.019-0.09-0.031 C777.547,893.004,777.242,893.09,777.09,893.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M785.938,896.273c-0.449-0.719-1.41-0.938-2.129-0.484 c-0.727,0.453-0.945,1.406-0.496,2.129c0.039,0.063,0.086,0.117,0.129,0.168h2.367 C786.23,897.586,786.309,896.859,785.938,896.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M785.031,893.117c-0.27-0.422-0.828-0.559-1.258-0.293 c-0.422,0.273-0.551,0.836-0.285,1.258c0.262,0.43,0.832,0.551,1.254,0.289 C785.168,894.102,785.297,893.547,785.031,893.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M780.543,897.438c0.176,0.277,0.535,0.356,0.801,0.191c0.281-0.176,0.363-0.531,0.184-0.801 c-0.16-0.27-0.527-0.359-0.797-0.188C780.461,896.82,780.379,897.172,780.543,897.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M783.613,885.051c-0.629,0.051-1.082,0.602-1.027,1.23c0.047,0.629,0.609,1.094,1.231,1.039 c0.629-0.059,1.082-0.609,1.027-1.238C784.797,885.457,784.238,884.992,783.613,885.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M781.965,885.195c-0.027-0.363-0.355-0.645-0.73-0.609 c-0.359,0.039-0.633,0.356-0.602,0.727c0.027,0.367,0.348,0.644,0.731,0.613 C781.723,885.891,781.996,885.563,781.965,885.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M782.969,888.512c-0.02-0.238-0.223-0.414-0.461-0.395 c-0.234,0.027-0.418,0.234-0.394,0.469c0.019,0.234,0.234,0.41,0.473,0.379 C782.809,888.957,782.984,888.754,782.969,888.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M786.629,860.883c-0.055-0.629-0.609-1.082-1.242-1.031c-0.625,0.059-1.09,0.609-1.023,1.23 c0.055,0.629,0.605,1.098,1.227,1.039C786.223,862.066,786.684,861.512,786.629,860.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M782.406,860.117c0.027,0.367,0.359,0.641,0.73,0.609c0.363-0.039,0.637-0.356,0.602-0.723 c-0.027-0.371-0.359-0.641-0.731-0.609C782.648,859.422,782.367,859.75,782.406,860.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M784.355,863.777c0.23-0.019,0.406-0.223,0.387-0.457c-0.027-0.242-0.223-0.414-0.465-0.391 c-0.234,0.012-0.406,0.227-0.387,0.465C783.906,863.625,784.121,863.801,784.355,863.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M785.809,881.297c-0.477-0.223-1.035-0.027-1.262,0.449 c-0.242,0.461-0.039,1.043,0.441,1.266c0.465,0.23,1.043,0.031,1.266-0.438 C786.484,882.098,786.281,881.531,785.809,881.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M783.945,882.988c-0.285-0.137-0.621-0.02-0.75,0.258c-0.144,0.281-0.019,0.613,0.258,0.75 c0.277,0.133,0.609,0.016,0.75-0.262C784.336,883.461,784.219,883.125,783.945,882.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M786.906,884.168c0.094-0.18,0.012-0.395-0.164-0.477c-0.176-0.086-0.391-0.012-0.473,0.16 c-0.09,0.184-0.016,0.394,0.168,0.488C786.613,884.422,786.828,884.34,786.906,884.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M768.859,847.125c0.449-0.723,0.238-1.672-0.496-2.129 c-0.723-0.453-1.676-0.234-2.133,0.492c-0.449,0.73-0.227,1.68,0.496,2.133 C767.457,848.074,768.406,847.852,768.859,847.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.172,842.555c-0.43-0.273-0.988-0.141-1.254,0.281c-0.266,0.43-0.141,0.992,0.289,1.25 c0.422,0.273,0.984,0.145,1.25-0.285C766.727,843.379,766.605,842.816,766.172,842.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M764.832,848.211c0.164-0.266,0.086-0.629-0.191-0.797 c-0.266-0.172-0.629-0.086-0.797,0.188c-0.176,0.269-0.09,0.625,0.183,0.797 C764.301,848.57,764.66,848.488,764.832,848.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M774.348,850.172c-0.73-0.453-1.688-0.234-2.137,0.492c-0.457,0.723-0.238,1.68,0.488,2.129 c0.731,0.457,1.68,0.238,2.133-0.488C775.281,851.578,775.066,850.625,774.348,850.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M772.43,848.977c0.269-0.422,0.144-0.984-0.285-1.258c-0.426-0.262-0.984-0.137-1.258,0.289 c-0.262,0.43-0.133,0.992,0.293,1.262C771.609,849.531,772.168,849.406,772.43,848.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.004,853.574c0.269,0.168,0.629,0.086,0.805-0.184c0.168-0.273,0.078-0.637-0.195-0.805 c-0.262-0.168-0.633-0.09-0.793,0.188C769.644,853.039,769.727,853.402,770.004,853.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M769.406,841.148c0.629-0.055,1.09-0.609,1.023-1.238c-0.051-0.629-0.606-1.086-1.227-1.027 c-0.625,0.047-1.094,0.602-1.031,1.227C768.23,840.738,768.781,841.207,769.406,841.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.824,838.418c-0.367,0.031-0.637,0.355-0.609,0.723 c0.035,0.375,0.355,0.648,0.734,0.609c0.363-0.031,0.633-0.363,0.606-0.723 C767.527,838.656,767.195,838.383,766.824,838.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M768.559,842.34c-0.023-0.238-0.223-0.41-0.469-0.391c-0.234,0.016-0.418,0.23-0.383,0.465 c0.012,0.234,0.227,0.41,0.465,0.391C768.406,842.781,768.578,842.574,768.559,842.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.91,842.953c-0.625,0.066-1.082,0.609-1.035,1.238c0.059,0.625,0.621,1.094,1.238,1.035 c0.633-0.059,1.098-0.606,1.039-1.238C778.098,843.363,777.543,842.902,776.91,842.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M774.543,842.496c-0.367,0.035-0.645,0.359-0.609,0.731c0.027,0.363,0.355,0.644,0.73,0.605 c0.363-0.031,0.637-0.355,0.609-0.726C775.227,842.731,774.902,842.461,774.543,842.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M775.875,846.883c0.238-0.02,0.41-0.227,0.402-0.461c-0.027-0.242-0.242-0.406-0.473-0.387 c-0.234,0.019-0.406,0.227-0.391,0.465C775.438,846.734,775.641,846.902,775.875,846.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.644,835.977h-0.809c-0.059,0.019-0.105,0.039-0.164,0.078 c-0.543,0.324-0.73,1.016-0.41,1.555c0.316,0.551,1.02,0.727,1.559,0.41c0.535-0.316,0.727-1.012,0.41-1.555 C777.09,836.227,776.879,836.07,776.644,835.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M775.863,839.965c0.191,0.316,0.602,0.418,0.918,0.231c0.324-0.184,0.43-0.598,0.238-0.914 c-0.191-0.316-0.605-0.426-0.926-0.242C775.777,839.227,775.672,839.641,775.863,839.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M779.254,836.875c-0.113-0.211-0.383-0.273-0.586-0.156 c-0.203,0.121-0.274,0.383-0.152,0.586c0.117,0.203,0.375,0.27,0.586,0.156 C779.305,837.336,779.375,837.074,779.254,836.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M764.477,836.25c0.031,0.629,0.57,1.113,1.199,1.078c0.625-0.035,1.113-0.566,1.07-1.199 c0-0.055-0.012-0.102-0.02-0.152H764.5C764.48,836.07,764.477,836.16,764.477,836.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M764.566,837.914c-0.375,0.019-0.656,0.324-0.637,0.703c0.019,0.363,0.34,0.652,0.711,0.625 c0.367-0.019,0.645-0.332,0.625-0.707C765.25,838.172,764.93,837.887,764.566,837.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M767.953,837.879c0.238-0.02,0.422-0.215,0.41-0.449c-0.008-0.234-0.215-0.418-0.449-0.402 c-0.242,0.008-0.418,0.211-0.406,0.445C767.516,837.711,767.719,837.887,767.953,837.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M773.188,843.008c0.223-0.477,0.027-1.047-0.438-1.277 c-0.488-0.227-1.043-0.027-1.273,0.445c-0.23,0.469-0.039,1.043,0.438,1.266 C772.387,843.668,772.961,843.477,773.188,843.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.879,843.422c-0.289-0.141-0.617-0.02-0.746,0.266 c-0.137,0.269-0.023,0.602,0.258,0.742c0.273,0.133,0.609,0.02,0.738-0.262 C771.262,843.891,771.16,843.555,770.879,843.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M773.195,844.285c-0.086,0.183-0.008,0.394,0.172,0.477c0.176,0.094,0.391,0.016,0.473-0.16 c0.086-0.18,0.016-0.391-0.164-0.477C773.5,844.031,773.289,844.106,773.195,844.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M781.336,850.949c0.629-0.047,1.098-0.598,1.031-1.227 c-0.051-0.629-0.606-1.094-1.231-1.039c-0.621,0.059-1.086,0.613-1.031,1.242 C780.168,850.547,780.715,851.008,781.336,850.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M778.883,849.563c0.363-0.031,0.637-0.363,0.609-0.727 c-0.031-0.371-0.363-0.644-0.731-0.609c-0.367,0.039-0.641,0.363-0.609,0.73 C778.184,849.328,778.508,849.59,778.883,849.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M780.027,851.762c-0.242,0.019-0.41,0.227-0.391,0.461c0.02,0.234,0.219,0.406,0.469,0.387 c0.234-0.02,0.41-0.227,0.391-0.461C780.469,851.914,780.266,851.742,780.027,851.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M781.137,839.254c0.055,0.625,0.613,1.094,1.231,1.035c0.637-0.055,1.094-0.609,1.047-1.231 c-0.063-0.637-0.621-1.09-1.242-1.039C781.551,838.074,781.086,838.629,781.137,839.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M779.793,837.555c-0.359,0.039-0.645,0.363-0.613,0.734c0.039,0.367,0.359,0.637,0.73,0.605 c0.367-0.027,0.645-0.359,0.613-0.73C780.484,837.801,780.168,837.527,779.793,837.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M781.133,841.945c0.238-0.023,0.406-0.227,0.395-0.469 c-0.027-0.231-0.234-0.406-0.469-0.383c-0.242,0.02-0.402,0.223-0.395,0.457 C780.691,841.797,780.902,841.965,781.133,841.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M782.016,843.758c-0.23,0.469-0.031,1.039,0.438,1.273c0.469,0.223,1.043,0.027,1.266-0.449 c0.23-0.469,0.031-1.043-0.438-1.266C782.809,843.086,782.238,843.281,782.016,843.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M781.41,844.996c-0.277-0.125-0.613-0.008-0.75,0.27c-0.133,0.277-0.016,0.609,0.262,0.742 c0.281,0.133,0.617,0.019,0.746-0.258C781.809,845.465,781.684,845.137,781.41,844.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M783.738,845.867c-0.09,0.18-0.02,0.395,0.168,0.484c0.176,0.082,0.391,0.004,0.48-0.172 c0.078-0.176,0.004-0.391-0.168-0.477C784.031,845.613,783.816,845.691,783.738,845.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M787.137,847.758c-0.625,0.09-1.047,0.672-0.965,1.285c0.09,0.625,0.668,1.055,1.289,0.965 c0.625-0.086,1.059-0.676,0.957-1.293C788.34,848.094,787.766,847.668,787.137,847.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M788.758,846.316c-0.059-0.359-0.398-0.617-0.769-0.566 c-0.367,0.055-0.613,0.391-0.566,0.762c0.055,0.371,0.402,0.613,0.762,0.566 C788.547,847.023,788.801,846.688,788.758,846.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M784.813,847.418c-0.234,0.039-0.394,0.258-0.367,0.488 c0.035,0.231,0.258,0.398,0.488,0.359c0.234-0.035,0.394-0.242,0.363-0.477 C785.262,847.543,785.047,847.387,784.813,847.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M784.227,855.574c-0.086-0.613-0.672-1.055-1.285-0.957 c-0.625,0.09-1.059,0.668-0.965,1.289c0.094,0.625,0.672,1.051,1.289,0.969 C783.891,856.773,784.324,856.195,784.227,855.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M784.555,853.176c-0.055-0.359-0.395-0.617-0.766-0.566 c-0.359,0.059-0.613,0.395-0.563,0.762c0.055,0.367,0.395,0.625,0.762,0.57S784.613,853.543,784.555,853.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M780.613,854.277c-0.234,0.039-0.395,0.254-0.356,0.488 c0.027,0.234,0.246,0.398,0.477,0.359c0.238-0.027,0.398-0.25,0.371-0.488 C781.059,854.414,780.852,854.242,780.613,854.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M788.398,855.301c0.203-0.488-0.019-1.043-0.508-1.246c-0.488-0.195-1.043,0.031-1.246,0.52 c-0.195,0.484,0.027,1.039,0.516,1.238C787.641,856.016,788.203,855.789,788.398,855.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M786.613,853.527c0.113-0.289-0.027-0.613-0.305-0.727 c-0.289-0.121-0.621,0.016-0.731,0.297c-0.125,0.285,0.012,0.613,0.305,0.73 C786.164,853.945,786.488,853.809,786.613,853.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M785.602,856.566c0.18,0.074,0.395-0.016,0.469-0.203c0.078-0.176-0.012-0.387-0.195-0.457 c-0.188-0.078-0.387,0-0.461,0.188C785.332,856.273,785.414,856.484,785.602,856.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M772.074,870.117c-0.719-0.453-1.676-0.23-2.121,0.492 c-0.461,0.727-0.234,1.676,0.477,2.133c0.734,0.453,1.684,0.234,2.144-0.492 C773.031,871.523,772.801,870.574,772.074,870.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.168,868.922c0.262-0.422,0.144-0.984-0.285-1.246c-0.43-0.27-0.984-0.141-1.258,0.289 c-0.262,0.422-0.137,0.981,0.293,1.25C769.348,869.477,769.902,869.352,770.168,868.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M768.539,873.336c0.172-0.266,0.086-0.637-0.184-0.797c-0.273-0.172-0.625-0.094-0.801,0.18 c-0.172,0.266-0.082,0.629,0.18,0.809C768.016,873.699,768.363,873.606,768.539,873.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.809,867.91c-0.488-0.703-1.457-0.871-2.148-0.387 c-0.711,0.488-0.875,1.449-0.391,2.148c0.488,0.707,1.453,0.879,2.149,0.391 C767.117,869.582,767.297,868.609,766.809,867.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M765.523,866.066c0.41-0.289,0.512-0.856,0.231-1.27c-0.289-0.41-0.859-0.512-1.273-0.23 c-0.41,0.289-0.512,0.859-0.223,1.266C764.543,866.25,765.117,866.352,765.523,866.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M762.281,869.477c0.266-0.184,0.34-0.543,0.156-0.809c-0.184-0.258-0.543-0.328-0.816-0.145 c-0.262,0.18-0.332,0.547-0.141,0.813C761.66,869.602,762.023,869.664,762.281,869.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.949,858.824c-0.637,0.063-1.094,0.609-1.035,1.23c0.047,0.629,0.609,1.094,1.227,1.039 c0.625-0.055,1.098-0.609,1.039-1.227C768.109,859.231,767.57,858.769,766.949,858.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M764.566,858.363c-0.375,0.031-0.645,0.363-0.606,0.727 c0.027,0.371,0.356,0.645,0.719,0.609c0.367-0.035,0.644-0.356,0.605-0.727 C765.254,858.598,764.93,858.332,764.566,858.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.293,862.281c-0.024-0.234-0.231-0.402-0.465-0.383c-0.23,0.02-0.414,0.223-0.387,0.457 c0.012,0.242,0.227,0.414,0.461,0.394C766.141,862.727,766.313,862.519,766.293,862.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.281,863.328c-0.063-0.633-0.609-1.094-1.242-1.031 c-0.621,0.047-1.082,0.605-1.035,1.227c0.059,0.625,0.621,1.086,1.25,1.035 C775.867,864.504,776.336,863.949,776.281,863.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M772.66,861.828c-0.359,0.035-0.633,0.363-0.605,0.727c0.039,0.375,0.359,0.645,0.727,0.609 c0.375-0.027,0.648-0.359,0.609-0.727C773.355,862.066,773.035,861.801,772.66,861.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M773.926,865.367c-0.227,0.02-0.402,0.223-0.383,0.465c0.016,0.234,0.226,0.406,0.461,0.387 c0.238-0.023,0.414-0.23,0.391-0.469C774.379,865.512,774.168,865.344,773.926,865.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M774.563,857.969c0.539-0.32,0.719-1.016,0.402-1.563c-0.316-0.531-1.02-0.727-1.555-0.402 c-0.539,0.316-0.73,1.016-0.402,1.559C773.316,858.106,774.016,858.289,774.563,857.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M774.75,859.223c-0.18-0.317-0.59-0.418-0.91-0.234c-0.316,0.191-0.43,0.602-0.242,0.922 c0.188,0.313,0.598,0.422,0.918,0.234C774.832,859.957,774.941,859.551,774.75,859.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.258,857.254c0.117,0.203,0.379,0.277,0.582,0.152c0.199-0.117,0.273-0.387,0.156-0.586 c-0.125-0.203-0.391-0.273-0.582-0.152C776.207,856.785,776.133,857.055,776.258,857.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M766.746,853.66c0.629-0.055,1.086-0.609,1.039-1.242c-0.055-0.621-0.609-1.082-1.234-1.031 c-0.625,0.051-1.098,0.609-1.039,1.234C765.566,853.25,766.121,853.711,766.746,853.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M764.894,851.539c-0.027-0.375-0.359-0.637-0.723-0.613 c-0.375,0.035-0.637,0.359-0.605,0.73c0.027,0.367,0.355,0.645,0.723,0.606C764.66,852.231,764.93,851.906,764.894,851.539 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M765.434,854.457c-0.238,0.02-0.414,0.234-0.387,0.465c0.02,0.242,0.227,0.414,0.461,0.395 c0.234-0.02,0.41-0.234,0.387-0.469C765.875,854.613,765.668,854.441,765.434,854.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M769.719,854.891c-0.477-0.223-1.039-0.023-1.277,0.449 c-0.231,0.469-0.027,1.043,0.449,1.266c0.473,0.234,1.043,0.035,1.277-0.438 C770.391,855.699,770.195,855.125,769.719,854.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M767.844,856.586c-0.274-0.129-0.606-0.019-0.746,0.254 c-0.129,0.289-0.02,0.617,0.258,0.754c0.277,0.133,0.617,0.016,0.746-0.258 C768.238,857.055,768.121,856.719,767.844,856.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M770.168,857.449c-0.086,0.18,0,0.391,0.168,0.48c0.188,0.09,0.395,0.008,0.477-0.164 c0.094-0.18,0.008-0.395-0.16-0.477C770.473,857.199,770.262,857.269,770.168,857.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M769.207,862.121c-0.227,0.477-0.031,1.043,0.441,1.273 c0.484,0.223,1.055,0.027,1.273-0.445c0.238-0.473,0.039-1.043-0.438-1.266 C770.012,861.449,769.434,861.652,769.207,862.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M767.867,863.633c-0.137,0.273-0.023,0.602,0.254,0.746c0.285,0.133,0.617,0.012,0.75-0.266 c0.137-0.273,0.019-0.609-0.258-0.746C768.336,863.231,768.004,863.356,767.867,863.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M771.578,864.547c0.09-0.18,0.012-0.391-0.16-0.477c-0.184-0.086-0.399-0.012-0.477,0.164 c-0.094,0.176-0.02,0.391,0.16,0.48C771.277,864.797,771.492,864.727,771.578,864.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M780.656,867.473c-0.055-0.625-0.613-1.09-1.234-1.035 c-0.633,0.051-1.086,0.621-1.035,1.238c0.051,0.629,0.609,1.086,1.234,1.031 C780.246,868.656,780.715,868.098,780.656,867.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M777.039,865.981c-0.363,0.027-0.637,0.359-0.609,0.723 c0.047,0.375,0.363,0.641,0.734,0.613c0.367-0.035,0.633-0.363,0.602-0.727 C777.738,866.219,777.406,865.941,777.039,865.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M778.301,869.516c-0.231,0.02-0.406,0.227-0.383,0.469c0.019,0.234,0.234,0.398,0.469,0.387 c0.238-0.027,0.402-0.23,0.387-0.469C778.75,869.664,778.547,869.492,778.301,869.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M784.418,870.219c-0.629,0.059-1.094,0.613-1.039,1.242 c0.055,0.629,0.609,1.078,1.242,1.027c0.625-0.051,1.086-0.602,1.027-1.23S785.047,870.16,784.418,870.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M782.043,869.762c-0.375,0.035-0.649,0.359-0.617,0.73c0.039,0.359,0.363,0.633,0.73,0.606 c0.375-0.039,0.637-0.359,0.609-0.727C782.734,870.004,782.406,869.727,782.043,869.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M783.769,873.688c-0.019-0.242-0.23-0.41-0.469-0.391c-0.234,0.02-0.41,0.23-0.391,0.465 c0.031,0.234,0.234,0.402,0.469,0.394C783.613,874.121,783.789,873.922,783.769,873.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M779.273,853.238c-0.055-0.629-0.617-1.086-1.234-1.035 c-0.633,0.066-1.086,0.617-1.039,1.242c0.055,0.629,0.609,1.086,1.234,1.031 C778.863,854.418,779.32,853.867,779.273,853.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M775.059,852.481c0.031,0.359,0.352,0.637,0.715,0.601c0.371-0.031,0.641-0.359,0.609-0.723 c-0.035-0.371-0.359-0.645-0.727-0.617C775.293,851.781,775.019,852.109,775.059,852.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M776.996,856.137c0.234-0.02,0.41-0.231,0.379-0.465c-0.008-0.234-0.219-0.41-0.445-0.391 c-0.246,0.02-0.414,0.231-0.395,0.469C776.555,855.984,776.762,856.148,776.996,856.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M780.266,860.035c-0.059-0.621-0.609-1.086-1.242-1.031 c-0.625,0.059-1.086,0.613-1.031,1.238c0.059,0.621,0.609,1.09,1.242,1.035 C779.852,861.215,780.309,860.66,780.266,860.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M777.375,859.148c-0.027-0.363-0.356-0.637-0.731-0.602 c-0.363,0.027-0.637,0.359-0.609,0.723c0.039,0.371,0.359,0.641,0.734,0.609 C777.133,859.84,777.406,859.519,777.375,859.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M777.906,862.074c-0.238,0.023-0.402,0.23-0.379,0.465c0.02,0.234,0.23,0.41,0.465,0.391 c0.23-0.019,0.406-0.227,0.387-0.461C778.355,862.231,778.152,862.055,777.906,862.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M781.621,862.695c-0.484-0.234-1.047-0.031-1.273,0.441 c-0.234,0.469-0.039,1.039,0.441,1.262c0.477,0.231,1.039,0.043,1.27-0.426 C782.289,863.484,782.09,862.922,781.621,862.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M779.75,864.383c-0.281-0.137-0.621-0.02-0.754,0.262c-0.137,0.274-0.012,0.609,0.258,0.742 c0.281,0.129,0.617,0.023,0.754-0.254C780.133,864.852,780.016,864.519,779.75,864.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M782.715,865.555c0.09-0.168,0.012-0.383-0.164-0.477c-0.184-0.082-0.395-0.008-0.481,0.168 c-0.086,0.184-0.012,0.398,0.16,0.481C782.414,865.816,782.625,865.738,782.715,865.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M787.219,891.266c-0.477,0.223-0.676,0.793-0.445,1.266c0.231,0.469,0.801,0.668,1.27,0.445 c0.476-0.234,0.676-0.793,0.445-1.273C788.258,891.227,787.691,891.031,787.219,891.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M786.438,890.547c-0.141-0.285-0.477-0.406-0.758-0.27 c-0.266,0.141-0.383,0.473-0.254,0.746c0.137,0.281,0.477,0.398,0.746,0.262 C786.453,891.152,786.566,890.816,786.438,890.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.148,890.106c-0.09-0.176-0.313-0.254-0.477-0.164 c-0.184,0.086-0.262,0.297-0.172,0.477c0.086,0.18,0.301,0.258,0.477,0.168 C789.148,890.496,789.227,890.285,789.148,890.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M793.617,844.863c-0.449-0.73-1.406-0.949-2.133-0.496c-0.719,0.449-0.941,1.41-0.484,2.141 c0.449,0.719,1.406,0.938,2.129,0.484C793.848,846.539,794.074,845.586,793.617,844.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.961,847.894c-0.422,0.27-0.551,0.828-0.285,1.254c0.266,0.426,0.828,0.559,1.25,0.285 c0.43-0.262,0.559-0.824,0.289-1.25C790.949,847.758,790.391,847.633,789.961,847.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M788.602,844.391c0.172,0.273,0.527,0.348,0.805,0.191c0.27-0.176,0.355-0.531,0.18-0.809 c-0.172-0.269-0.527-0.352-0.797-0.184C788.516,843.762,788.426,844.113,788.602,844.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M796.094,854.824c0.625,0.051,1.176-0.41,1.234-1.039c0.059-0.625-0.41-1.176-1.027-1.238 c-0.633-0.051-1.195,0.414-1.242,1.039C795.004,854.211,795.461,854.766,796.094,854.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M794.438,854.672c0.031-0.363-0.234-0.691-0.602-0.727 c-0.375-0.027-0.691,0.238-0.727,0.609c-0.035,0.367,0.238,0.695,0.602,0.727 C794.082,855.309,794.398,855.043,794.438,854.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M795.445,851.359c0.016-0.234-0.16-0.445-0.387-0.465c-0.246-0.019-0.449,0.149-0.473,0.391 c-0.027,0.234,0.156,0.438,0.395,0.457C795.207,851.762,795.422,851.594,795.445,851.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M795.609,859.141c-0.543-0.316-1.242-0.133-1.559,0.41 c-0.313,0.539-0.145,1.242,0.406,1.559c0.543,0.309,1.238,0.141,1.551-0.41 C796.328,860.156,796.144,859.461,795.609,859.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M794.887,858.121c0.316,0.184,0.731,0.082,0.918-0.242c0.188-0.316,0.082-0.731-0.242-0.914 c-0.316-0.191-0.723-0.074-0.914,0.234C794.457,857.523,794.559,857.938,794.887,858.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M797.449,860.445c0.207,0.117,0.469,0.051,0.59-0.156c0.121-0.199,0.055-0.469-0.156-0.586 c-0.199-0.113-0.461-0.051-0.586,0.148C797.188,860.055,797.258,860.328,797.449,860.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.035,860.504c0.23,0.477,0.793,0.672,1.273,0.445c0.465-0.231,0.672-0.793,0.438-1.27 c-0.223-0.473-0.793-0.668-1.266-0.441C789.008,859.461,788.805,860.035,789.035,860.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M788.699,858.516c-0.133-0.281-0.469-0.395-0.75-0.258 c-0.273,0.125-0.394,0.469-0.258,0.746c0.133,0.273,0.461,0.398,0.746,0.258 C788.719,859.129,788.832,858.789,788.699,858.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.41,858.082c-0.094-0.176-0.305-0.254-0.484-0.164c-0.18,0.082-0.25,0.297-0.16,0.476 c0.082,0.176,0.293,0.25,0.477,0.172C791.414,858.481,791.496,858.262,791.41,858.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.973,854.16c-0.227-0.473-0.797-0.668-1.27-0.442c-0.484,0.227-0.672,0.793-0.445,1.27 c0.219,0.469,0.801,0.672,1.273,0.438C792.004,855.203,792.203,854.633,791.973,854.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.922,852.996c-0.141-0.277-0.473-0.394-0.746-0.258 c-0.281,0.137-0.398,0.461-0.262,0.738c0.133,0.289,0.469,0.402,0.75,0.266 C789.934,853.606,790.055,853.273,789.922,852.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M792.148,852.398c-0.176,0.086-0.254,0.301-0.16,0.477c0.082,0.176,0.301,0.254,0.477,0.164 c0.176-0.078,0.254-0.297,0.172-0.477C792.539,852.383,792.328,852.313,792.148,852.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M787.531,840.023c-0.227-0.473-0.797-0.676-1.27-0.445c-0.48,0.23-0.672,0.793-0.441,1.266 c0.219,0.473,0.793,0.672,1.27,0.445C787.563,841.059,787.766,840.496,787.531,840.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M784.723,838.59c-0.273,0.137-0.383,0.477-0.258,0.75c0.141,0.277,0.473,0.398,0.758,0.258 c0.27-0.133,0.387-0.469,0.262-0.742C785.344,838.578,785.008,838.457,784.723,838.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M788.184,838.422c-0.082-0.184-0.293-0.258-0.477-0.164 c-0.176,0.078-0.254,0.293-0.168,0.473c0.094,0.18,0.305,0.254,0.488,0.172 C788.203,838.813,788.281,838.606,788.184,838.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M798.961,842.856c-0.457-0.723-1.41-0.941-2.129-0.484c-0.738,0.445-0.949,1.402-0.5,2.129 c0.453,0.727,1.41,0.941,2.141,0.488C799.188,844.535,799.414,843.578,798.961,842.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M796.563,846.18c-0.262-0.43-0.828-0.555-1.262-0.285c-0.418,0.262-0.551,0.828-0.281,1.25 c0.266,0.43,0.824,0.559,1.246,0.289C796.691,847.168,796.832,846.606,796.563,846.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M794.926,841.766c-0.164-0.273-0.531-0.352-0.805-0.176c-0.266,0.16-0.344,0.531-0.18,0.793 c0.172,0.273,0.527,0.359,0.801,0.191C795.019,842.402,795.102,842.039,794.926,841.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M795.875,839.418c0.199-0.828-0.313-1.668-1.133-1.867 c-0.836-0.207-1.668,0.309-1.871,1.133c-0.207,0.832,0.301,1.668,1.129,1.875 C794.828,840.758,795.668,840.25,795.875,839.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.816,840.023c0.129-0.492-0.184-0.984-0.668-1.109 c-0.484-0.121-0.977,0.188-1.094,0.676c-0.129,0.484,0.164,0.977,0.66,1.094 C791.203,840.801,791.699,840.508,791.816,840.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M792.82,835.977c0.07,0.109,0.176,0.191,0.324,0.219c0.227,0.055,0.473-0.031,0.602-0.219 H792.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.789,839.441c0.457-0.719,0.234-1.68-0.488-2.133c-0.731-0.453-1.68-0.234-2.137,0.492 c-0.449,0.719-0.234,1.676,0.496,2.133C801.387,840.383,802.332,840.168,802.789,839.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M801.879,842.606c0.273-0.426,0.141-0.984-0.277-1.258c-0.43-0.266-0.996-0.137-1.258,0.285 c-0.27,0.426-0.152,0.992,0.277,1.258C801.051,843.156,801.621,843.027,801.879,842.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M797.394,838.277c-0.16,0.273-0.086,0.629,0.188,0.801c0.273,0.176,0.633,0.086,0.805-0.184 c0.164-0.269,0.09-0.633-0.188-0.801C797.938,837.922,797.578,838,797.394,838.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M801.703,849.641c0.059-0.629-0.414-1.184-1.039-1.238c-0.617-0.059-1.18,0.41-1.234,1.031 c-0.051,0.629,0.414,1.18,1.031,1.238C801.094,850.727,801.641,850.262,801.703,849.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M798.824,850.519c0.027-0.363-0.25-0.695-0.621-0.723c-0.363-0.031-0.691,0.238-0.723,0.605 c-0.031,0.367,0.23,0.699,0.613,0.734C798.465,851.164,798.781,850.894,798.824,850.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M799.355,847.602c0.234,0.019,0.441-0.156,0.461-0.395c0.027-0.226-0.148-0.441-0.387-0.457 c-0.234-0.023-0.441,0.152-0.465,0.387C798.941,847.367,799.121,847.574,799.355,847.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.672,863.606c0.055-0.621-0.41-1.176-1.031-1.231c-0.621-0.059-1.18,0.398-1.234,1.027 c-0.055,0.629,0.406,1.18,1.035,1.242C802.07,864.695,802.625,864.234,802.672,863.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M799.797,864.492c0.031-0.363-0.254-0.691-0.617-0.723 c-0.371-0.031-0.691,0.234-0.723,0.598c-0.031,0.375,0.246,0.703,0.609,0.731 C799.43,865.133,799.769,864.863,799.797,864.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M800.797,861.176c0.016-0.234-0.16-0.438-0.395-0.461c-0.238-0.027-0.445,0.148-0.469,0.387 c-0.008,0.234,0.16,0.445,0.398,0.469C800.563,861.59,800.773,861.41,800.797,861.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M801.309,857.074c0.047-0.625-0.41-1.18-1.031-1.234c-0.629-0.063-1.18,0.406-1.246,1.035 c-0.051,0.629,0.41,1.172,1.043,1.231C800.695,858.16,801.254,857.699,801.309,857.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M798.418,857.961c0.039-0.371-0.234-0.703-0.609-0.73c-0.359-0.031-0.691,0.242-0.719,0.609 c-0.031,0.375,0.238,0.695,0.602,0.727C798.07,858.594,798.387,858.332,798.418,857.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M799.422,854.648c0.02-0.234-0.156-0.449-0.391-0.465c-0.23-0.023-0.441,0.152-0.461,0.391 c-0.023,0.234,0.152,0.438,0.391,0.465C799.195,855.059,799.41,854.883,799.422,854.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M803.102,853.148c-0.23-0.469-0.789-0.668-1.266-0.445c-0.48,0.234-0.664,0.801-0.449,1.273 c0.234,0.473,0.805,0.672,1.277,0.441C803.141,854.191,803.332,853.621,803.102,853.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M801.051,851.988c-0.133-0.285-0.469-0.406-0.746-0.266 c-0.281,0.133-0.398,0.469-0.258,0.746c0.125,0.285,0.469,0.391,0.746,0.266 C801.059,852.59,801.188,852.262,801.051,851.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M803.281,851.383c-0.172,0.09-0.25,0.301-0.164,0.477c0.066,0.152,0.223,0.215,0.375,0.195 v-0.695C803.418,851.348,803.344,851.356,803.281,851.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M790.801,888.098c-0.727,0.453-0.941,1.406-0.492,2.137c0.457,0.719,1.406,0.938,2.129,0.48 c0.719-0.449,0.938-1.402,0.492-2.125C792.48,887.867,791.523,887.644,790.801,888.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M790.531,891.91c-0.273-0.422-0.832-0.551-1.258-0.289c-0.43,0.27-0.543,0.84-0.281,1.254 c0.262,0.426,0.816,0.559,1.25,0.293C790.668,892.902,790.801,892.34,790.531,891.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M788.719,888.305c0.273-0.172,0.348-0.527,0.184-0.805c-0.172-0.269-0.523-0.352-0.801-0.18 c-0.27,0.172-0.355,0.527-0.191,0.797C788.086,888.391,788.445,888.481,788.719,888.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M798.906,883.422c-0.449-0.73-1.406-0.953-2.137-0.496 c-0.715,0.457-0.945,1.414-0.488,2.133c0.457,0.723,1.402,0.945,2.133,0.492 C799.141,885.094,799.355,884.137,798.906,883.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M796.5,886.746c-0.258-0.43-0.824-0.559-1.254-0.289c-0.426,0.262-0.543,0.824-0.277,1.254 c0.266,0.422,0.824,0.555,1.254,0.289C796.644,887.731,796.769,887.168,796.5,886.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M794.078,882.144c-0.281,0.176-0.359,0.527-0.191,0.809c0.168,0.27,0.531,0.348,0.805,0.176 c0.277-0.164,0.352-0.523,0.18-0.797C794.703,882.063,794.34,881.977,794.078,882.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M793.473,894.574c-0.621-0.055-1.172,0.414-1.227,1.031 c-0.063,0.625,0.406,1.188,1.023,1.234c0.633,0.059,1.188-0.406,1.242-1.031 C794.559,895.184,794.102,894.629,793.473,894.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.621,896.695c0.039-0.371-0.238-0.695-0.602-0.734c-0.371-0.027-0.703,0.246-0.73,0.617 c-0.039,0.367,0.242,0.691,0.609,0.723C791.273,897.336,791.594,897.07,791.621,896.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M792.16,893.766c0.242,0.023,0.438-0.152,0.465-0.387c0.027-0.231-0.156-0.441-0.387-0.461 c-0.234-0.024-0.445,0.144-0.465,0.383C791.754,893.547,791.926,893.75,792.16,893.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.613,892.344c0.055-0.629-0.41-1.183-1.035-1.238c-0.621-0.051-1.188,0.402-1.234,1.031 c-0.055,0.629,0.41,1.184,1.031,1.238C802.004,893.43,802.555,892.973,802.613,892.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M799.727,893.227c0.043-0.363-0.242-0.695-0.605-0.719 c-0.375-0.039-0.695,0.234-0.727,0.609c-0.039,0.359,0.234,0.684,0.598,0.723 C799.371,893.871,799.695,893.602,799.727,893.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M799.875,889.832c-0.02,0.246,0.156,0.449,0.391,0.465c0.238,0.023,0.438-0.145,0.469-0.379 c0.02-0.238-0.156-0.449-0.391-0.465C800.105,889.434,799.898,889.606,799.875,889.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M800.898,897.707c-0.547-0.32-1.223-0.144-1.543,0.379h1.922 C801.188,897.93,801.055,897.793,800.898,897.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M800.172,896.676c0.324,0.191,0.727,0.078,0.922-0.242c0.184-0.316,0.078-0.73-0.242-0.914 c-0.316-0.184-0.73-0.082-0.922,0.238C799.75,896.078,799.855,896.488,800.172,896.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.336,897.18c0.016-0.371-0.262-0.688-0.625-0.707c-0.371-0.02-0.684,0.266-0.715,0.637 c-0.02,0.363,0.266,0.684,0.637,0.703C788.996,897.832,789.316,897.547,789.336,897.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M792.031,897.844c-0.176-0.012-0.34,0.086-0.41,0.242h0.762 C792.32,897.949,792.191,897.848,792.031,897.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M797.266,892.719c-0.234-0.469-0.805-0.668-1.273-0.445 c-0.477,0.234-0.676,0.797-0.449,1.273c0.23,0.477,0.801,0.66,1.273,0.438 C797.289,893.762,797.492,893.191,797.266,892.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M795.203,891.547c-0.137-0.27-0.461-0.387-0.746-0.258c-0.281,0.133-0.394,0.473-0.266,0.75 c0.144,0.273,0.473,0.394,0.754,0.262C795.227,892.164,795.336,891.832,795.203,891.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M797.441,890.953c-0.176,0.09-0.254,0.305-0.172,0.48c0.082,0.172,0.309,0.246,0.477,0.16 c0.18-0.086,0.254-0.289,0.172-0.469C797.836,890.941,797.609,890.867,797.441,890.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.769,888.957c-0.039,0.371,0.242,0.703,0.606,0.731 c0.035,0.004,0.078-0.008,0.117-0.016v-1.313C803.121,888.328,802.805,888.598,802.769,888.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.375,896.402c-0.035,0.363,0.238,0.688,0.609,0.727 c0.191,0.012,0.367-0.055,0.508-0.184v-0.973c-0.113-0.098-0.246-0.172-0.391-0.184 C802.727,895.754,802.41,896.027,802.375,896.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M796.644,863.465c-0.453-0.719-1.41-0.938-2.133-0.484c-0.727,0.445-0.945,1.406-0.5,2.121 c0.457,0.73,1.41,0.945,2.141,0.5C796.875,865.152,797.094,864.188,796.644,863.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M792.699,867.762c0.27,0.426,0.832,0.551,1.254,0.289c0.426-0.273,0.559-0.832,0.289-1.254 c-0.27-0.426-0.828-0.559-1.254-0.289C792.563,866.769,792.438,867.328,792.699,867.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.813,862.199c-0.273,0.164-0.356,0.527-0.191,0.801 c0.172,0.269,0.527,0.359,0.809,0.184c0.266-0.172,0.348-0.531,0.176-0.801 C792.441,862.106,792.086,862.027,791.813,862.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M790.488,865.652c-0.699-0.48-1.664-0.316-2.148,0.387 c-0.488,0.699-0.313,1.664,0.391,2.156c0.695,0.484,1.66,0.313,2.148-0.387 C791.363,867.106,791.195,866.141,790.488,865.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.598,869.652c-0.414-0.281-0.992-0.184-1.27,0.231c-0.285,0.41-0.188,0.973,0.231,1.269 c0.41,0.285,0.973,0.184,1.262-0.23C790.113,870.508,790,869.941,789.598,869.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M786.359,866.238c-0.266-0.18-0.629-0.117-0.813,0.145 c-0.184,0.269-0.113,0.621,0.141,0.816c0.273,0.18,0.633,0.117,0.82-0.141C786.688,866.789,786.613,866.43,786.359,866.238 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.215,874.625c-0.625-0.055-1.184,0.402-1.234,1.035c-0.055,0.629,0.41,1.18,1.039,1.234 c0.613,0.059,1.172-0.41,1.227-1.039C792.305,875.231,791.844,874.68,791.215,874.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.363,876.746c0.027-0.363-0.234-0.695-0.606-0.73c-0.375-0.027-0.691,0.246-0.73,0.613 c-0.031,0.371,0.234,0.688,0.605,0.723C788.996,877.391,789.324,877.113,789.363,876.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.902,873.82c0.23,0.023,0.445-0.152,0.469-0.387c0.008-0.238-0.16-0.449-0.391-0.469 c-0.242-0.019-0.449,0.152-0.473,0.391C789.492,873.59,789.664,873.801,789.902,873.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M799.32,871.152c-0.629-0.047-1.188,0.418-1.238,1.039c-0.051,0.629,0.406,1.18,1.039,1.238 c0.617,0.055,1.168-0.406,1.227-1.039C800.402,871.769,799.945,871.219,799.32,871.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M797.461,873.277c0.039-0.363-0.234-0.688-0.609-0.73c-0.367-0.027-0.688,0.246-0.719,0.609 c-0.039,0.375,0.238,0.703,0.606,0.731C797.105,873.922,797.426,873.648,797.461,873.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M798.473,869.977c0.016-0.25-0.16-0.449-0.398-0.469c-0.234-0.031-0.438,0.144-0.465,0.379 c-0.012,0.238,0.156,0.449,0.395,0.473C798.234,870.375,798.449,870.199,798.473,869.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M798.629,877.75c-0.535-0.316-1.238-0.137-1.555,0.406 c-0.324,0.543-0.141,1.242,0.406,1.563c0.543,0.317,1.242,0.133,1.551-0.41 C799.355,878.773,799.168,878.074,798.629,877.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M798.578,875.574c-0.305-0.191-0.715-0.082-0.906,0.234 c-0.18,0.324-0.086,0.734,0.234,0.926c0.324,0.18,0.738,0.07,0.926-0.25C799.008,876.172,798.906,875.754,798.578,875.574z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M800.48,879.051c0.203,0.117,0.469,0.051,0.578-0.148c0.129-0.211,0.059-0.469-0.148-0.586 c-0.207-0.125-0.469-0.059-0.586,0.144C800.207,878.672,800.277,878.934,800.48,879.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.586,883.09c-0.055,0.629,0.406,1.18,1.031,1.238c0.625,0.059,1.176-0.402,1.238-1.039 c0.059-0.621-0.406-1.172-1.035-1.227C790.191,882.008,789.641,882.469,789.586,883.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M788.969,884.188c0.027-0.371-0.238-0.695-0.609-0.731 c-0.371-0.035-0.699,0.238-0.727,0.602c-0.031,0.371,0.238,0.699,0.609,0.738 C788.602,884.832,788.934,884.551,788.969,884.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M789.973,880.867c0.02-0.23-0.164-0.441-0.387-0.465c-0.234-0.019-0.449,0.148-0.469,0.391 c-0.023,0.238,0.148,0.445,0.391,0.465C789.742,881.277,789.953,881.102,789.973,880.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M794.234,879.555c-0.234-0.473-0.805-0.672-1.277-0.445 c-0.469,0.23-0.668,0.797-0.438,1.273c0.231,0.469,0.797,0.668,1.27,0.438C794.262,880.59,794.457,880.027,794.234,879.555 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.164,878.871c0.141,0.277,0.469,0.398,0.75,0.258c0.277-0.129,0.391-0.461,0.266-0.738 c-0.137-0.289-0.481-0.395-0.742-0.266C791.148,878.258,791.039,878.594,791.164,878.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M794.715,878.434c0.184-0.082,0.262-0.297,0.172-0.477c-0.086-0.176-0.301-0.25-0.488-0.172 c-0.164,0.094-0.238,0.308-0.156,0.477C794.328,878.441,794.543,878.519,794.715,878.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M794.988,872.773c-0.219-0.48-0.785-0.684-1.266-0.449 c-0.477,0.234-0.668,0.797-0.434,1.277c0.223,0.473,0.793,0.664,1.266,0.438 C795.027,873.813,795.227,873.238,794.988,872.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M791.934,872.09c0.137,0.277,0.473,0.395,0.758,0.262c0.266-0.137,0.383-0.465,0.246-0.75 c-0.125-0.277-0.469-0.391-0.734-0.262C791.914,871.477,791.805,871.813,791.934,872.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M795.18,871.004c-0.18,0.086-0.262,0.301-0.168,0.48c0.086,0.176,0.293,0.25,0.473,0.168 c0.172-0.09,0.25-0.309,0.168-0.48C795.563,870.992,795.355,870.922,795.18,871.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.453,868.039c-0.047,0.629,0.41,1.18,1.039,1.234v-2.269 C802.949,867.063,802.508,867.484,802.453,868.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M801.836,869.133c0.027-0.375-0.234-0.691-0.605-0.723 c-0.367-0.043-0.691,0.238-0.723,0.602c-0.027,0.367,0.234,0.699,0.602,0.73 C801.48,869.769,801.805,869.508,801.836,869.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.844,865.816c0.02-0.234-0.152-0.441-0.391-0.461c-0.234-0.024-0.438,0.148-0.461,0.383 c-0.027,0.242,0.152,0.453,0.387,0.465C802.613,866.223,802.824,866.047,802.844,865.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M803.434,882.019c-0.016,0.156,0.008,0.313,0.059,0.457v-0.723 C803.461,881.84,803.441,881.922,803.434,882.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.824,883.094c0.027-0.363-0.25-0.691-0.613-0.719c-0.375-0.031-0.699,0.238-0.73,0.609 c-0.035,0.363,0.238,0.695,0.605,0.727C802.453,883.738,802.781,883.473,802.824,883.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M803.426,879.324c-0.238-0.023-0.441,0.152-0.465,0.387 c-0.019,0.234,0.156,0.445,0.391,0.465c0.047,0.012,0.09-0.008,0.141-0.02v-0.816 C803.473,879.336,803.453,879.324,803.426,879.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M803.301,874.449c-0.633-0.059-1.18,0.406-1.242,1.027c-0.055,0.629,0.41,1.18,1.031,1.242 c0.148,0.008,0.27-0.012,0.402-0.039v-2.199C803.426,874.469,803.359,874.453,803.301,874.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M801.445,876.563c0.027-0.367-0.234-0.688-0.609-0.723 c-0.367-0.031-0.691,0.246-0.723,0.613c-0.027,0.363,0.234,0.695,0.609,0.723 C801.086,877.211,801.414,876.934,801.445,876.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M802.445,873.258c0.023-0.242-0.152-0.445-0.387-0.465c-0.234-0.02-0.438,0.144-0.457,0.379 c-0.031,0.238,0.145,0.449,0.383,0.473C802.219,873.668,802.434,873.484,802.445,873.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M803.07,871.078c0.074,0.172,0.246,0.266,0.422,0.301v-1.086 c-0.059,0.008-0.113,0.008-0.16,0.039C803.047,870.461,802.93,870.797,803.07,871.078z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.531,898.086h2.406c0.207-0.266,0.34-0.594,0.34-0.957c0-0.859-0.691-1.551-1.543-1.551 c-0.801,0-1.449,0.598-1.535,1.375v0.344C680.238,897.59,680.352,897.863,680.531,898.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M685.84,889.227c-0.449,0.719-0.223,1.668,0.488,2.121c0.731,0.453,1.676,0.23,2.133-0.492 c0.457-0.719,0.238-1.676-0.492-2.133C687.242,888.273,686.297,888.488,685.84,889.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M684.523,886.566c-0.262,0.426-0.137,0.988,0.289,1.254 c0.426,0.269,0.988,0.137,1.254-0.285c0.262-0.43,0.133-0.988-0.289-1.258 C685.352,886.016,684.789,886.141,684.523,886.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M683.445,891.328c-0.168,0.273-0.086,0.629,0.18,0.797c0.281,0.176,0.641,0.098,0.801-0.188 c0.184-0.266,0.098-0.621-0.172-0.793C683.98,890.969,683.613,891.055,683.445,891.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M681.801,878.668c0.055,0.629,0.609,1.09,1.234,1.031c0.629-0.059,1.086-0.609,1.031-1.238 c-0.059-0.621-0.609-1.082-1.227-1.027C682.207,877.488,681.742,878.039,681.801,878.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M681.727,880.504c-0.242,0.019-0.414,0.23-0.395,0.461c0.02,0.242,0.227,0.41,0.461,0.391 c0.246-0.02,0.414-0.223,0.398-0.461C682.156,880.66,681.953,880.484,681.727,880.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M691.141,883.168c0.621-0.059,1.082-0.602,1.023-1.231 c-0.043-0.629-0.605-1.098-1.227-1.035c-0.629,0.051-1.094,0.606-1.035,1.234 C689.957,882.758,690.512,883.223,691.141,883.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M688.559,880.445c-0.371,0.027-0.633,0.348-0.606,0.715 c0.031,0.383,0.359,0.644,0.723,0.613c0.371-0.031,0.645-0.359,0.606-0.734C689.25,880.68,688.934,880.402,688.559,880.445 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M689.438,884.441c0.019,0.234,0.227,0.402,0.461,0.391c0.234-0.027,0.41-0.234,0.391-0.469 c-0.023-0.238-0.23-0.414-0.465-0.395C689.598,883.992,689.41,884.207,689.438,884.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M690.449,876.578c0.547-0.316,0.731-1.02,0.406-1.559c-0.316-0.547-1.012-0.726-1.555-0.406 c-0.543,0.316-0.727,1.012-0.406,1.559C689.219,876.719,689.902,876.894,690.449,876.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M689.727,877.594c-0.316,0.192-0.418,0.602-0.23,0.926c0.18,0.316,0.594,0.422,0.91,0.234 c0.332-0.195,0.433-0.598,0.242-0.914C690.461,877.523,690.055,877.41,689.727,877.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M692.301,875.277c-0.203,0.117-0.277,0.383-0.152,0.59c0.125,0.199,0.375,0.266,0.582,0.141 c0.207-0.113,0.281-0.383,0.156-0.574C692.758,875.227,692.504,875.16,692.301,875.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M682.441,869.996c-0.629,0.059-1.098,0.609-1.039,1.231 c0.063,0.629,0.613,1.098,1.246,1.035c0.621-0.055,1.082-0.606,1.023-1.234 C683.617,870.398,683.063,869.941,682.441,869.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.793,870.141c-0.027-0.316-0.281-0.551-0.594-0.586v1.309 C680.559,870.816,680.82,870.508,680.793,870.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.934,873.531c0.019,0.238,0.23,0.41,0.465,0.391c0.234-0.02,0.414-0.223,0.387-0.469 c-0.012-0.234-0.227-0.398-0.461-0.383C681.094,873.09,680.918,873.297,680.934,873.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M681.133,876.035c0.016,0.234,0.211,0.41,0.453,0.394c0.234-0.008,0.414-0.207,0.406-0.441 c-0.016-0.234-0.211-0.422-0.449-0.406C681.309,875.594,681.125,875.793,681.133,876.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M684.785,875.211c0.469,0.234,1.035,0.035,1.27-0.441c0.223-0.469,0.031-1.031-0.438-1.262 c-0.488-0.231-1.059-0.035-1.277,0.434C684.109,874.422,684.313,874.988,684.785,875.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M682.984,875.457c-0.137,0.277-0.012,0.609,0.27,0.738c0.277,0.144,0.609,0.016,0.746-0.258 c0.129-0.277,0.008-0.613-0.254-0.738C683.457,875.063,683.125,875.172,682.984,875.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M686.227,876.543c0.184,0.078,0.395,0.008,0.477-0.172c0.082-0.18,0.016-0.383-0.16-0.477 c-0.18-0.086-0.391-0.008-0.477,0.164C685.973,876.242,686.055,876.453,686.227,876.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M685.547,882c0.473,0.223,1.043,0.027,1.273-0.438c0.219-0.481,0.027-1.043-0.449-1.273 c-0.469-0.231-1.043-0.027-1.27,0.445C684.871,881.199,685.07,881.766,685.547,882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M683.754,882.234c-0.137,0.281-0.008,0.617,0.254,0.75c0.289,0.129,0.621,0.02,0.75-0.266 c0.137-0.281,0.027-0.605-0.258-0.742C684.223,881.84,683.891,881.961,683.754,882.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M686.992,883.32c0.172,0.082,0.387,0.008,0.484-0.16c0.078-0.18,0.012-0.395-0.168-0.488 c-0.176-0.078-0.402-0.012-0.481,0.172C686.746,883.019,686.82,883.231,686.992,883.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M691.668,893.352c0.726,0.457,1.68,0.234,2.129-0.488c0.457-0.727,0.238-1.68-0.488-2.133 c-0.715-0.453-1.68-0.234-2.129,0.492C690.723,891.938,690.945,892.902,691.668,893.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M689.859,888.578c-0.262,0.422-0.137,0.984,0.289,1.25c0.426,0.258,0.992,0.133,1.266-0.285 c0.254-0.43,0.125-0.992-0.301-1.258C690.691,888.019,690.133,888.148,689.859,888.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M688.777,893.332c-0.168,0.274-0.07,0.633,0.192,0.801c0.277,0.172,0.633,0.086,0.808-0.184 c0.164-0.27,0.082-0.629-0.18-0.801C689.32,892.977,688.965,893.059,688.777,893.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M688.609,898.086h1.223c0.676-0.297,1.066-1.043,0.891-1.785 c-0.211-0.828-1.047-1.34-1.871-1.137c-0.828,0.199-1.34,1.043-1.141,1.871C687.84,897.527,688.18,897.891,688.609,898.086 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M686.66,895.699c-0.117-0.488-0.605-0.785-1.098-0.672 c-0.492,0.121-0.789,0.613-0.676,1.102c0.129,0.492,0.617,0.793,1.106,0.672 C686.484,896.68,686.777,896.191,686.66,895.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M695.508,895.789c-0.727,0.453-0.945,1.406-0.492,2.129 c0.027,0.063,0.082,0.117,0.121,0.168h2.371c0.422-0.5,0.488-1.227,0.133-1.813 C697.184,895.555,696.227,895.336,695.508,895.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M696.434,894.371c0.426-0.269,0.57-0.824,0.293-1.254c-0.266-0.422-0.832-0.559-1.258-0.293 c-0.426,0.273-0.551,0.836-0.289,1.258C695.449,894.512,696.012,894.633,696.434,894.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.227,896.828c-0.164-0.27-0.527-0.359-0.805-0.188c-0.266,0.18-0.344,0.531-0.184,0.797 c0.176,0.277,0.531,0.356,0.809,0.191C693.32,897.453,693.402,897.098,693.227,896.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M695.516,887.32c0.625-0.059,1.086-0.609,1.035-1.238c-0.059-0.625-0.609-1.09-1.238-1.031 c-0.625,0.051-1.086,0.602-1.039,1.23C694.336,886.91,694.887,887.375,695.516,887.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.051,885.926c0.375-0.035,0.645-0.363,0.609-0.73c-0.027-0.363-0.355-0.645-0.73-0.609 c-0.367,0.039-0.637,0.356-0.609,0.727C692.363,885.68,692.691,885.957,693.051,885.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.816,888.586c0.008,0.234,0.223,0.41,0.457,0.379c0.238-0.008,0.414-0.211,0.391-0.453 c-0.023-0.238-0.23-0.414-0.457-0.395C693.957,888.144,693.793,888.352,693.816,888.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M696.492,873.348c0.617-0.055,1.086-0.621,1.031-1.238 c-0.055-0.625-0.613-1.086-1.238-1.031c-0.629,0.055-1.086,0.605-1.035,1.234 C695.313,872.938,695.867,873.398,696.492,873.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.305,871.344c0.027,0.371,0.355,0.641,0.723,0.606c0.367-0.031,0.645-0.348,0.602-0.723 c-0.027-0.375-0.356-0.637-0.719-0.609C693.539,870.648,693.269,870.981,693.305,871.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M695.637,874.539c-0.019-0.238-0.227-0.414-0.461-0.383 c-0.234,0.008-0.414,0.223-0.391,0.469c0.016,0.223,0.23,0.394,0.465,0.379 C695.488,874.984,695.656,874.773,695.637,874.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M695.852,880.734c0.629-0.059,1.086-0.621,1.027-1.238 c-0.047-0.629-0.602-1.094-1.231-1.035s-1.086,0.609-1.027,1.238C694.672,880.324,695.23,880.785,695.852,880.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.398,879.336c0.363-0.035,0.637-0.355,0.609-0.727 c-0.039-0.375-0.371-0.645-0.734-0.609c-0.363,0.027-0.641,0.359-0.605,0.719 C692.695,879.098,693.023,879.367,693.398,879.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M694.531,881.543c-0.234,0.019-0.398,0.223-0.379,0.457c0.02,0.234,0.223,0.402,0.457,0.383 c0.234-0.02,0.41-0.223,0.395-0.461C694.98,881.688,694.781,881.512,694.531,881.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M700.438,879.191c-0.477-0.227-1.039-0.027-1.266,0.445 c-0.23,0.477-0.031,1.047,0.441,1.277c0.473,0.227,1.039,0.027,1.273-0.445 C701.109,879.992,700.914,879.422,700.438,879.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M697.816,881.148c-0.129,0.27-0.012,0.606,0.273,0.742c0.273,0.129,0.602,0.016,0.746-0.262 c0.125-0.277,0.008-0.609-0.269-0.742C698.289,880.742,697.957,880.867,697.816,881.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M701.539,882.063c0.09-0.176,0.008-0.391-0.168-0.477c-0.18-0.09-0.387-0.016-0.473,0.168 c-0.098,0.176-0.012,0.391,0.164,0.469C701.242,882.313,701.449,882.242,701.539,882.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M685.16,845.488c-0.461,0.73-0.246,1.68,0.484,2.133c0.719,0.453,1.676,0.231,2.125-0.496 c0.457-0.723,0.234-1.672-0.48-2.129C686.563,844.543,685.617,844.762,685.16,845.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M683.832,842.836c-0.266,0.43-0.141,0.992,0.289,1.25c0.43,0.273,0.984,0.145,1.25-0.285 c0.273-0.422,0.144-0.984-0.285-1.246C684.656,842.281,684.102,842.414,683.832,842.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M682.758,847.602c-0.172,0.269-0.09,0.625,0.184,0.797c0.273,0.172,0.633,0.09,0.805-0.188 c0.168-0.266,0.086-0.629-0.188-0.797C683.289,847.242,682.926,847.328,682.758,847.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M691.125,850.664c-0.453,0.723-0.231,1.68,0.492,2.129c0.723,0.457,1.684,0.238,2.129-0.488 c0.461-0.727,0.234-1.68-0.492-2.133C692.535,849.719,691.574,849.938,691.125,850.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M690.094,849.269c0.43,0.262,0.988,0.137,1.254-0.293c0.27-0.422,0.141-0.984-0.289-1.258 c-0.426-0.262-0.984-0.137-1.254,0.289C689.543,848.438,689.668,849,690.094,849.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M689.535,852.586c-0.281-0.168-0.629-0.09-0.801,0.188 c-0.164,0.266-0.086,0.629,0.184,0.801c0.273,0.168,0.625,0.086,0.805-0.184 C689.891,853.117,689.805,852.754,689.535,852.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M688.316,841.148c0.633-0.055,1.094-0.609,1.043-1.238 c-0.059-0.629-0.621-1.086-1.238-1.027c-0.625,0.047-1.086,0.602-1.035,1.227 C687.144,840.738,687.691,841.207,688.316,841.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M685.859,839.75c0.367-0.031,0.641-0.363,0.609-0.723c-0.039-0.371-0.356-0.644-0.731-0.609 c-0.367,0.031-0.637,0.355-0.609,0.723C685.168,839.516,685.488,839.789,685.859,839.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M686.621,842.414c0.019,0.23,0.227,0.41,0.465,0.391c0.234-0.023,0.41-0.23,0.391-0.465 c-0.027-0.238-0.234-0.41-0.469-0.391C686.777,841.965,686.602,842.18,686.621,842.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M696.426,844.609c0.625-0.047,1.09-0.605,1.031-1.234c-0.059-0.625-0.609-1.094-1.23-1.035 c-0.629,0.059-1.09,0.613-1.035,1.238C695.238,844.207,695.801,844.664,696.426,844.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.234,842.606c0.039,0.367,0.359,0.644,0.723,0.617c0.371-0.035,0.645-0.367,0.613-0.734 c-0.027-0.367-0.356-0.633-0.727-0.605C693.48,841.914,693.203,842.242,693.234,842.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M694.719,845.883c0.023,0.234,0.234,0.41,0.473,0.391c0.23-0.023,0.402-0.23,0.383-0.469 c-0.019-0.234-0.223-0.41-0.469-0.391C694.875,845.434,694.703,845.644,694.719,845.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M695.734,838.019c0.543-0.316,0.727-1.012,0.41-1.555c-0.141-0.238-0.344-0.394-0.578-0.488 h-0.809c-0.066,0.019-0.117,0.039-0.172,0.078c-0.547,0.324-0.73,1.016-0.406,1.555 C694.5,838.16,695.199,838.336,695.734,838.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M695.934,839.281c-0.188-0.316-0.594-0.426-0.914-0.242 c-0.316,0.188-0.434,0.602-0.238,0.926c0.191,0.316,0.598,0.418,0.914,0.231 C696.012,840.012,696.125,839.598,695.934,839.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M698.176,836.875c-0.129-0.211-0.391-0.273-0.594-0.156 c-0.195,0.121-0.273,0.383-0.152,0.586c0.125,0.203,0.387,0.27,0.586,0.156 C698.227,837.336,698.289,837.074,698.176,836.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M683.391,836.25c0.035,0.629,0.57,1.113,1.199,1.078c0.637-0.035,1.113-0.566,1.074-1.199 c0-0.055-0.008-0.102-0.02-0.152h-2.23C683.398,836.066,683.391,836.16,683.391,836.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M682.848,838.617c0.031,0.363,0.336,0.652,0.703,0.625c0.371-0.019,0.652-0.332,0.637-0.707 c-0.023-0.363-0.336-0.648-0.707-0.621C683.113,837.934,682.828,838.238,682.848,838.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M687.277,837.43c-0.008-0.234-0.215-0.418-0.449-0.402 c-0.238,0.008-0.418,0.211-0.402,0.445c0.004,0.238,0.215,0.414,0.449,0.406 C687.105,837.859,687.293,837.664,687.277,837.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M690.391,842.176c-0.23,0.469-0.027,1.043,0.438,1.266c0.481,0.227,1.043,0.035,1.277-0.434 c0.223-0.477,0.031-1.047-0.441-1.277C691.191,841.504,690.621,841.703,690.391,842.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M689.309,844.43c0.269,0.133,0.605,0.02,0.746-0.262c0.133-0.277,0.012-0.613-0.258-0.746 c-0.289-0.141-0.617-0.02-0.762,0.266C688.91,843.957,689.023,844.289,689.309,844.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M692.281,844.762c0.18,0.094,0.391,0.016,0.477-0.16c0.094-0.18,0.012-0.391-0.16-0.477 c-0.184-0.094-0.395-0.019-0.477,0.16C692.023,844.469,692.105,844.68,692.281,844.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M700.797,848.762c0.625-0.063,1.094-0.609,1.039-1.238c-0.055-0.621-0.613-1.09-1.234-1.027 c-0.633,0.055-1.086,0.609-1.043,1.227C699.617,848.352,700.176,848.816,700.797,848.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M698.332,847.367c0.375-0.027,0.637-0.359,0.609-0.73c-0.027-0.363-0.348-0.641-0.715-0.602 c-0.371,0.027-0.645,0.355-0.613,0.727C697.641,847.125,697.973,847.398,698.332,847.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M699.098,850.027c0.023,0.242,0.23,0.414,0.461,0.391c0.242-0.024,0.41-0.223,0.391-0.461 c-0.019-0.238-0.234-0.41-0.469-0.394C699.25,849.586,699.074,849.797,699.098,850.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M701.441,840.09c-0.055-0.629-0.613-1.09-1.234-1.031c-0.633,0.051-1.094,0.602-1.035,1.234 c0.059,0.625,0.609,1.094,1.234,1.023C701.027,841.266,701.488,840.719,701.441,840.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M698.547,839.203c-0.031-0.367-0.355-0.645-0.723-0.613 c-0.367,0.039-0.633,0.363-0.602,0.734c0.039,0.367,0.355,0.641,0.719,0.609 C698.313,839.898,698.586,839.574,698.547,839.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M698.703,842.594c0.02,0.234,0.231,0.414,0.461,0.391c0.234-0.02,0.41-0.234,0.387-0.469 c-0.012-0.234-0.223-0.402-0.457-0.391C698.855,842.152,698.68,842.359,698.703,842.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M701.969,844.461c0.473,0.223,1.035,0.027,1.273-0.449c0.227-0.473,0.019-1.039-0.445-1.262 c-0.48-0.234-1.039-0.039-1.277,0.438C701.289,843.668,701.488,844.227,701.969,844.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M700.438,845.441c0.277,0.133,0.613,0.012,0.746-0.266c0.129-0.273,0.008-0.602-0.258-0.746 c-0.285-0.129-0.609-0.012-0.75,0.266C700.039,844.969,700.164,845.309,700.438,845.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M703.25,845.305c-0.086,0.172-0.008,0.387,0.16,0.473c0.18,0.09,0.391,0.012,0.484-0.164 c0.086-0.18,0.008-0.395-0.168-0.477C703.551,845.051,703.332,845.121,703.25,845.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M682.887,865.434c-0.453,0.727-0.234,1.684,0.5,2.137c0.719,0.453,1.668,0.227,2.129-0.492 c0.445-0.723,0.231-1.672-0.5-2.133C684.297,864.492,683.348,864.715,682.887,865.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M681.566,862.789c-0.258,0.422-0.129,0.98,0.289,1.258c0.434,0.262,0.992,0.129,1.262-0.289 c0.269-0.43,0.137-0.992-0.297-1.258C682.391,862.234,681.832,862.356,681.566,862.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.496,867.543c-0.164,0.273-0.09,0.641,0.191,0.801c0.262,0.176,0.625,0.098,0.797-0.18 c0.168-0.273,0.082-0.629-0.184-0.805C681.027,867.188,680.668,867.277,680.496,867.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M689.359,872.742c0.727,0.453,1.668,0.234,2.117-0.492c0.469-0.727,0.25-1.676-0.477-2.133 c-0.727-0.453-1.68-0.23-2.141,0.492C688.414,871.336,688.629,872.285,689.359,872.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M687.84,869.215c0.422,0.262,0.977,0.137,1.246-0.293c0.273-0.422,0.141-0.984-0.289-1.246 c-0.422-0.27-0.988-0.141-1.246,0.289C687.277,868.387,687.406,868.945,687.84,869.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M686.469,872.719c-0.172,0.266-0.086,0.629,0.18,0.809c0.277,0.172,0.645,0.078,0.809-0.191 c0.168-0.266,0.094-0.637-0.188-0.797C687,872.367,686.641,872.445,686.469,872.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M686.066,861.094c0.621-0.055,1.078-0.609,1.027-1.227 c-0.059-0.637-0.609-1.098-1.234-1.043c-0.629,0.063-1.09,0.609-1.043,1.23 C684.875,860.684,685.438,861.148,686.066,861.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M683.605,859.699c0.363-0.035,0.637-0.356,0.609-0.727 c-0.047-0.375-0.367-0.641-0.734-0.609c-0.367,0.031-0.633,0.363-0.602,0.727 C682.906,859.461,683.23,859.734,683.605,859.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M684.355,862.356c0.023,0.242,0.227,0.414,0.461,0.394c0.238-0.023,0.414-0.231,0.391-0.469 c-0.016-0.234-0.23-0.402-0.461-0.383C684.512,861.918,684.336,862.121,684.355,862.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M694.16,864.559c0.625-0.055,1.09-0.609,1.039-1.23c-0.063-0.633-0.613-1.094-1.242-1.031 c-0.625,0.047-1.086,0.605-1.031,1.227C692.984,864.148,693.535,864.609,694.16,864.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M690.973,862.555c0.035,0.375,0.363,0.645,0.73,0.609c0.375-0.027,0.637-0.359,0.609-0.727 c-0.035-0.371-0.363-0.637-0.727-0.609C691.215,861.863,690.938,862.191,690.973,862.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M692.461,865.832c0.02,0.234,0.231,0.406,0.465,0.387c0.234-0.023,0.406-0.23,0.383-0.469 c-0.02-0.238-0.223-0.406-0.457-0.383C692.613,865.387,692.438,865.59,692.461,865.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.48,857.969c0.535-0.32,0.727-1.016,0.398-1.563c-0.316-0.531-1.008-0.727-1.559-0.402 c-0.535,0.316-0.723,1.016-0.406,1.559C692.234,858.106,692.93,858.289,693.48,857.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M693.664,859.223c-0.176-0.317-0.59-0.418-0.906-0.234c-0.32,0.191-0.43,0.602-0.246,0.922 c0.188,0.313,0.602,0.422,0.918,0.234C693.754,859.957,693.855,859.551,693.664,859.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M695.91,856.82c-0.121-0.203-0.383-0.273-0.578-0.152c-0.211,0.117-0.289,0.387-0.156,0.586 c0.113,0.203,0.379,0.277,0.586,0.152C695.953,857.289,696.031,857.019,695.91,856.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M685.664,853.66c0.633-0.055,1.082-0.609,1.035-1.242c-0.055-0.621-0.605-1.082-1.234-1.031 c-0.629,0.051-1.098,0.609-1.039,1.234C684.484,853.25,685.043,853.711,685.664,853.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M682.48,851.656c0.027,0.367,0.359,0.645,0.719,0.606c0.375-0.031,0.648-0.356,0.609-0.723 c-0.035-0.375-0.356-0.637-0.727-0.613C682.723,850.961,682.449,851.285,682.48,851.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M683.961,854.922c0.02,0.242,0.227,0.414,0.461,0.395c0.234-0.02,0.414-0.234,0.391-0.469 c-0.016-0.234-0.231-0.406-0.461-0.391C684.109,854.477,683.934,854.691,683.961,854.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M681.133,856.203c0.031,0.629,0.566,1.113,1.195,1.074c0.629-0.039,1.106-0.57,1.078-1.195 c-0.035-0.625-0.567-1.113-1.199-1.082C681.574,855.043,681.094,855.574,681.133,856.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.59,858.566c0.012,0.367,0.328,0.652,0.703,0.625c0.367-0.016,0.648-0.336,0.629-0.703 c-0.02-0.367-0.336-0.652-0.711-0.629C680.852,857.879,680.57,858.184,680.59,858.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M684.613,857.824c0.234-0.008,0.414-0.215,0.402-0.449 c-0.008-0.234-0.207-0.418-0.457-0.402c-0.223,0.008-0.418,0.215-0.398,0.445 C684.168,857.66,684.367,857.84,684.613,857.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M687.355,855.34c-0.223,0.469-0.027,1.043,0.445,1.266c0.481,0.234,1.051,0.035,1.266-0.438 c0.242-0.469,0.039-1.043-0.438-1.277C688.16,854.668,687.586,854.867,687.355,855.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M686.012,856.84c-0.133,0.289-0.016,0.617,0.258,0.754c0.281,0.133,0.617,0.016,0.758-0.258 c0.129-0.281,0.012-0.617-0.269-0.75C686.484,856.457,686.152,856.566,686.012,856.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M689.25,857.93c0.188,0.09,0.394,0.008,0.477-0.164c0.098-0.18,0.012-0.395-0.164-0.477 c-0.176-0.09-0.383-0.02-0.477,0.16C688.996,857.629,689.074,857.84,689.25,857.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M688.129,862.121c-0.234,0.477-0.027,1.043,0.445,1.273 c0.473,0.223,1.039,0.027,1.262-0.445c0.231-0.473,0.027-1.043-0.438-1.266 C688.926,861.449,688.363,861.652,688.129,862.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M687.039,864.379c0.281,0.133,0.613,0.012,0.746-0.266c0.141-0.273,0.016-0.609-0.258-0.746 c-0.285-0.137-0.621-0.012-0.75,0.266C686.644,863.906,686.766,864.234,687.039,864.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M690.019,864.715c0.172,0.082,0.391,0.012,0.484-0.168c0.078-0.18,0.004-0.391-0.172-0.477 c-0.176-0.086-0.398-0.012-0.477,0.164C689.766,864.41,689.844,864.625,690.019,864.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M698.547,868.707c0.617-0.051,1.07-0.609,1.023-1.234c-0.055-0.625-0.609-1.09-1.238-1.035 c-0.625,0.051-1.082,0.621-1.031,1.238C697.352,868.305,697.914,868.762,698.547,868.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M696.078,867.316c0.375-0.035,0.637-0.363,0.609-0.727 c-0.031-0.371-0.363-0.648-0.734-0.609c-0.359,0.027-0.633,0.359-0.602,0.723 C695.391,867.078,695.707,867.344,696.078,867.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M696.84,869.984c0.012,0.234,0.227,0.398,0.453,0.387c0.234-0.027,0.414-0.23,0.394-0.469 c-0.019-0.238-0.231-0.41-0.461-0.387C696.984,869.535,696.816,869.742,696.84,869.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M699.516,854.734c0.621-0.051,1.086-0.602,1.035-1.227c-0.055-0.633-0.609-1.09-1.238-1.039 c-0.629,0.059-1.086,0.609-1.039,1.238C698.332,854.336,698.883,854.793,699.516,854.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M697.66,852.617c-0.031-0.367-0.359-0.641-0.73-0.605c-0.367,0.035-0.633,0.355-0.606,0.73 c0.035,0.367,0.352,0.641,0.727,0.609C697.418,853.313,697.688,852.981,697.66,852.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M698.664,855.934c-0.02-0.234-0.23-0.414-0.465-0.391c-0.23,0.019-0.414,0.23-0.387,0.465 c0.012,0.238,0.223,0.41,0.461,0.391C698.512,856.371,698.684,856.168,698.664,855.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M699.172,860.035c-0.051-0.621-0.605-1.086-1.23-1.031c-0.621,0.059-1.09,0.613-1.035,1.238 c0.066,0.621,0.609,1.09,1.23,1.035C698.769,861.215,699.23,860.66,699.172,860.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M696.297,859.148c-0.039-0.363-0.363-0.637-0.73-0.602 c-0.367,0.027-0.645,0.359-0.613,0.723c0.035,0.371,0.359,0.641,0.731,0.609 C696.047,859.84,696.324,859.519,696.297,859.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M697.293,862.469c-0.024-0.238-0.227-0.414-0.461-0.394c-0.238,0.023-0.41,0.23-0.391,0.465 c0.019,0.234,0.219,0.41,0.465,0.391C697.144,862.91,697.309,862.703,697.293,862.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M700.523,862.695c-0.465-0.234-1.031-0.031-1.266,0.441 c-0.223,0.469-0.027,1.039,0.449,1.262c0.469,0.231,1.035,0.043,1.266-0.426 C701.203,863.484,701.004,862.922,700.523,862.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M698.176,865.387c0.273,0.129,0.606,0.023,0.746-0.254c0.141-0.281,0.016-0.613-0.258-0.75 c-0.277-0.137-0.617-0.02-0.75,0.262C697.781,864.918,697.898,865.254,698.176,865.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M701.461,865.078c-0.176-0.082-0.391-0.008-0.469,0.168 c-0.094,0.184-0.02,0.398,0.168,0.481c0.172,0.09,0.387,0.012,0.469-0.172 C701.707,865.387,701.637,865.172,701.461,865.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M706.234,891.348c0.723,0.453,1.68,0.23,2.129-0.492c0.453-0.719,0.234-1.676-0.488-2.133 c-0.719-0.449-1.68-0.234-2.121,0.504C705.293,889.945,705.516,890.894,706.234,891.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M704.719,887.82c0.426,0.269,0.98,0.137,1.254-0.285c0.262-0.43,0.129-0.988-0.293-1.258 c-0.43-0.262-0.988-0.137-1.254,0.289S704.285,887.555,704.719,887.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M704.156,891.144c-0.27-0.176-0.637-0.09-0.809,0.184c-0.172,0.273-0.086,0.629,0.188,0.797 c0.273,0.176,0.633,0.098,0.801-0.188C704.504,891.672,704.426,891.316,704.156,891.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M699.398,891.305c-0.332,0.531-0.168,1.238,0.371,1.57c0.535,0.34,1.234,0.18,1.574-0.363 c0.336-0.531,0.172-1.234-0.359-1.57C700.445,890.609,699.746,890.769,699.398,891.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M699.355,889.121c-0.32-0.195-0.73-0.098-0.93,0.219c-0.195,0.32-0.102,0.723,0.219,0.922 c0.309,0.195,0.727,0.109,0.926-0.207C699.769,889.742,699.668,889.32,699.355,889.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M697.629,892.863c-0.129,0.199-0.063,0.469,0.137,0.59c0.203,0.133,0.469,0.07,0.598-0.133 c0.125-0.203,0.063-0.465-0.137-0.594C698.027,892.598,697.746,892.668,697.629,892.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M711.047,883.168c0.625-0.059,1.078-0.602,1.023-1.231 c-0.047-0.629-0.609-1.098-1.227-1.035c-0.625,0.051-1.098,0.606-1.039,1.234 C709.859,882.758,710.422,883.223,711.047,883.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.465,880.445c-0.363,0.027-0.652,0.348-0.613,0.715c0.035,0.383,0.367,0.644,0.73,0.613 c0.363-0.031,0.645-0.359,0.613-0.734C709.168,880.68,708.828,880.402,708.465,880.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M709.332,884.441c0.027,0.234,0.231,0.402,0.469,0.391c0.234-0.027,0.41-0.234,0.391-0.469 c-0.023-0.238-0.231-0.414-0.469-0.395C709.496,883.992,709.313,884.207,709.332,884.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M709.195,874.613c-0.539,0.316-0.719,1.012-0.398,1.559c0.316,0.547,1.02,0.723,1.559,0.406 c0.547-0.316,0.723-1.02,0.402-1.559C710.449,874.473,709.746,874.293,709.195,874.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M710.316,878.754c0.324-0.195,0.426-0.598,0.234-0.914c-0.195-0.316-0.598-0.43-0.914-0.246 c-0.324,0.192-0.43,0.602-0.234,0.926C709.586,878.836,709.992,878.941,710.316,878.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M712.051,875.867c0.117,0.199,0.383,0.266,0.586,0.141c0.199-0.113,0.273-0.383,0.152-0.574 c-0.121-0.207-0.375-0.273-0.59-0.156C712,875.394,711.934,875.66,712.051,875.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M704.227,876.484c0.473,0.223,1.043,0.027,1.27-0.445c0.23-0.473,0.031-1.047-0.441-1.273 c-0.477-0.227-1.043-0.027-1.266,0.441C703.559,875.684,703.762,876.25,704.227,876.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M702.699,877.469c0.285,0.125,0.609,0.016,0.75-0.262c0.129-0.273,0.02-0.617-0.266-0.754 c-0.281-0.125-0.613-0.016-0.75,0.266C702.309,877,702.426,877.328,702.699,877.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M705.516,877.324c-0.086,0.18-0.012,0.394,0.164,0.48c0.176,0.082,0.391,0.004,0.469-0.172 c0.098-0.176,0.02-0.395-0.16-0.477C705.813,877.074,705.598,877.148,705.516,877.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M699.074,885.414c-0.23,0.477-0.031,1.047,0.445,1.277c0.469,0.23,1.035,0.027,1.262-0.445 c0.23-0.473,0.031-1.047-0.438-1.273C699.871,884.746,699.301,884.941,699.074,885.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M697.727,886.926c-0.141,0.273-0.02,0.609,0.262,0.746c0.27,0.137,0.606,0.02,0.742-0.266 c0.137-0.273,0.016-0.613-0.258-0.738C698.191,886.531,697.863,886.648,697.727,886.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M701.445,887.84c0.082-0.18,0.004-0.387-0.164-0.473c-0.18-0.086-0.387-0.008-0.484,0.168 c-0.082,0.176-0.016,0.383,0.172,0.465C701.152,888.094,701.363,888.019,701.445,887.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M700.316,873.613c-0.313-0.426-0.906-0.516-1.336-0.207 c-0.426,0.313-0.508,0.906-0.199,1.324c0.313,0.43,0.894,0.516,1.324,0.211 C700.535,874.633,700.621,874.035,700.316,873.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M700.262,876.758c0.242-0.188,0.301-0.535,0.117-0.789 c-0.184-0.246-0.535-0.297-0.789-0.117c-0.238,0.188-0.293,0.531-0.109,0.777 C699.656,876.879,700.008,876.934,700.262,876.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M702.027,873.785c-0.109-0.164-0.34-0.199-0.5-0.078c-0.156,0.113-0.183,0.34-0.078,0.504 c0.129,0.16,0.344,0.188,0.508,0.07C702.117,874.164,702.148,873.941,702.027,873.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M706.723,881.563c0.227-0.481,0.027-1.043-0.445-1.273 c-0.477-0.231-1.035-0.027-1.262,0.445c-0.234,0.465-0.039,1.031,0.434,1.266 C705.922,882.223,706.492,882.027,706.723,881.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M704.668,882.719c0.125-0.281,0.019-0.605-0.262-0.742 c-0.277-0.137-0.613-0.016-0.742,0.258c-0.133,0.281-0.02,0.617,0.258,0.75 C704.199,883.113,704.531,883.004,704.668,882.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M707.383,883.16c0.086-0.18,0.012-0.395-0.172-0.488c-0.176-0.078-0.391-0.012-0.473,0.172 c-0.094,0.176-0.016,0.387,0.16,0.477C707.082,883.402,707.293,883.328,707.383,883.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M700.574,894.867c-0.23,0.473-0.035,1.047,0.43,1.277c0.477,0.227,1.043,0.027,1.273-0.445 c0.234-0.477,0.035-1.043-0.441-1.27C701.363,894.199,700.797,894.398,700.574,894.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M699.219,896.383c-0.125,0.277-0.02,0.609,0.262,0.746c0.281,0.129,0.609,0.012,0.742-0.262 c0.133-0.281,0.023-0.617-0.262-0.75C699.688,895.981,699.355,896.098,699.219,896.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M702.769,896.82c-0.176-0.086-0.387-0.012-0.48,0.16c-0.082,0.188-0.004,0.394,0.164,0.484 c0.188,0.086,0.402,0.008,0.481-0.168C703.027,897.117,702.949,896.906,702.769,896.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M711.574,893.352c0.715,0.457,1.676,0.234,2.133-0.488c0.449-0.727,0.234-1.68-0.492-2.133 c-0.723-0.453-1.668-0.234-2.129,0.492C710.629,891.938,710.848,892.902,711.574,893.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M709.773,888.578c-0.269,0.422-0.137,0.984,0.277,1.25c0.426,0.258,0.996,0.133,1.258-0.285 c0.266-0.43,0.133-0.992-0.289-1.258C710.59,888.019,710.031,888.148,709.773,888.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.871,894.133c0.273,0.172,0.633,0.086,0.809-0.184c0.164-0.27,0.094-0.629-0.184-0.801 c-0.27-0.172-0.641-0.09-0.809,0.184C708.523,893.606,708.598,893.965,708.871,894.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.754,895.164c-0.832,0.199-1.34,1.043-1.137,1.871c0.125,0.492,0.461,0.855,0.887,1.051 h1.23c0.676-0.297,1.07-1.043,0.887-1.785C710.422,895.473,709.582,894.961,708.754,895.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M705.465,895.027c-0.488,0.121-0.789,0.613-0.672,1.102 c0.125,0.492,0.613,0.793,1.105,0.672c0.492-0.121,0.789-0.609,0.668-1.102 C706.449,895.211,705.953,894.914,705.465,895.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.414,895.789c-0.734,0.453-0.957,1.406-0.496,2.129 c0.039,0.063,0.082,0.117,0.129,0.168h2.359c0.418-0.5,0.496-1.227,0.133-1.813 C717.086,895.555,716.125,895.336,715.414,895.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M716.34,894.371c0.074-0.051,0.137-0.105,0.192-0.164c-0.149,0.031-0.309,0.008-0.434-0.074 c-0.273-0.168-0.363-0.527-0.188-0.801c0.152-0.242,0.457-0.328,0.719-0.215l0,0c-0.27-0.422-0.824-0.559-1.258-0.293 c-0.426,0.273-0.551,0.836-0.277,1.258C715.355,894.512,715.91,894.633,716.34,894.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.125,896.828c-0.16-0.27-0.523-0.359-0.797-0.188c-0.269,0.18-0.344,0.531-0.18,0.797 c0.168,0.277,0.527,0.356,0.801,0.191C713.223,897.453,713.305,897.098,713.125,896.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M716.453,886.082c-0.059-0.625-0.609-1.09-1.23-1.031c-0.633,0.051-1.094,0.602-1.043,1.23 c0.066,0.629,0.617,1.094,1.234,1.039C716.043,887.262,716.504,886.711,716.453,886.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M712.957,885.926c0.371-0.035,0.648-0.363,0.606-0.73c-0.027-0.363-0.348-0.645-0.727-0.609 c-0.363,0.039-0.637,0.356-0.602,0.727C712.262,885.68,712.59,885.957,712.957,885.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M714.18,888.965c0.234-0.008,0.41-0.211,0.391-0.453c-0.023-0.238-0.226-0.414-0.469-0.395 c-0.23,0.027-0.406,0.234-0.387,0.469C713.738,888.82,713.941,888.996,714.18,888.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M717.426,872.109c-0.059-0.625-0.609-1.086-1.231-1.031 c-0.629,0.055-1.098,0.605-1.043,1.234c0.059,0.625,0.609,1.086,1.242,1.035 C717.012,873.293,717.48,872.727,717.426,872.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.93,871.949c0.375-0.031,0.644-0.348,0.617-0.723c-0.039-0.375-0.367-0.637-0.73-0.609 c-0.375,0.031-0.641,0.363-0.609,0.727C713.234,871.715,713.563,871.984,713.93,871.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.078,874.156c-0.238,0.008-0.414,0.223-0.391,0.469 c0.023,0.223,0.231,0.394,0.465,0.379c0.23-0.02,0.414-0.231,0.387-0.465C715.516,874.301,715.313,874.125,715.078,874.156 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.004,876.762c-0.621,0.051-1.09,0.609-1.027,1.234c0.055,0.629,0.598,1.086,1.234,1.031 c0.621-0.055,1.086-0.609,1.027-1.238C724.184,877.168,723.629,876.699,723.004,876.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M721.359,876.902c-0.035-0.371-0.355-0.641-0.727-0.602 c-0.367,0.027-0.648,0.348-0.609,0.719c0.027,0.371,0.359,0.641,0.719,0.606 C721.117,877.594,721.391,877.269,721.359,876.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M722.363,880.215c-0.031-0.234-0.234-0.406-0.469-0.383 c-0.234,0.02-0.406,0.223-0.387,0.461c0.02,0.23,0.231,0.414,0.465,0.391C722.207,880.664,722.383,880.453,722.363,880.215 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M714.82,877.613c-0.629,0.055-1.086,0.609-1.023,1.238c0.047,0.625,0.605,1.082,1.227,1.023 c0.633-0.047,1.094-0.598,1.035-1.227C716.004,878.019,715.441,877.555,714.82,877.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M711.836,877.879c0.031,0.363,0.363,0.641,0.723,0.609c0.375-0.035,0.648-0.355,0.617-0.727 c-0.043-0.371-0.367-0.645-0.734-0.606C712.07,877.191,711.809,877.508,711.836,877.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.707,880.684c-0.23,0.023-0.414,0.234-0.387,0.469c0.027,0.234,0.223,0.41,0.465,0.391 c0.234-0.027,0.406-0.234,0.387-0.469C714.152,880.84,713.941,880.664,713.707,880.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M717.852,882.574c0.227-0.477,0.039-1.043-0.445-1.277 c-0.469-0.223-1.039-0.027-1.262,0.449c-0.234,0.461-0.027,1.043,0.438,1.266 C717.051,883.242,717.625,883.043,717.852,882.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.055,883.996c0.281,0.133,0.613,0.016,0.742-0.262c0.137-0.273,0.027-0.609-0.258-0.746 c-0.27-0.137-0.617-0.02-0.742,0.258C714.66,883.527,714.769,883.859,715.055,883.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M718.344,883.691c-0.172-0.086-0.387-0.012-0.481,0.16 c-0.078,0.184-0.012,0.394,0.172,0.488c0.176,0.082,0.391,0,0.477-0.172C718.594,883.988,718.523,883.773,718.344,883.691z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M720.918,892.863c0.461-0.727,0.238-1.68-0.484-2.133c-0.719-0.453-1.676-0.234-2.125,0.492 c-0.457,0.715-0.234,1.68,0.48,2.129C719.516,893.809,720.473,893.586,720.918,892.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M718.527,889.543c0.262-0.43,0.133-0.992-0.289-1.258c-0.422-0.266-0.992-0.137-1.254,0.293 c-0.266,0.422-0.133,0.984,0.289,1.25C717.695,890.086,718.266,889.961,718.527,889.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.91,893.332c-0.176,0.274-0.086,0.633,0.188,0.801c0.125,0.082,0.285,0.105,0.434,0.074 c0.148-0.031,0.277-0.121,0.367-0.258c0.172-0.27,0.086-0.629-0.188-0.801c-0.019-0.019-0.051-0.019-0.082-0.031 C716.367,893.004,716.063,893.09,715.91,893.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M724.762,896.273c-0.457-0.719-1.41-0.938-2.137-0.484 c-0.723,0.453-0.945,1.406-0.488,2.129c0.039,0.063,0.09,0.117,0.129,0.168h2.367 C725.043,897.586,725.117,896.859,724.762,896.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.848,893.117c-0.262-0.422-0.824-0.559-1.254-0.293 c-0.422,0.273-0.555,0.836-0.281,1.258c0.262,0.43,0.824,0.551,1.246,0.289 C723.988,894.102,724.117,893.547,723.848,893.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M719.371,897.438c0.164,0.277,0.523,0.356,0.805,0.191c0.266-0.176,0.356-0.531,0.18-0.801 c-0.172-0.27-0.527-0.359-0.801-0.188C719.277,896.82,719.199,897.172,719.371,897.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M722.434,885.051c-0.621,0.051-1.094,0.602-1.035,1.23c0.066,0.629,0.613,1.094,1.246,1.039 c0.625-0.059,1.082-0.609,1.027-1.238C723.613,885.457,723.063,884.992,722.434,885.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M720.789,885.195c-0.047-0.363-0.363-0.645-0.738-0.609 c-0.359,0.039-0.633,0.356-0.594,0.727c0.031,0.367,0.352,0.644,0.719,0.613 C720.543,885.891,720.816,885.563,720.789,885.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M721.785,888.512c-0.02-0.238-0.227-0.414-0.461-0.395c-0.234,0.027-0.41,0.234-0.387,0.469 c0.012,0.234,0.227,0.41,0.453,0.379C721.641,888.957,721.805,888.754,721.785,888.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M725.445,860.883c-0.055-0.629-0.609-1.082-1.242-1.031 c-0.617,0.059-1.082,0.609-1.031,1.23c0.059,0.629,0.617,1.098,1.246,1.039C725.031,862.066,725.5,861.512,725.445,860.883 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M721.23,860.117c0.031,0.367,0.352,0.641,0.719,0.609c0.375-0.039,0.645-0.356,0.606-0.723 c-0.023-0.371-0.356-0.641-0.719-0.609C721.469,859.422,721.191,859.75,721.23,860.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.172,863.777c0.238-0.019,0.414-0.223,0.387-0.457 c-0.012-0.242-0.219-0.414-0.461-0.391c-0.234,0.012-0.406,0.227-0.391,0.465 C722.73,863.625,722.938,863.801,723.172,863.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M724.633,881.297c-0.473-0.223-1.043-0.027-1.273,0.449 c-0.223,0.461-0.027,1.043,0.445,1.266c0.473,0.23,1.035,0.031,1.266-0.438 C725.301,882.098,725.098,881.531,724.633,881.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M722.75,882.988c-0.266-0.137-0.602-0.02-0.734,0.258c-0.133,0.281-0.019,0.613,0.258,0.75 c0.273,0.133,0.609,0.016,0.75-0.262C723.16,883.461,723.035,883.125,722.75,882.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M725.727,884.168c0.094-0.18,0.016-0.395-0.16-0.477c-0.184-0.086-0.395-0.012-0.477,0.16 c-0.086,0.184-0.02,0.394,0.16,0.488C725.43,884.422,725.644,884.34,725.727,884.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M707.684,847.125c0.453-0.723,0.23-1.672-0.5-2.129c-0.719-0.453-1.668-0.234-2.129,0.492 c-0.453,0.73-0.234,1.68,0.488,2.133C706.273,848.074,707.223,847.852,707.684,847.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M704.988,842.555c-0.418-0.273-0.988-0.141-1.254,0.281c-0.266,0.43-0.141,0.992,0.289,1.25 c0.422,0.273,0.992,0.145,1.258-0.285C705.543,843.379,705.41,842.816,704.988,842.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M703.652,848.211c0.168-0.266,0.082-0.629-0.183-0.797 c-0.273-0.172-0.633-0.086-0.805,0.188c-0.18,0.269-0.094,0.625,0.18,0.797C703.117,848.57,703.48,848.488,703.652,848.211 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.164,850.172c-0.723-0.453-1.676-0.234-2.137,0.492c-0.445,0.723-0.23,1.68,0.488,2.129 c0.734,0.457,1.68,0.238,2.141-0.488C714.102,851.578,713.883,850.625,713.164,850.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M711.254,848.977c0.262-0.422,0.137-0.984-0.289-1.258c-0.43-0.262-0.988-0.137-1.25,0.289 c-0.273,0.43-0.141,0.992,0.285,1.262C710.426,849.531,710.984,849.406,711.254,848.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.816,853.574c0.277,0.168,0.641,0.086,0.809-0.184c0.168-0.273,0.09-0.637-0.195-0.805 c-0.262-0.168-0.621-0.09-0.793,0.188C708.465,853.039,708.551,853.402,708.816,853.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.227,841.148c0.625-0.055,1.086-0.609,1.035-1.238 c-0.066-0.629-0.609-1.086-1.242-1.027c-0.621,0.047-1.082,0.602-1.035,1.227 C707.047,840.738,707.605,841.207,708.227,841.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M705.641,838.418c-0.359,0.031-0.633,0.355-0.594,0.723 c0.027,0.375,0.344,0.648,0.715,0.609c0.375-0.031,0.641-0.363,0.609-0.723 C706.336,838.656,706.016,838.383,705.641,838.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M707.375,842.34c-0.02-0.238-0.231-0.41-0.461-0.391c-0.234,0.016-0.41,0.23-0.387,0.465 c0.02,0.234,0.223,0.41,0.457,0.391C707.223,842.781,707.398,842.574,707.375,842.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.734,842.953c-0.629,0.066-1.086,0.609-1.031,1.238 c0.059,0.625,0.609,1.094,1.231,1.035c0.629-0.059,1.098-0.606,1.035-1.238 C716.918,843.363,716.359,842.902,715.734,842.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.359,842.496c-0.367,0.035-0.641,0.359-0.609,0.731c0.039,0.363,0.355,0.644,0.73,0.605 c0.375-0.031,0.637-0.355,0.609-0.726C714.059,842.731,713.734,842.461,713.359,842.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M714.699,846.883c0.227-0.02,0.406-0.227,0.395-0.461c-0.027-0.242-0.234-0.406-0.473-0.387 c-0.231,0.019-0.406,0.227-0.375,0.465C714.254,846.734,714.457,846.902,714.699,846.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.473,835.977h-0.813c-0.055,0.019-0.113,0.039-0.172,0.078 c-0.547,0.324-0.723,1.016-0.406,1.555c0.324,0.551,1.016,0.727,1.566,0.41c0.539-0.316,0.711-1.012,0.398-1.555 C715.91,836.227,715.703,836.07,715.473,835.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M714.68,839.965c0.188,0.316,0.602,0.418,0.918,0.231c0.324-0.184,0.426-0.598,0.234-0.914 c-0.176-0.316-0.59-0.426-0.914-0.242C714.605,839.227,714.488,839.641,714.68,839.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M718.074,836.875c-0.117-0.211-0.387-0.273-0.586-0.156 c-0.203,0.121-0.273,0.383-0.144,0.586c0.113,0.203,0.379,0.27,0.574,0.156 C718.121,837.336,718.191,837.074,718.074,836.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M703.293,836.25c0.039,0.629,0.574,1.113,1.203,1.078c0.629-0.035,1.105-0.566,1.078-1.199 c-0.008-0.055-0.012-0.102-0.031-0.152h-2.227C703.301,836.07,703.293,836.16,703.293,836.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M703.379,837.914c-0.359,0.019-0.652,0.324-0.621,0.703 c0.012,0.363,0.328,0.652,0.703,0.625c0.363-0.019,0.648-0.332,0.629-0.707 C704.066,838.172,703.762,837.887,703.379,837.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M706.781,837.879c0.227-0.02,0.418-0.215,0.402-0.449c-0.012-0.234-0.219-0.418-0.445-0.402 c-0.246,0.008-0.422,0.211-0.41,0.445C706.336,837.711,706.535,837.887,706.781,837.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M712.004,843.008c0.238-0.477,0.035-1.047-0.438-1.277 c-0.473-0.227-1.043-0.027-1.273,0.445c-0.231,0.469-0.027,1.043,0.445,1.266 C711.203,843.668,711.781,843.477,712.004,843.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M709.695,843.422c-0.285-0.141-0.609-0.02-0.75,0.266c-0.133,0.269-0.02,0.602,0.262,0.742 c0.277,0.133,0.609,0.02,0.746-0.262C710.094,843.891,709.977,843.555,709.695,843.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M712.023,844.285c-0.09,0.183-0.019,0.394,0.164,0.477c0.172,0.094,0.394,0.016,0.481-0.16 c0.082-0.18,0.008-0.391-0.168-0.477C712.324,844.031,712.102,844.106,712.023,844.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M720.164,850.949c0.625-0.047,1.086-0.598,1.027-1.227 c-0.059-0.629-0.602-1.094-1.238-1.039c-0.621,0.059-1.078,0.613-1.031,1.242 C718.984,850.547,719.531,851.008,720.164,850.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M717.695,849.563c0.379-0.031,0.641-0.363,0.613-0.727 c-0.031-0.371-0.359-0.644-0.731-0.609c-0.367,0.039-0.641,0.363-0.609,0.73 C717.008,849.328,717.34,849.59,717.695,849.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M718.844,851.762c-0.234,0.019-0.41,0.227-0.391,0.461c0.031,0.234,0.234,0.406,0.457,0.387 c0.25-0.02,0.422-0.227,0.398-0.461C719.289,851.914,719.078,851.742,718.844,851.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M719.953,839.254c0.059,0.625,0.609,1.094,1.238,1.035c0.625-0.055,1.094-0.609,1.039-1.231 c-0.059-0.637-0.609-1.09-1.242-1.039C720.367,838.074,719.906,838.629,719.953,839.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M718.609,837.555c-0.363,0.039-0.633,0.363-0.605,0.734 c0.039,0.367,0.363,0.637,0.727,0.605c0.375-0.027,0.648-0.359,0.609-0.73 C719.309,837.801,718.984,837.527,718.609,837.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M719.953,841.945c0.242-0.023,0.414-0.227,0.391-0.469c-0.02-0.231-0.227-0.406-0.461-0.383 c-0.234,0.02-0.414,0.223-0.391,0.457C719.508,841.797,719.723,841.965,719.953,841.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M720.832,843.758c-0.23,0.469-0.031,1.039,0.438,1.273c0.484,0.223,1.043,0.027,1.274-0.449 c0.226-0.469,0.031-1.043-0.445-1.266C721.625,843.086,721.063,843.281,720.832,843.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M720.227,844.996c-0.277-0.125-0.609-0.008-0.738,0.27 c-0.137,0.277-0.027,0.609,0.258,0.742c0.277,0.133,0.613,0.019,0.746-0.258 C720.629,845.465,720.512,845.137,720.227,844.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M722.555,845.867c-0.082,0.18-0.012,0.395,0.176,0.484c0.176,0.082,0.391,0.004,0.469-0.172 c0.09-0.176,0.012-0.391-0.164-0.477C722.863,845.613,722.644,845.691,722.555,845.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M725.957,847.758c-0.629,0.09-1.063,0.672-0.961,1.285c0.094,0.625,0.672,1.055,1.281,0.965 c0.633-0.086,1.063-0.676,0.973-1.293C727.156,848.094,726.582,847.668,725.957,847.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.574,846.316c-0.055-0.359-0.391-0.617-0.758-0.566 c-0.367,0.055-0.625,0.391-0.57,0.762c0.051,0.371,0.394,0.613,0.754,0.566 C727.371,847.023,727.629,846.688,727.574,846.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.629,847.418c-0.234,0.039-0.398,0.258-0.359,0.488c0.027,0.231,0.25,0.398,0.484,0.359 c0.234-0.035,0.402-0.242,0.363-0.477C724.078,847.543,723.867,847.387,723.629,847.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.055,855.574c-0.094-0.613-0.672-1.055-1.297-0.957 c-0.625,0.09-1.059,0.668-0.965,1.289c0.086,0.625,0.676,1.051,1.289,0.969 C722.707,856.773,723.141,856.195,723.055,855.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.371,853.176c-0.047-0.359-0.395-0.617-0.75-0.566 c-0.375,0.059-0.625,0.395-0.566,0.762c0.043,0.367,0.391,0.625,0.754,0.57 C723.172,853.887,723.422,853.543,723.371,853.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M719.434,854.277c-0.234,0.039-0.395,0.254-0.367,0.488c0.039,0.234,0.25,0.398,0.488,0.359 c0.234-0.027,0.394-0.25,0.359-0.488C719.883,854.414,719.668,854.242,719.434,854.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.215,855.301c0.203-0.488-0.031-1.043-0.512-1.246c-0.477-0.195-1.035,0.031-1.234,0.52 c-0.207,0.484,0.019,1.039,0.508,1.238C726.465,856.016,727.019,855.789,727.215,855.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M725.43,853.527c0.117-0.289-0.012-0.613-0.301-0.727c-0.293-0.121-0.617,0.016-0.734,0.297 c-0.117,0.285,0.024,0.613,0.309,0.73C724.984,853.945,725.309,853.809,725.43,853.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M724.418,856.566c0.184,0.074,0.394-0.016,0.476-0.203c0.074-0.176-0.019-0.387-0.191-0.457 c-0.191-0.078-0.398,0-0.473,0.188C724.156,856.273,724.238,856.484,724.418,856.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M710.902,870.117c-0.73-0.453-1.676-0.23-2.133,0.492c-0.449,0.727-0.238,1.676,0.492,2.133 c0.719,0.453,1.668,0.234,2.129-0.492C711.836,871.523,711.625,870.574,710.902,870.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.996,868.922c0.266-0.422,0.133-0.984-0.297-1.246c-0.418-0.27-0.984-0.141-1.246,0.289 c-0.269,0.422-0.137,0.981,0.289,1.25C708.164,869.477,708.719,869.352,708.996,868.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M707.367,873.336c0.16-0.266,0.086-0.637-0.191-0.797c-0.269-0.172-0.629-0.094-0.801,0.18 c-0.168,0.266-0.086,0.629,0.188,0.809C706.824,873.699,707.195,873.606,707.367,873.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M705.625,867.91c-0.481-0.703-1.445-0.871-2.148-0.387 c-0.699,0.488-0.875,1.449-0.391,2.148c0.484,0.707,1.445,0.879,2.156,0.391 C705.941,869.582,706.113,868.609,705.625,867.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M704.344,866.066c0.41-0.289,0.516-0.856,0.227-1.27c-0.289-0.41-0.848-0.512-1.27-0.23 c-0.414,0.289-0.504,0.859-0.219,1.266C703.359,866.25,703.926,866.352,704.344,866.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M701.102,869.477c0.27-0.184,0.34-0.543,0.152-0.809c-0.184-0.258-0.543-0.328-0.809-0.145 c-0.262,0.18-0.328,0.547-0.148,0.813C700.48,869.602,700.848,869.664,701.102,869.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M705.762,858.824c-0.629,0.063-1.094,0.609-1.031,1.23c0.051,0.629,0.609,1.094,1.23,1.039 c0.625-0.055,1.086-0.609,1.035-1.227C706.945,859.231,706.391,858.769,705.762,858.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M703.379,858.363c-0.359,0.031-0.633,0.363-0.602,0.727 c0.027,0.371,0.356,0.645,0.731,0.609c0.359-0.035,0.637-0.356,0.602-0.727 C704.082,858.598,703.75,858.332,703.379,858.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M705.121,862.281c-0.027-0.234-0.234-0.402-0.465-0.383c-0.25,0.02-0.414,0.223-0.398,0.457 c0.023,0.242,0.227,0.414,0.473,0.394C704.953,862.727,705.133,862.519,705.121,862.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.098,863.328c-0.051-0.633-0.609-1.094-1.238-1.031 c-0.625,0.047-1.086,0.605-1.027,1.227c0.059,0.625,0.609,1.086,1.227,1.035 C714.688,864.504,715.152,863.949,715.098,863.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M711.488,861.828c-0.363,0.035-0.644,0.363-0.609,0.727 c0.027,0.375,0.355,0.645,0.727,0.609c0.367-0.027,0.645-0.359,0.602-0.727 C712.18,862.066,711.852,861.801,711.488,861.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M712.75,865.367c-0.234,0.02-0.41,0.223-0.391,0.465c0.02,0.234,0.23,0.406,0.469,0.387 c0.234-0.023,0.406-0.23,0.387-0.469C713.191,865.512,712.988,865.344,712.75,865.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.383,857.969c0.539-0.32,0.719-1.016,0.414-1.563c-0.332-0.531-1.023-0.727-1.57-0.402 c-0.543,0.316-0.719,1.016-0.402,1.559C712.141,858.106,712.832,858.289,713.383,857.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.582,859.223c-0.195-0.317-0.605-0.418-0.926-0.234 c-0.317,0.191-0.422,0.602-0.234,0.922c0.18,0.313,0.594,0.422,0.918,0.234 C713.656,859.957,713.766,859.551,713.582,859.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.078,857.254c0.113,0.203,0.379,0.277,0.578,0.152c0.207-0.117,0.277-0.387,0.156-0.586 c-0.117-0.203-0.379-0.273-0.582-0.152C715.023,856.785,714.957,857.055,715.078,857.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M705.566,853.66c0.629-0.055,1.098-0.609,1.039-1.242c-0.059-0.621-0.613-1.082-1.238-1.031 c-0.633,0.051-1.098,0.609-1.031,1.234C704.387,853.25,704.945,853.711,705.566,853.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M703.723,851.539c-0.039-0.375-0.363-0.637-0.734-0.613 c-0.363,0.035-0.637,0.359-0.605,0.73c0.031,0.367,0.355,0.645,0.73,0.606C703.48,852.231,703.75,851.906,703.723,851.539z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M704.258,854.457c-0.246,0.02-0.41,0.234-0.391,0.465c0.019,0.242,0.223,0.414,0.457,0.395 c0.246-0.02,0.41-0.234,0.395-0.469C704.699,854.613,704.484,854.441,704.258,854.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.539,854.891c-0.477-0.223-1.043-0.023-1.27,0.449c-0.23,0.469-0.031,1.043,0.441,1.266 c0.469,0.234,1.043,0.035,1.262-0.438C709.207,855.699,709.012,855.125,708.539,854.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M706.664,856.586c-0.273-0.129-0.613-0.019-0.742,0.254 c-0.137,0.289-0.023,0.617,0.254,0.754c0.285,0.133,0.613,0.016,0.746-0.258 C707.055,857.055,706.945,856.719,706.664,856.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.996,857.449c-0.09,0.18-0.023,0.391,0.172,0.48c0.164,0.09,0.379,0.008,0.469-0.164 c0.082-0.18,0.008-0.395-0.16-0.477C709.289,857.199,709.074,857.269,708.996,857.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M708.027,862.121c-0.215,0.477-0.019,1.043,0.449,1.273 c0.469,0.223,1.039,0.027,1.266-0.445c0.234-0.473,0.031-1.043-0.441-1.266 C708.828,861.449,708.262,861.652,708.027,862.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M706.688,863.633c-0.141,0.273-0.023,0.602,0.258,0.746 c0.277,0.133,0.613,0.012,0.742-0.266c0.137-0.273,0.023-0.609-0.258-0.746 C707.156,863.231,706.82,863.356,706.688,863.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M710.402,864.547c0.082-0.18,0.008-0.391-0.168-0.477c-0.176-0.086-0.391-0.012-0.473,0.164 c-0.086,0.176-0.016,0.391,0.172,0.48C710.102,864.797,710.316,864.727,710.402,864.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M719.469,867.473c-0.051-0.625-0.609-1.09-1.231-1.035c-0.621,0.051-1.09,0.621-1.031,1.238 c0.059,0.629,0.609,1.086,1.238,1.031C719.066,868.656,719.531,868.098,719.469,867.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.863,865.981c-0.367,0.027-0.641,0.359-0.606,0.723 c0.024,0.375,0.348,0.641,0.727,0.613c0.363-0.035,0.637-0.363,0.609-0.727 C716.563,866.219,716.23,865.941,715.863,865.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M717.129,869.516c-0.234,0.02-0.41,0.227-0.391,0.469c0.016,0.234,0.231,0.398,0.469,0.387 c0.234-0.027,0.41-0.23,0.383-0.469C717.57,869.664,717.367,869.492,717.129,869.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.23,870.219c-0.617,0.059-1.082,0.613-1.031,1.242c0.059,0.629,0.609,1.078,1.238,1.027 c0.625-0.051,1.086-0.602,1.039-1.23C724.418,870.629,723.867,870.16,723.23,870.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M720.859,869.762c-0.367,0.035-0.648,0.359-0.602,0.73c0.027,0.359,0.356,0.633,0.719,0.606 c0.363-0.039,0.645-0.359,0.605-0.727C721.551,870.004,721.23,869.727,720.859,869.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M722.586,873.688c-0.019-0.242-0.234-0.41-0.457-0.391c-0.246,0.02-0.41,0.23-0.391,0.465 c0.016,0.234,0.231,0.402,0.461,0.394C722.434,874.121,722.613,873.922,722.586,873.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M718.094,853.238c-0.059-0.629-0.613-1.086-1.238-1.035 c-0.633,0.066-1.086,0.617-1.031,1.242c0.059,0.629,0.609,1.086,1.238,1.031 C717.684,854.418,718.148,853.867,718.094,853.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M713.871,852.481c0.027,0.359,0.359,0.637,0.73,0.601c0.363-0.031,0.637-0.359,0.609-0.723 c-0.031-0.371-0.363-0.645-0.734-0.617C714.113,851.781,713.84,852.109,713.871,852.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M715.824,856.137c0.223-0.02,0.398-0.231,0.383-0.465c-0.019-0.234-0.234-0.41-0.461-0.391 c-0.234,0.02-0.41,0.231-0.391,0.469C715.371,855.984,715.586,856.148,715.824,856.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M719.078,860.035c-0.059-0.621-0.605-1.086-1.234-1.031 c-0.629,0.059-1.09,0.613-1.035,1.238c0.063,0.621,0.609,1.09,1.242,1.035C718.668,861.215,719.137,860.66,719.078,860.035 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M716.195,859.148c-0.031-0.363-0.363-0.637-0.726-0.602 c-0.371,0.027-0.645,0.359-0.609,0.723c0.031,0.371,0.363,0.641,0.727,0.609 C715.961,859.84,716.223,859.519,716.195,859.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M716.73,862.074c-0.23,0.023-0.41,0.23-0.383,0.465c0.012,0.234,0.215,0.41,0.461,0.391 c0.234-0.019,0.406-0.227,0.387-0.461C717.172,862.231,716.969,862.055,716.73,862.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M720.434,862.695c-0.469-0.234-1.039-0.031-1.262,0.441 c-0.23,0.469-0.035,1.039,0.434,1.262c0.477,0.231,1.039,0.043,1.27-0.426 C721.105,863.484,720.906,862.922,720.434,862.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M718.566,864.383c-0.281-0.137-0.609-0.02-0.75,0.262c-0.133,0.274-0.02,0.609,0.258,0.742 c0.277,0.129,0.613,0.023,0.75-0.254C718.961,864.852,718.84,864.519,718.566,864.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M721.539,865.555c0.082-0.168,0.008-0.383-0.172-0.477 c-0.176-0.082-0.391-0.008-0.477,0.168c-0.078,0.184-0.016,0.398,0.172,0.481 C721.234,865.816,721.457,865.738,721.539,865.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M726.035,891.266c-0.469,0.223-0.664,0.793-0.438,1.266c0.234,0.469,0.789,0.668,1.27,0.445 c0.473-0.234,0.668-0.793,0.445-1.273C727.082,891.227,726.512,891.031,726.035,891.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M725.25,890.547c-0.133-0.285-0.469-0.406-0.746-0.27c-0.273,0.141-0.387,0.473-0.258,0.746 c0.133,0.281,0.469,0.398,0.75,0.262C725.269,891.152,725.383,890.816,725.25,890.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.965,890.106c-0.09-0.176-0.301-0.254-0.473-0.164c-0.18,0.086-0.258,0.297-0.172,0.477 c0.082,0.18,0.297,0.258,0.473,0.168C727.98,890.496,728.051,890.285,727.965,890.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M732.438,844.863c-0.453-0.73-1.414-0.949-2.133-0.496c-0.723,0.449-0.941,1.41-0.484,2.141 c0.453,0.719,1.402,0.938,2.129,0.484C732.676,846.539,732.887,845.586,732.438,844.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.781,847.894c-0.426,0.27-0.555,0.828-0.285,1.254c0.262,0.426,0.836,0.559,1.25,0.285 c0.426-0.262,0.559-0.824,0.293-1.25C729.766,847.758,729.207,847.633,728.781,847.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.418,844.391c0.18,0.273,0.535,0.348,0.801,0.191c0.277-0.176,0.359-0.531,0.195-0.809 c-0.176-0.269-0.539-0.352-0.809-0.184C727.332,843.762,727.254,844.113,727.418,844.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M734.91,854.824c0.637,0.051,1.18-0.41,1.238-1.039c0.051-0.625-0.41-1.176-1.031-1.238 c-0.633-0.051-1.18,0.414-1.242,1.039C733.82,854.211,734.289,854.766,734.91,854.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M733.266,854.672c0.027-0.363-0.238-0.691-0.613-0.727c-0.363-0.027-0.691,0.238-0.73,0.609 c-0.031,0.367,0.246,0.695,0.613,0.727C732.906,855.309,733.227,855.043,733.266,854.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M734.266,851.359c0.023-0.234-0.156-0.445-0.391-0.465 c-0.234-0.019-0.445,0.149-0.465,0.391c-0.027,0.234,0.152,0.438,0.391,0.457 C734.035,851.762,734.25,851.594,734.266,851.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M734.43,859.141c-0.551-0.316-1.246-0.133-1.563,0.41c-0.313,0.539-0.137,1.242,0.406,1.559 c0.543,0.309,1.242,0.141,1.559-0.41C735.156,860.156,734.965,859.461,734.43,859.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M733.715,858.121c0.317,0.184,0.723,0.082,0.906-0.242c0.191-0.316,0.086-0.731-0.234-0.914 c-0.324-0.191-0.73-0.074-0.926,0.234C733.285,857.523,733.383,857.938,733.715,858.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M736.269,860.445c0.211,0.117,0.473,0.051,0.598-0.156c0.121-0.199,0.043-0.469-0.164-0.586 c-0.191-0.113-0.465-0.051-0.578,0.148C736.004,860.055,736.066,860.328,736.269,860.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.855,860.504c0.227,0.477,0.801,0.672,1.277,0.445c0.469-0.231,0.664-0.793,0.438-1.27 c-0.223-0.473-0.809-0.668-1.266-0.441C727.824,859.461,727.629,860.035,727.855,860.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.512,858.516c-0.133-0.281-0.457-0.395-0.746-0.258 c-0.273,0.125-0.391,0.469-0.254,0.746c0.133,0.273,0.457,0.398,0.742,0.258 C727.531,859.129,727.652,858.789,727.512,858.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.227,858.082c-0.086-0.176-0.297-0.254-0.48-0.164c-0.176,0.082-0.25,0.297-0.164,0.476 c0.082,0.176,0.297,0.25,0.477,0.172C730.246,858.481,730.313,858.262,730.227,858.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.789,854.16c-0.227-0.473-0.789-0.668-1.266-0.442c-0.477,0.227-0.672,0.793-0.449,1.27 c0.234,0.469,0.805,0.672,1.273,0.438C730.82,855.203,731.019,854.633,730.789,854.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.742,852.996c-0.145-0.277-0.477-0.394-0.75-0.258 c-0.281,0.137-0.395,0.461-0.258,0.738c0.129,0.289,0.465,0.402,0.742,0.266 C728.754,853.606,728.875,853.273,728.742,852.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.977,852.398c-0.18,0.086-0.254,0.301-0.172,0.477c0.082,0.176,0.297,0.254,0.477,0.164 c0.18-0.078,0.25-0.297,0.172-0.477C731.363,852.383,731.152,852.313,730.977,852.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M726.352,840.023c-0.23-0.473-0.793-0.676-1.273-0.445c-0.469,0.23-0.66,0.793-0.438,1.266 c0.227,0.473,0.801,0.672,1.27,0.445C726.383,841.059,726.582,840.496,726.352,840.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M723.555,838.59c-0.285,0.137-0.395,0.477-0.258,0.75c0.125,0.277,0.457,0.398,0.742,0.258 c0.277-0.133,0.398-0.469,0.258-0.742C724.16,838.578,723.828,838.457,723.555,838.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.016,838.422c-0.094-0.184-0.313-0.258-0.484-0.164 c-0.18,0.078-0.254,0.293-0.164,0.473c0.082,0.18,0.297,0.254,0.477,0.172 C727.019,838.813,727.094,838.606,727.016,838.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M737.773,842.856c-0.449-0.723-1.406-0.941-2.125-0.484 c-0.73,0.445-0.941,1.402-0.492,2.129c0.457,0.727,1.414,0.941,2.133,0.488 C738.012,844.535,738.23,843.578,737.773,842.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M735.383,846.18c-0.266-0.43-0.832-0.555-1.25-0.285c-0.43,0.262-0.563,0.828-0.293,1.25 c0.262,0.43,0.82,0.559,1.246,0.289C735.516,847.168,735.648,846.606,735.383,846.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M733.746,841.766c-0.164-0.273-0.531-0.352-0.797-0.176c-0.273,0.16-0.355,0.531-0.18,0.793 c0.164,0.273,0.524,0.359,0.793,0.191C733.84,842.402,733.918,842.039,733.746,841.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M734.699,839.418c0.199-0.828-0.313-1.668-1.141-1.867 c-0.828-0.207-1.668,0.309-1.871,1.133c-0.195,0.832,0.301,1.668,1.141,1.875 C733.656,840.758,734.492,840.25,734.699,839.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.633,840.023c0.129-0.492-0.176-0.984-0.66-1.109c-0.492-0.121-0.984,0.188-1.098,0.676 c-0.121,0.484,0.172,0.977,0.656,1.094C730.019,840.801,730.516,840.508,730.633,840.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M731.633,835.977c0.078,0.109,0.191,0.191,0.328,0.219c0.227,0.055,0.473-0.031,0.602-0.219 H731.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.605,839.441c0.457-0.719,0.238-1.68-0.48-2.133c-0.727-0.453-1.684-0.234-2.141,0.492 c-0.449,0.719-0.223,1.676,0.496,2.133C740.203,840.383,741.152,840.168,741.605,839.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M740.703,842.606c0.266-0.426,0.133-0.984-0.289-1.258 c-0.426-0.266-0.992-0.137-1.258,0.285c-0.266,0.426-0.133,0.992,0.285,1.258 C739.871,843.156,740.438,843.027,740.703,842.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M736.219,838.277c-0.168,0.273-0.082,0.629,0.18,0.801c0.285,0.176,0.633,0.086,0.809-0.184 c0.172-0.269,0.082-0.633-0.18-0.801C736.75,837.922,736.387,838,736.219,838.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M740.519,849.641c0.055-0.629-0.402-1.184-1.031-1.238c-0.625-0.059-1.176,0.41-1.234,1.031 c-0.055,0.629,0.406,1.18,1.031,1.238C739.91,850.727,740.473,850.262,740.519,849.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M737.629,850.519c0.039-0.363-0.231-0.695-0.598-0.723 c-0.375-0.031-0.692,0.238-0.731,0.605c-0.031,0.367,0.238,0.699,0.609,0.734 C737.285,851.164,737.602,850.894,737.629,850.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M738.18,847.602c0.23,0.019,0.441-0.156,0.465-0.395c0.016-0.226-0.16-0.441-0.394-0.457 c-0.238-0.023-0.445,0.152-0.469,0.387C737.762,847.367,737.938,847.574,738.18,847.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.492,863.606c0.066-0.621-0.402-1.176-1.031-1.231c-0.629-0.059-1.176,0.398-1.23,1.027 c-0.066,0.629,0.402,1.18,1.031,1.242C740.891,864.695,741.441,864.234,741.492,863.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M738.609,864.492c0.035-0.363-0.238-0.691-0.609-0.723 c-0.371-0.031-0.695,0.234-0.715,0.598c-0.039,0.375,0.234,0.703,0.598,0.731 C738.254,865.133,738.574,864.863,738.609,864.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M739.613,861.176c0.019-0.234-0.152-0.438-0.394-0.461 c-0.234-0.027-0.438,0.148-0.457,0.387c-0.019,0.234,0.145,0.445,0.383,0.469 C739.383,861.59,739.594,861.41,739.613,861.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M740.125,857.074c0.059-0.625-0.398-1.18-1.031-1.234c-0.625-0.063-1.18,0.406-1.231,1.035 c-0.059,0.629,0.406,1.172,1.027,1.231C739.516,858.16,740.07,857.699,740.125,857.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M737.246,857.961c0.027-0.371-0.242-0.703-0.621-0.73c-0.363-0.031-0.691,0.242-0.719,0.609 c-0.031,0.375,0.242,0.695,0.609,0.727C736.875,858.594,737.215,858.332,737.246,857.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M738.238,854.648c0.019-0.234-0.148-0.449-0.375-0.465 c-0.242-0.023-0.445,0.152-0.477,0.391c-0.008,0.234,0.16,0.438,0.395,0.465 C738.012,855.059,738.227,854.883,738.238,854.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.918,853.148c-0.231-0.469-0.789-0.668-1.258-0.445 c-0.477,0.234-0.676,0.801-0.449,1.273c0.234,0.473,0.797,0.672,1.262,0.441 C741.957,854.191,742.152,853.621,741.918,853.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M739.871,851.988c-0.133-0.285-0.469-0.406-0.75-0.266 c-0.273,0.133-0.395,0.469-0.258,0.746c0.133,0.285,0.473,0.391,0.746,0.266 C739.887,852.59,740.004,852.262,739.871,851.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.102,851.383c-0.18,0.09-0.246,0.301-0.168,0.477c0.07,0.152,0.219,0.215,0.375,0.195 v-0.695C742.238,851.348,742.172,851.356,742.102,851.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M729.609,888.098c-0.715,0.453-0.934,1.406-0.477,2.137c0.449,0.719,1.402,0.938,2.121,0.48 c0.73-0.449,0.949-1.402,0.496-2.125C731.293,887.867,730.344,887.644,729.609,888.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M729.348,891.91c-0.273-0.422-0.824-0.551-1.25-0.289c-0.426,0.27-0.551,0.84-0.301,1.254 c0.281,0.426,0.84,0.559,1.27,0.293C729.496,892.902,729.609,892.34,729.348,891.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.535,888.305c0.262-0.172,0.359-0.527,0.188-0.805c-0.176-0.269-0.539-0.352-0.801-0.18 c-0.277,0.172-0.355,0.527-0.195,0.797C726.902,888.391,727.262,888.481,727.535,888.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M737.723,883.422c-0.457-0.73-1.402-0.953-2.129-0.496 c-0.723,0.457-0.942,1.414-0.488,2.133c0.449,0.723,1.406,0.945,2.129,0.492 C737.957,885.094,738.18,884.137,737.723,883.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M735.332,886.746c-0.266-0.43-0.836-0.559-1.269-0.289 c-0.418,0.262-0.543,0.824-0.277,1.254c0.266,0.422,0.824,0.555,1.254,0.289 C735.461,887.731,735.594,887.168,735.332,886.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M732.894,882.144c-0.273,0.176-0.359,0.527-0.191,0.809c0.176,0.27,0.531,0.348,0.801,0.176 c0.281-0.164,0.367-0.523,0.191-0.797C733.519,882.063,733.164,881.977,732.894,882.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M732.301,894.574c-0.629-0.055-1.188,0.414-1.238,1.031 c-0.055,0.625,0.406,1.188,1.023,1.234c0.633,0.059,1.188-0.406,1.242-1.031S732.914,894.629,732.301,894.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.438,896.695c0.039-0.371-0.231-0.695-0.598-0.734 c-0.371-0.027-0.695,0.246-0.727,0.617c-0.039,0.367,0.234,0.691,0.606,0.723 C730.082,897.336,730.418,897.07,730.438,896.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.984,893.766c0.238,0.023,0.438-0.152,0.457-0.387c0.027-0.231-0.148-0.441-0.387-0.461 c-0.234-0.024-0.449,0.144-0.465,0.383C730.566,893.547,730.75,893.75,730.984,893.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.438,892.344c0.047-0.629-0.418-1.183-1.039-1.238c-0.629-0.051-1.18,0.402-1.234,1.031 c-0.059,0.629,0.406,1.184,1.027,1.238C740.828,893.43,741.379,892.973,741.438,892.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M738.547,893.227c0.035-0.363-0.234-0.695-0.609-0.719 c-0.367-0.039-0.691,0.234-0.723,0.609c-0.027,0.359,0.234,0.684,0.609,0.723 C738.188,893.871,738.516,893.602,738.547,893.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M738.699,889.832c-0.027,0.246,0.148,0.449,0.387,0.465 c0.234,0.023,0.441-0.145,0.461-0.379c0.023-0.238-0.152-0.449-0.391-0.465 C738.922,889.434,738.719,889.606,738.699,889.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M739.715,897.707c-0.539-0.32-1.227-0.144-1.543,0.379h1.93 C740.004,897.93,739.883,897.793,739.715,897.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M738.996,896.676c0.316,0.191,0.73,0.078,0.906-0.242c0.199-0.316,0.086-0.73-0.227-0.914 c-0.324-0.184-0.731-0.082-0.914,0.238C738.57,896.078,738.672,896.488,738.996,896.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.16,897.18c0.023-0.371-0.266-0.688-0.629-0.707c-0.375-0.02-0.688,0.266-0.707,0.637 c-0.019,0.363,0.262,0.684,0.625,0.703C727.824,897.832,728.141,897.547,728.16,897.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.848,897.844c-0.176-0.012-0.332,0.086-0.41,0.242h0.773 C731.141,897.949,731.008,897.848,730.848,897.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M736.07,892.719c-0.226-0.469-0.789-0.668-1.266-0.445 c-0.469,0.234-0.672,0.797-0.438,1.273c0.234,0.477,0.793,0.66,1.266,0.438 C736.109,893.762,736.309,893.191,736.07,892.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M734.031,891.547c-0.141-0.27-0.473-0.387-0.758-0.258c-0.281,0.133-0.387,0.473-0.258,0.75 c0.137,0.273,0.473,0.394,0.746,0.262C734.039,892.164,734.16,891.832,734.031,891.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M736.258,890.953c-0.176,0.09-0.254,0.305-0.168,0.48c0.09,0.172,0.297,0.246,0.48,0.16 c0.172-0.086,0.246-0.289,0.168-0.469C736.644,890.941,736.441,890.867,736.258,890.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.586,888.957c-0.027,0.371,0.246,0.703,0.606,0.731 c0.039,0.004,0.082-0.008,0.117-0.016v-1.313C741.941,888.328,741.625,888.598,741.586,888.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.188,896.402c-0.031,0.363,0.25,0.688,0.606,0.727c0.203,0.012,0.383-0.055,0.516-0.184 v-0.973c-0.098-0.098-0.234-0.172-0.391-0.184C741.559,895.754,741.227,896.027,741.188,896.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M735.457,863.465c-0.453-0.719-1.406-0.938-2.129-0.484 c-0.723,0.445-0.941,1.406-0.48,2.121c0.445,0.73,1.402,0.945,2.121,0.5C735.691,865.152,735.91,864.188,735.457,863.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M731.519,867.762c0.266,0.426,0.828,0.551,1.258,0.289c0.418-0.273,0.551-0.832,0.289-1.254 c-0.27-0.426-0.836-0.559-1.254-0.289C731.383,866.769,731.254,867.328,731.519,867.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.629,862.199c-0.273,0.164-0.356,0.527-0.18,0.801c0.164,0.269,0.527,0.359,0.793,0.184 c0.277-0.172,0.355-0.531,0.188-0.801C731.262,862.106,730.906,862.027,730.629,862.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M729.309,865.652c-0.699-0.48-1.656-0.316-2.152,0.387 c-0.488,0.699-0.313,1.664,0.391,2.156c0.703,0.484,1.66,0.313,2.148-0.387 C730.18,867.106,730.012,866.141,729.309,865.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.414,869.652c-0.414-0.281-0.977-0.184-1.27,0.231c-0.277,0.41-0.184,0.973,0.231,1.269 c0.414,0.285,0.969,0.184,1.262-0.23C728.93,870.508,728.832,869.941,728.414,869.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M725.184,866.238c-0.27-0.18-0.629-0.117-0.809,0.145c-0.191,0.269-0.129,0.621,0.137,0.816 c0.266,0.18,0.625,0.117,0.813-0.141C725.512,866.789,725.441,866.43,725.184,866.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.031,874.625c-0.625-0.055-1.18,0.402-1.231,1.035c-0.059,0.629,0.402,1.18,1.031,1.234 c0.625,0.059,1.188-0.41,1.231-1.039C731.121,875.231,730.664,874.68,730.031,874.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.184,876.746c0.027-0.363-0.242-0.695-0.609-0.73c-0.371-0.027-0.691,0.246-0.73,0.613 c-0.027,0.371,0.242,0.688,0.605,0.723C727.824,877.391,728.148,877.113,728.184,876.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.723,873.82c0.234,0.023,0.441-0.152,0.461-0.387c0.019-0.238-0.148-0.449-0.383-0.469 c-0.238-0.019-0.457,0.152-0.465,0.391C728.309,873.59,728.484,873.801,728.723,873.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M738.141,871.152c-0.633-0.047-1.184,0.418-1.242,1.039 c-0.051,0.629,0.406,1.18,1.039,1.238c0.617,0.055,1.18-0.406,1.227-1.039 C739.219,871.769,738.762,871.219,738.141,871.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M736.285,873.277c0.035-0.363-0.242-0.688-0.613-0.73c-0.371-0.027-0.688,0.246-0.727,0.609 c-0.027,0.375,0.246,0.703,0.609,0.731C735.93,873.922,736.25,873.648,736.285,873.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M737.285,869.977c0.02-0.25-0.152-0.449-0.387-0.469c-0.242-0.031-0.445,0.144-0.465,0.379 c-0.02,0.238,0.152,0.449,0.383,0.473C737.055,870.375,737.266,870.199,737.285,869.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M737.449,877.75c-0.539-0.316-1.242-0.137-1.559,0.406c-0.316,0.543-0.141,1.242,0.41,1.563 c0.539,0.317,1.238,0.133,1.563-0.41C738.18,878.773,737.992,878.074,737.449,877.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M737.418,875.574c-0.328-0.191-0.734-0.082-0.926,0.234 c-0.184,0.324-0.078,0.734,0.246,0.926c0.309,0.18,0.719,0.07,0.906-0.25C737.836,876.172,737.723,875.754,737.418,875.574 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M739.297,879.051c0.211,0.117,0.473,0.051,0.586-0.148c0.121-0.211,0.047-0.469-0.152-0.586 c-0.203-0.125-0.465-0.059-0.586,0.144C739.027,878.672,739.094,878.934,739.297,879.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.402,883.09c-0.058,0.629,0.41,1.18,1.035,1.238c0.633,0.059,1.176-0.402,1.234-1.039 c0.059-0.621-0.402-1.172-1.031-1.227S728.465,882.469,728.402,883.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M727.789,884.188c0.027-0.371-0.242-0.695-0.605-0.731 c-0.367-0.035-0.699,0.238-0.734,0.602c-0.035,0.371,0.242,0.699,0.609,0.738 C727.43,884.832,727.758,884.551,727.789,884.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M728.789,880.867c0.023-0.23-0.152-0.441-0.387-0.465c-0.234-0.019-0.449,0.148-0.477,0.391 c-0.012,0.238,0.16,0.445,0.398,0.465C728.563,881.277,728.762,881.102,728.789,880.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M733.055,879.555c-0.234-0.473-0.809-0.672-1.277-0.445 c-0.473,0.23-0.664,0.797-0.441,1.273c0.231,0.469,0.801,0.668,1.27,0.438C733.074,880.59,733.273,880.027,733.055,879.555 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M729.992,878.871c0.137,0.277,0.465,0.398,0.746,0.258c0.281-0.129,0.394-0.461,0.258-0.738 c-0.133-0.289-0.465-0.395-0.746-0.266C729.973,878.258,729.855,878.594,729.992,878.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M733.543,878.434c0.176-0.082,0.25-0.297,0.172-0.477c-0.098-0.176-0.313-0.25-0.488-0.172 c-0.172,0.094-0.242,0.308-0.16,0.477C733.144,878.441,733.359,878.519,733.543,878.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M733.816,872.773c-0.231-0.48-0.801-0.684-1.273-0.449c-0.465,0.234-0.66,0.797-0.441,1.277 c0.234,0.473,0.805,0.664,1.27,0.438C733.844,873.813,734.039,873.238,733.816,872.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M730.762,872.09c0.125,0.277,0.461,0.395,0.734,0.262c0.281-0.137,0.394-0.465,0.262-0.75 c-0.129-0.277-0.465-0.391-0.738-0.262C730.738,871.477,730.625,871.813,730.762,872.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M734,871.004c-0.18,0.086-0.258,0.301-0.168,0.48c0.086,0.176,0.301,0.25,0.477,0.168 c0.176-0.09,0.246-0.309,0.168-0.48C734.387,870.992,734.172,870.922,734,871.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.285,868.039c-0.07,0.629,0.398,1.18,1.023,1.234v-2.269 C741.773,867.063,741.324,867.484,741.285,868.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M740.664,869.133c0.031-0.375-0.242-0.691-0.605-0.723 c-0.371-0.043-0.703,0.238-0.734,0.602c-0.027,0.367,0.242,0.699,0.606,0.73 C740.305,869.769,740.633,869.508,740.664,869.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.66,865.816c0.023-0.234-0.156-0.441-0.391-0.461c-0.234-0.024-0.441,0.148-0.461,0.383 c-0.02,0.242,0.148,0.453,0.387,0.465C741.438,866.223,741.637,866.047,741.66,865.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.25,882.019c-0.012,0.156,0,0.313,0.059,0.457v-0.723 C742.285,881.84,742.266,881.922,742.25,882.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.637,883.094c0.031-0.363-0.238-0.691-0.609-0.719 c-0.367-0.031-0.688,0.238-0.723,0.609c-0.035,0.363,0.234,0.695,0.605,0.727 C741.285,883.738,741.602,883.473,741.637,883.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.25,879.324c-0.234-0.023-0.445,0.152-0.469,0.387c-0.02,0.234,0.152,0.445,0.394,0.465 c0.035,0.012,0.09-0.008,0.133-0.02v-0.816C742.285,879.336,742.273,879.324,742.25,879.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M742.117,874.449c-0.625-0.059-1.18,0.406-1.238,1.027c-0.051,0.629,0.406,1.18,1.035,1.242 c0.137,0.008,0.266-0.012,0.395-0.039v-2.199C742.25,874.469,742.18,874.453,742.117,874.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M740.262,876.563c0.039-0.367-0.234-0.688-0.594-0.723 c-0.383-0.031-0.707,0.246-0.738,0.613c-0.027,0.363,0.234,0.695,0.609,0.723 C739.902,877.211,740.23,876.934,740.262,876.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.266,873.258c0.02-0.242-0.152-0.445-0.387-0.465c-0.238-0.02-0.441,0.144-0.465,0.379 c-0.027,0.238,0.148,0.449,0.383,0.473C741.035,873.668,741.246,873.484,741.266,873.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M741.891,871.078c0.086,0.172,0.242,0.266,0.418,0.301v-1.086 c-0.059,0.008-0.109,0.008-0.16,0.039C741.863,870.461,741.762,870.797,741.891,871.078z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M619.34,898.086h2.414c0.215-0.266,0.344-0.594,0.344-0.957 c0-0.859-0.695-1.551-1.543-1.551c-0.801,0-1.445,0.598-1.535,1.375v0.344C619.055,897.59,619.172,897.863,619.34,898.086z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M624.656,889.227c-0.449,0.719-0.227,1.668,0.496,2.121c0.719,0.453,1.676,0.23,2.137-0.492 c0.441-0.719,0.223-1.676-0.492-2.133C626.066,888.273,625.113,888.488,624.656,889.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M623.34,886.566c-0.266,0.426-0.133,0.988,0.289,1.254c0.43,0.269,0.988,0.137,1.258-0.285 c0.266-0.43,0.137-0.988-0.289-1.258C624.168,886.016,623.609,886.141,623.34,886.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M622.262,891.328c-0.164,0.273-0.086,0.629,0.188,0.797 c0.273,0.176,0.633,0.098,0.805-0.188c0.16-0.266,0.086-0.621-0.184-0.793 C622.797,890.969,622.434,891.055,622.262,891.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M620.617,878.668c0.055,0.629,0.613,1.09,1.242,1.031c0.625-0.059,1.078-0.609,1.035-1.238 c-0.059-0.621-0.613-1.082-1.238-1.027S620.559,878.039,620.617,878.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M620.535,880.504c-0.23,0.019-0.41,0.23-0.379,0.461c0.016,0.242,0.227,0.41,0.461,0.391 c0.23-0.02,0.414-0.223,0.391-0.461C620.984,880.66,620.777,880.484,620.535,880.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M629.961,883.168c0.629-0.059,1.078-0.602,1.035-1.231 c-0.059-0.629-0.621-1.098-1.238-1.035c-0.633,0.051-1.098,0.606-1.031,1.234 C628.777,882.758,629.336,883.223,629.961,883.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M627.375,880.445c-0.359,0.027-0.633,0.348-0.602,0.715 c0.027,0.383,0.348,0.644,0.731,0.613c0.359-0.031,0.637-0.359,0.609-0.734C628.066,880.68,627.75,880.402,627.375,880.445 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.258,884.441c0.023,0.234,0.219,0.402,0.469,0.391c0.234-0.027,0.398-0.234,0.387-0.469 c-0.031-0.238-0.238-0.414-0.477-0.395C628.402,883.992,628.238,884.207,628.258,884.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M629.266,876.578c0.547-0.316,0.727-1.02,0.41-1.559c-0.313-0.547-1.016-0.726-1.551-0.406 c-0.551,0.316-0.731,1.012-0.414,1.559C628.027,876.719,628.73,876.894,629.266,876.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.547,877.594c-0.32,0.192-0.414,0.602-0.234,0.926c0.188,0.316,0.602,0.422,0.914,0.234 c0.316-0.195,0.426-0.598,0.242-0.914C629.281,877.523,628.867,877.41,628.547,877.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M631.117,875.277c-0.199,0.117-0.273,0.383-0.152,0.59c0.125,0.199,0.383,0.266,0.59,0.141 c0.207-0.113,0.269-0.383,0.148-0.574C631.586,875.227,631.32,875.16,631.117,875.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M621.262,869.996c-0.629,0.059-1.09,0.609-1.039,1.231c0.055,0.629,0.609,1.098,1.234,1.035 c0.629-0.055,1.094-0.606,1.031-1.234C622.434,870.398,621.891,869.941,621.262,869.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M619.609,870.141c-0.027-0.316-0.277-0.551-0.59-0.586v1.309 C619.379,870.816,619.641,870.508,619.609,870.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M619.754,873.531c0.019,0.238,0.234,0.41,0.469,0.391c0.234-0.02,0.406-0.223,0.391-0.469 c-0.023-0.234-0.23-0.398-0.469-0.383C619.91,873.09,619.734,873.297,619.754,873.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M619.957,876.035c0.012,0.234,0.215,0.41,0.445,0.394c0.238-0.008,0.422-0.207,0.41-0.441 c-0.019-0.234-0.219-0.422-0.453-0.406C620.125,875.594,619.941,875.793,619.957,876.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M623.602,875.211c0.465,0.234,1.039,0.035,1.27-0.441c0.223-0.469,0.031-1.031-0.441-1.262 c-0.469-0.231-1.043-0.035-1.27,0.434C622.934,874.422,623.129,874.988,623.602,875.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M621.813,875.457c-0.133,0.277-0.023,0.609,0.262,0.738 c0.273,0.144,0.606,0.016,0.742-0.258c0.125-0.277,0.019-0.613-0.266-0.738 C622.281,875.063,621.945,875.172,621.813,875.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M625.055,876.543c0.176,0.078,0.387,0.008,0.48-0.172c0.082-0.18,0.008-0.383-0.172-0.477 c-0.176-0.086-0.394-0.008-0.477,0.164C624.797,876.242,624.871,876.453,625.055,876.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M624.363,882c0.481,0.223,1.051,0.027,1.273-0.438c0.231-0.481,0.035-1.043-0.438-1.273 c-0.484-0.231-1.047-0.027-1.273,0.445C623.691,881.199,623.887,881.766,624.363,882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M622.578,882.234c-0.144,0.281-0.027,0.617,0.258,0.75c0.277,0.129,0.613,0.02,0.75-0.266 c0.129-0.281,0.016-0.605-0.258-0.742C623.043,881.84,622.707,881.961,622.578,882.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M625.82,883.32c0.172,0.082,0.387,0.008,0.469-0.16c0.094-0.18,0.02-0.395-0.16-0.488 c-0.18-0.078-0.391-0.012-0.484,0.172C625.563,883.019,625.637,883.231,625.82,883.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M630.488,893.352c0.727,0.457,1.68,0.234,2.133-0.488c0.449-0.727,0.23-1.68-0.492-2.133 c-0.715-0.453-1.68-0.234-2.129,0.492C629.543,891.938,629.769,892.902,630.488,893.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.676,888.578c-0.262,0.422-0.129,0.984,0.289,1.25c0.43,0.258,0.996,0.133,1.258-0.285 c0.266-0.43,0.133-0.992-0.293-1.258C629.508,888.019,628.945,888.148,628.676,888.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M627.609,893.332c-0.172,0.274-0.098,0.633,0.18,0.801c0.27,0.172,0.641,0.086,0.809-0.184 c0.16-0.27,0.078-0.629-0.195-0.801C628.141,892.977,627.769,893.059,627.609,893.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M627.426,898.086h1.223c0.688-0.297,1.074-1.043,0.891-1.785 c-0.203-0.828-1.043-1.34-1.871-1.137c-0.832,0.199-1.34,1.043-1.129,1.871C626.656,897.527,627,897.891,627.426,898.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M625.484,895.699c-0.121-0.488-0.613-0.785-1.102-0.672 c-0.496,0.121-0.793,0.613-0.668,1.102c0.117,0.492,0.609,0.793,1.098,0.672 C625.301,896.68,625.605,896.191,625.484,895.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.324,895.789c-0.73,0.453-0.938,1.406-0.488,2.129c0.039,0.063,0.078,0.117,0.125,0.168 h2.363c0.422-0.5,0.492-1.227,0.133-1.813C636,895.555,635.051,895.336,634.324,895.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M635.258,894.371c0.43-0.269,0.551-0.824,0.293-1.254c-0.273-0.422-0.836-0.559-1.258-0.293 c-0.426,0.273-0.559,0.836-0.285,1.258C634.269,894.512,634.84,894.633,635.258,894.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.047,896.828c-0.164-0.27-0.52-0.359-0.805-0.188c-0.266,0.18-0.348,0.531-0.172,0.797 c0.164,0.277,0.531,0.356,0.793,0.191C632.137,897.453,632.219,897.098,632.047,896.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.332,887.32c0.625-0.059,1.086-0.609,1.035-1.238c-0.051-0.625-0.606-1.09-1.234-1.031 c-0.629,0.051-1.09,0.602-1.039,1.23C633.152,886.91,633.703,887.375,634.332,887.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M631.871,885.926c0.367-0.035,0.641-0.363,0.609-0.73c-0.027-0.363-0.359-0.645-0.719-0.609 c-0.375,0.039-0.648,0.356-0.609,0.727C631.18,885.68,631.504,885.957,631.871,885.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.629,888.586c0.023,0.234,0.227,0.41,0.465,0.379c0.234-0.008,0.41-0.211,0.391-0.453 c-0.023-0.238-0.227-0.414-0.469-0.395C632.785,888.144,632.609,888.352,632.629,888.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M635.309,873.348c0.633-0.055,1.082-0.621,1.031-1.238c-0.055-0.625-0.605-1.086-1.23-1.031 c-0.629,0.055-1.098,0.605-1.031,1.234C634.133,872.938,634.684,873.398,635.309,873.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.121,871.344c0.027,0.371,0.359,0.641,0.727,0.606c0.371-0.031,0.641-0.348,0.613-0.723 c-0.035-0.375-0.367-0.637-0.73-0.609C632.363,870.648,632.082,870.981,632.121,871.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.453,874.539c-0.012-0.238-0.227-0.414-0.461-0.383 c-0.238,0.008-0.41,0.223-0.391,0.469c0.02,0.223,0.234,0.394,0.469,0.379C634.305,874.984,634.48,874.773,634.453,874.539 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.68,880.734c0.617-0.059,1.086-0.621,1.027-1.238c-0.059-0.629-0.605-1.094-1.238-1.035 c-0.621,0.059-1.082,0.609-1.031,1.238C633.488,880.324,634.039,880.785,634.68,880.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.207,879.336c0.371-0.035,0.645-0.355,0.617-0.727c-0.035-0.375-0.363-0.645-0.73-0.609 c-0.367,0.027-0.641,0.359-0.609,0.719C631.527,879.098,631.844,879.367,632.207,879.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M633.359,881.543c-0.246,0.019-0.41,0.223-0.391,0.457c0.019,0.234,0.23,0.402,0.469,0.383 c0.238-0.02,0.41-0.223,0.391-0.461C633.801,881.688,633.586,881.512,633.359,881.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.258,879.191c-0.469-0.227-1.035-0.027-1.262,0.445 c-0.234,0.477-0.039,1.047,0.434,1.277c0.473,0.227,1.043,0.027,1.273-0.445 C639.93,879.992,639.73,879.422,639.258,879.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M636.641,881.148c-0.129,0.27-0.019,0.606,0.266,0.742c0.273,0.129,0.602,0.016,0.738-0.262 c0.137-0.277,0.02-0.609-0.25-0.742C637.109,880.742,636.773,880.867,636.641,881.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M640.355,882.063c0.094-0.176,0.02-0.391-0.16-0.477c-0.18-0.09-0.395-0.016-0.481,0.168 c-0.082,0.176-0.008,0.391,0.172,0.469C640.059,882.313,640.273,882.242,640.355,882.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M623.977,845.488c-0.453,0.73-0.23,1.68,0.48,2.133c0.731,0.453,1.68,0.231,2.141-0.496 c0.445-0.723,0.23-1.672-0.5-2.129C625.383,844.543,624.422,844.762,623.977,845.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M622.656,842.836c-0.266,0.43-0.145,0.992,0.281,1.25c0.422,0.273,1,0.145,1.258-0.285 c0.262-0.422,0.141-0.984-0.289-1.246C623.477,842.281,622.922,842.414,622.656,842.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M621.578,847.602c-0.164,0.269-0.094,0.625,0.18,0.797c0.273,0.172,0.633,0.09,0.809-0.188 c0.172-0.266,0.09-0.629-0.18-0.797C622.109,847.242,621.742,847.328,621.578,847.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M629.949,850.664c-0.453,0.723-0.234,1.68,0.484,2.129c0.734,0.457,1.68,0.238,2.137-0.488 c0.445-0.727,0.238-1.68-0.492-2.133C631.355,849.719,630.406,849.938,629.949,850.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.914,849.269c0.426,0.262,0.984,0.137,1.258-0.293c0.262-0.422,0.133-0.984-0.293-1.258 c-0.426-0.262-0.984-0.137-1.25,0.289C628.359,848.438,628.488,849,628.914,849.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.352,852.586c-0.266-0.168-0.629-0.09-0.801,0.188 c-0.176,0.266-0.086,0.629,0.184,0.801c0.273,0.168,0.637,0.086,0.813-0.184 C628.707,853.117,628.629,852.754,628.352,852.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M627.141,841.148c0.625-0.055,1.086-0.609,1.039-1.238 c-0.055-0.629-0.613-1.086-1.242-1.027c-0.625,0.047-1.086,0.602-1.031,1.227 C625.961,840.738,626.512,841.207,627.141,841.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M624.688,839.75c0.367-0.031,0.633-0.363,0.602-0.723c-0.031-0.371-0.359-0.644-0.723-0.609 c-0.371,0.031-0.641,0.355-0.606,0.723C623.988,839.516,624.305,839.789,624.688,839.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M625.441,842.414c0.019,0.23,0.23,0.41,0.453,0.391c0.242-0.023,0.418-0.23,0.395-0.465 c-0.02-0.238-0.223-0.41-0.457-0.391C625.594,841.965,625.422,842.18,625.441,842.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M635.25,844.609c0.617-0.047,1.082-0.605,1.031-1.234c-0.059-0.625-0.617-1.094-1.238-1.035 c-0.621,0.059-1.09,0.613-1.035,1.238C634.07,844.207,634.617,844.664,635.25,844.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.055,842.606c0.027,0.367,0.363,0.644,0.73,0.617c0.367-0.035,0.641-0.367,0.602-0.734 c-0.027-0.367-0.352-0.633-0.73-0.605C632.301,841.914,632.023,842.242,632.055,842.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M633.543,845.883c0.016,0.234,0.23,0.41,0.465,0.391c0.234-0.023,0.414-0.23,0.387-0.469 c-0.023-0.234-0.226-0.41-0.461-0.391C633.695,845.434,633.519,845.644,633.543,845.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.559,838.019c0.543-0.316,0.73-1.012,0.406-1.555c-0.137-0.238-0.348-0.394-0.582-0.488 h-0.809c-0.059,0.019-0.113,0.039-0.168,0.078c-0.539,0.324-0.719,1.016-0.406,1.555 C633.316,838.16,634.012,838.336,634.559,838.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.754,839.281c-0.188-0.316-0.59-0.426-0.906-0.242c-0.332,0.188-0.43,0.602-0.254,0.926 c0.183,0.316,0.602,0.418,0.926,0.231C634.84,840.012,634.941,839.598,634.754,839.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M636.992,836.875c-0.117-0.211-0.379-0.273-0.582-0.156 c-0.207,0.121-0.273,0.383-0.156,0.586c0.117,0.203,0.387,0.27,0.582,0.156 C637.035,837.336,637.109,837.074,636.992,836.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M622.207,836.25c0.039,0.629,0.57,1.113,1.203,1.078c0.629-0.035,1.109-0.566,1.078-1.199 c-0.008-0.055-0.012-0.102-0.031-0.152h-2.227C622.215,836.066,622.207,836.16,622.207,836.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M621.672,838.617c0.02,0.363,0.328,0.652,0.707,0.625c0.367-0.019,0.644-0.332,0.633-0.707 c-0.031-0.363-0.336-0.648-0.711-0.621C621.93,837.934,621.652,838.238,621.672,838.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M626.098,837.43c-0.008-0.234-0.219-0.418-0.453-0.402c-0.23,0.008-0.414,0.211-0.402,0.445 c0.016,0.238,0.211,0.414,0.457,0.406C625.93,837.859,626.109,837.664,626.098,837.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M629.207,842.176c-0.223,0.469-0.027,1.043,0.445,1.266c0.481,0.227,1.043,0.035,1.27-0.434 c0.23-0.477,0.031-1.047-0.441-1.277C630.012,841.504,629.441,841.703,629.207,842.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.125,844.43c0.273,0.133,0.605,0.02,0.742-0.262c0.137-0.277,0.019-0.613-0.258-0.746 c-0.277-0.141-0.613-0.02-0.746,0.266C627.73,843.957,627.852,844.289,628.125,844.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M631.109,844.762c0.164,0.094,0.383,0.016,0.477-0.16c0.078-0.18,0.004-0.391-0.172-0.477 c-0.18-0.094-0.391-0.019-0.477,0.16C630.855,844.469,630.926,844.68,631.109,844.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.613,848.762c0.633-0.063,1.098-0.609,1.039-1.238c-0.055-0.621-0.609-1.09-1.234-1.027 c-0.629,0.055-1.086,0.609-1.031,1.227C638.441,848.352,638.996,848.816,639.613,848.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.164,847.367c0.363-0.027,0.637-0.359,0.609-0.73c-0.035-0.363-0.359-0.641-0.738-0.602 c-0.363,0.027-0.645,0.355-0.602,0.727C636.461,847.125,636.789,847.398,637.164,847.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.914,850.027c0.023,0.242,0.23,0.414,0.461,0.391c0.246-0.024,0.414-0.223,0.402-0.461 c-0.023-0.238-0.234-0.41-0.473-0.394C638.074,849.586,637.898,849.797,637.914,850.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M640.254,840.09c-0.051-0.629-0.609-1.09-1.231-1.031c-0.621,0.051-1.094,0.602-1.027,1.234 c0.051,0.625,0.605,1.094,1.227,1.023C639.859,841.266,640.316,840.719,640.254,840.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.379,839.203c-0.031-0.367-0.363-0.645-0.738-0.613 c-0.359,0.039-0.633,0.363-0.602,0.734c0.027,0.367,0.352,0.641,0.73,0.609 C637.133,839.898,637.406,839.574,637.379,839.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.519,842.594c0.02,0.234,0.223,0.414,0.477,0.391c0.227-0.02,0.406-0.234,0.375-0.469 c-0.016-0.234-0.227-0.402-0.469-0.391C637.672,842.152,637.496,842.359,637.519,842.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M640.785,844.461c0.477,0.223,1.047,0.027,1.266-0.449c0.234-0.473,0.039-1.039-0.445-1.262 c-0.461-0.234-1.035-0.039-1.262,0.438C640.121,843.668,640.316,844.227,640.785,844.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.254,845.441c0.281,0.133,0.613,0.012,0.742-0.266c0.148-0.273,0.023-0.602-0.254-0.746 c-0.273-0.129-0.613-0.012-0.746,0.266C638.863,844.969,638.973,845.309,639.254,845.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M642.066,845.305c-0.086,0.172-0.012,0.387,0.168,0.473c0.176,0.09,0.391,0.012,0.48-0.164 c0.082-0.18,0.012-0.395-0.172-0.477C642.367,845.051,642.156,845.121,642.066,845.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M621.715,865.434c-0.453,0.727-0.234,1.684,0.488,2.137 c0.719,0.453,1.676,0.227,2.133-0.492c0.449-0.723,0.231-1.672-0.504-2.133 C623.113,864.492,622.164,864.715,621.715,865.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M620.394,862.789c-0.277,0.422-0.137,0.98,0.285,1.258c0.426,0.262,0.992,0.129,1.25-0.289 c0.273-0.43,0.144-0.992-0.277-1.258C621.223,862.234,620.66,862.356,620.394,862.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M619.309,867.543c-0.16,0.273-0.078,0.641,0.195,0.801c0.269,0.176,0.621,0.098,0.797-0.18 c0.168-0.273,0.094-0.629-0.184-0.805C619.848,867.188,619.488,867.277,619.309,867.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.18,872.742c0.715,0.453,1.672,0.234,2.125-0.492c0.457-0.727,0.234-1.676-0.492-2.133 c-0.723-0.453-1.672-0.23-2.121,0.492C627.234,871.336,627.453,872.285,628.18,872.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M626.656,869.215c0.426,0.262,0.988,0.137,1.246-0.293c0.277-0.422,0.145-0.984-0.281-1.246 c-0.426-0.27-0.984-0.141-1.254,0.289C626.098,868.387,626.227,868.945,626.656,869.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M625.289,872.719c-0.164,0.266-0.086,0.629,0.188,0.809 c0.273,0.172,0.621,0.078,0.805-0.191c0.16-0.266,0.086-0.637-0.188-0.797C625.82,872.367,625.461,872.445,625.289,872.719 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M624.875,861.094c0.625-0.055,1.086-0.609,1.035-1.227c-0.059-0.637-0.609-1.098-1.23-1.043 c-0.633,0.063-1.094,0.609-1.035,1.23C623.703,860.684,624.254,861.148,624.875,861.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M622.414,859.699c0.371-0.035,0.648-0.356,0.609-0.727 c-0.031-0.375-0.348-0.641-0.723-0.609c-0.371,0.031-0.641,0.363-0.609,0.727 C621.719,859.461,622.055,859.734,622.414,859.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M623.172,862.356c0.023,0.242,0.238,0.414,0.469,0.394c0.231-0.023,0.406-0.231,0.387-0.469 c-0.019-0.234-0.227-0.402-0.457-0.383C623.332,861.918,623.152,862.121,623.172,862.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.984,864.559c0.617-0.055,1.086-0.609,1.027-1.23c-0.059-0.633-0.605-1.094-1.227-1.031 c-0.637,0.047-1.098,0.605-1.035,1.227C631.805,864.148,632.359,864.609,632.984,864.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M629.797,862.555c0.031,0.375,0.355,0.645,0.723,0.609c0.375-0.027,0.649-0.359,0.609-0.727 c-0.031-0.371-0.363-0.637-0.723-0.609C630.031,861.863,629.769,862.191,629.797,862.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M631.273,865.832c0.027,0.234,0.231,0.406,0.469,0.387c0.234-0.023,0.406-0.23,0.387-0.469 c-0.023-0.238-0.227-0.406-0.465-0.383C631.43,865.387,631.254,865.59,631.273,865.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.301,857.969c0.535-0.32,0.715-1.016,0.395-1.563c-0.316-0.531-1.012-0.727-1.555-0.402 c-0.539,0.316-0.719,1.016-0.402,1.559C631.051,858.106,631.762,858.289,632.301,857.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M632.496,859.223c-0.191-0.317-0.606-0.418-0.922-0.234 c-0.32,0.191-0.422,0.602-0.234,0.922c0.188,0.313,0.59,0.422,0.906,0.234C632.57,859.957,632.676,859.551,632.496,859.223 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.727,856.82c-0.117-0.203-0.375-0.273-0.582-0.152 c-0.207,0.117-0.269,0.387-0.152,0.586c0.121,0.203,0.379,0.277,0.59,0.152 C634.781,857.289,634.848,857.019,634.727,856.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M624.48,853.66c0.633-0.055,1.094-0.609,1.035-1.242c-0.055-0.621-0.609-1.082-1.23-1.031 c-0.637,0.051-1.094,0.609-1.031,1.234C623.301,853.25,623.859,853.711,624.48,853.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M621.297,851.656c0.027,0.367,0.359,0.645,0.73,0.606c0.363-0.031,0.637-0.356,0.609-0.723 c-0.039-0.375-0.371-0.637-0.727-0.613C621.527,850.961,621.266,851.285,621.297,851.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M622.777,854.922c0.027,0.242,0.234,0.414,0.469,0.395c0.23-0.02,0.402-0.234,0.383-0.469 c-0.016-0.234-0.219-0.406-0.461-0.391C622.934,854.477,622.766,854.691,622.777,854.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M619.949,856.203c0.031,0.629,0.578,1.113,1.191,1.074c0.637-0.039,1.121-0.57,1.086-1.195 c-0.031-0.625-0.57-1.113-1.195-1.082C620.398,855.043,619.91,855.574,619.949,856.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M619.406,858.566c0.023,0.367,0.328,0.652,0.707,0.625c0.363-0.016,0.652-0.336,0.633-0.703 c-0.02-0.367-0.344-0.652-0.703-0.629C619.668,857.879,619.391,858.184,619.406,858.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M623.43,857.824c0.242-0.008,0.418-0.215,0.402-0.449c-0.012-0.234-0.211-0.418-0.445-0.402 c-0.234,0.008-0.414,0.215-0.406,0.445C622.992,857.66,623.195,857.84,623.43,857.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M626.176,855.34c-0.219,0.469-0.023,1.043,0.449,1.266c0.469,0.234,1.043,0.035,1.273-0.438 c0.227-0.469,0.027-1.043-0.445-1.277C626.977,854.668,626.41,854.867,626.176,855.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M624.832,856.84c-0.125,0.289-0.019,0.617,0.262,0.754c0.281,0.133,0.609,0.016,0.742-0.258 c0.137-0.281,0.023-0.617-0.258-0.75C625.301,856.457,624.969,856.566,624.832,856.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.066,857.93c0.188,0.09,0.402,0.008,0.48-0.164c0.09-0.18,0.023-0.395-0.156-0.477 c-0.184-0.09-0.406-0.02-0.488,0.16C627.824,857.629,627.898,857.84,628.066,857.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M626.945,862.121c-0.231,0.477-0.027,1.043,0.441,1.273 c0.477,0.223,1.051,0.027,1.273-0.445c0.23-0.473,0.035-1.043-0.445-1.266 C627.742,861.449,627.172,861.652,626.945,862.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M625.859,864.379c0.277,0.133,0.621,0.012,0.742-0.266c0.141-0.273,0.023-0.609-0.254-0.746 c-0.281-0.137-0.609-0.012-0.746,0.266C625.461,863.906,625.582,864.234,625.859,864.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M628.836,864.715c0.176,0.082,0.402,0.012,0.481-0.168c0.086-0.18,0.019-0.391-0.168-0.477 c-0.176-0.086-0.391-0.012-0.477,0.164C628.59,864.41,628.66,864.625,628.836,864.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.355,868.707c0.633-0.051,1.09-0.609,1.031-1.234c-0.043-0.625-0.613-1.09-1.227-1.035 c-0.629,0.051-1.094,0.621-1.039,1.238C636.184,868.305,636.73,868.762,637.355,868.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M634.898,867.316c0.359-0.035,0.637-0.363,0.609-0.727 c-0.035-0.371-0.359-0.648-0.734-0.609c-0.363,0.027-0.637,0.359-0.605,0.723 C634.207,867.078,634.527,867.344,634.898,867.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M635.652,869.984c0.023,0.234,0.231,0.398,0.469,0.387c0.234-0.027,0.41-0.23,0.391-0.469 c-0.023-0.238-0.23-0.41-0.469-0.387C635.809,869.535,635.633,869.742,635.652,869.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M638.332,854.734c0.629-0.051,1.086-0.602,1.035-1.227c-0.059-0.633-0.606-1.09-1.238-1.039 c-0.625,0.059-1.094,0.609-1.039,1.238C637.16,854.336,637.703,854.793,638.332,854.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M636.48,852.617c-0.027-0.367-0.359-0.641-0.727-0.605c-0.367,0.035-0.645,0.355-0.606,0.73 c0.027,0.367,0.359,0.641,0.719,0.609C636.242,853.313,636.516,852.981,636.48,852.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.48,855.934c-0.023-0.234-0.23-0.414-0.465-0.391c-0.238,0.019-0.402,0.23-0.383,0.465 c0.019,0.238,0.223,0.41,0.457,0.391C637.324,856.371,637.504,856.168,637.48,855.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.996,860.035c-0.059-0.621-0.602-1.086-1.238-1.031 c-0.621,0.059-1.082,0.613-1.031,1.238c0.059,0.621,0.605,1.09,1.238,1.035 C637.586,861.215,638.055,860.66,637.996,860.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M635.109,859.148c-0.031-0.363-0.355-0.637-0.727-0.602 c-0.371,0.027-0.641,0.359-0.609,0.723c0.035,0.371,0.363,0.641,0.727,0.609 C634.875,859.84,635.137,859.519,635.109,859.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M636.109,862.469c-0.016-0.238-0.227-0.414-0.461-0.394c-0.234,0.023-0.41,0.23-0.391,0.465 c0.031,0.234,0.234,0.41,0.469,0.391C635.965,862.91,636.137,862.703,636.109,862.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.352,862.695c-0.473-0.234-1.039-0.031-1.266,0.441 c-0.23,0.469-0.031,1.039,0.438,1.262c0.473,0.231,1.043,0.043,1.27-0.426 C640.019,863.484,639.824,862.922,639.352,862.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M636.992,865.387c0.273,0.129,0.621,0.023,0.746-0.254c0.137-0.281,0.016-0.613-0.258-0.75 c-0.281-0.137-0.613-0.02-0.75,0.262C636.602,864.918,636.715,865.254,636.992,865.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M640.281,865.078c-0.18-0.082-0.391-0.008-0.477,0.168 c-0.078,0.184-0.012,0.398,0.172,0.481c0.172,0.09,0.387,0.012,0.473-0.172 C640.539,865.387,640.461,865.172,640.281,865.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M645.051,891.348c0.727,0.453,1.68,0.23,2.129-0.492c0.457-0.719,0.238-1.676-0.484-2.133 c-0.723-0.449-1.68-0.234-2.133,0.504C644.109,889.945,644.332,890.894,645.051,891.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M643.531,887.82c0.426,0.269,0.992,0.137,1.258-0.285c0.262-0.43,0.137-0.988-0.293-1.258 c-0.418-0.262-0.988-0.137-1.254,0.289C642.98,886.992,643.113,887.555,643.531,887.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M642.973,891.144c-0.27-0.176-0.629-0.09-0.797,0.184c-0.18,0.273-0.098,0.629,0.176,0.797 c0.273,0.176,0.633,0.098,0.809-0.188C643.328,891.672,643.242,891.316,642.973,891.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M638.223,891.305c-0.34,0.531-0.168,1.238,0.359,1.57c0.539,0.34,1.246,0.18,1.582-0.363 c0.336-0.531,0.172-1.234-0.363-1.57C639.269,890.609,638.551,890.769,638.223,891.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M638.172,889.121c-0.316-0.195-0.734-0.098-0.926,0.219 c-0.199,0.32-0.098,0.723,0.211,0.922c0.316,0.195,0.731,0.109,0.93-0.207C638.582,889.742,638.484,889.32,638.172,889.121 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M636.453,892.863c-0.129,0.199-0.063,0.469,0.129,0.59c0.207,0.133,0.481,0.07,0.598-0.133 c0.125-0.203,0.066-0.465-0.145-0.594C636.836,892.598,636.574,892.668,636.453,892.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M649.859,883.168c0.629-0.059,1.098-0.602,1.035-1.231 c-0.055-0.629-0.609-1.098-1.234-1.035c-0.625,0.051-1.086,0.606-1.031,1.234 C648.68,882.758,649.23,883.223,649.859,883.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.281,880.445c-0.367,0.027-0.637,0.348-0.606,0.715 c0.039,0.383,0.356,0.644,0.723,0.613c0.371-0.031,0.641-0.359,0.609-0.734C647.98,880.68,647.652,880.402,647.281,880.445 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M648.16,884.441c0.02,0.234,0.223,0.402,0.457,0.391c0.246-0.027,0.418-0.234,0.394-0.469 c-0.019-0.238-0.227-0.414-0.461-0.395C648.316,883.992,648.137,884.207,648.16,884.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M648.027,874.613c-0.551,0.316-0.73,1.012-0.414,1.559c0.324,0.547,1.023,0.723,1.559,0.406 c0.543-0.316,0.73-1.02,0.402-1.559C649.262,874.473,648.563,874.293,648.027,874.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M649.133,878.754c0.313-0.195,0.43-0.598,0.242-0.914c-0.191-0.316-0.598-0.43-0.922-0.246 c-0.316,0.192-0.418,0.602-0.234,0.926C648.402,878.836,648.813,878.941,649.133,878.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M650.867,875.867c0.129,0.199,0.391,0.266,0.586,0.141c0.203-0.113,0.277-0.383,0.152-0.574 c-0.113-0.207-0.383-0.273-0.582-0.156C650.816,875.394,650.742,875.66,650.867,875.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M643.043,876.484c0.473,0.223,1.043,0.027,1.281-0.445c0.219-0.473,0.02-1.047-0.445-1.273 c-0.473-0.227-1.051-0.027-1.277,0.441C642.383,875.684,642.57,876.25,643.043,876.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M641.519,877.469c0.277,0.125,0.606,0.016,0.746-0.262c0.137-0.273,0.016-0.617-0.258-0.754 c-0.277-0.125-0.621-0.016-0.746,0.266C641.125,877,641.242,877.328,641.519,877.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M644.332,877.324c-0.09,0.18-0.008,0.394,0.164,0.48c0.176,0.082,0.391,0.004,0.48-0.172 c0.094-0.176,0.016-0.395-0.164-0.477C644.629,877.074,644.422,877.148,644.332,877.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M637.894,885.414c-0.23,0.477-0.023,1.047,0.449,1.277c0.465,0.23,1.035,0.027,1.269-0.445 c0.227-0.473,0.02-1.047-0.457-1.273C638.688,884.746,638.125,884.941,637.894,885.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M636.547,886.926c-0.137,0.273-0.016,0.609,0.258,0.746c0.285,0.137,0.617,0.02,0.742-0.266 c0.137-0.273,0.031-0.613-0.25-0.738C637.016,886.531,636.676,886.648,636.547,886.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M640.262,887.84c0.082-0.18,0.012-0.387-0.172-0.473c-0.172-0.086-0.383-0.008-0.477,0.168 c-0.078,0.176,0,0.383,0.172,0.465C639.961,888.094,640.176,888.019,640.262,887.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.129,873.613c-0.309-0.426-0.898-0.516-1.328-0.207 c-0.418,0.313-0.516,0.906-0.195,1.324c0.297,0.43,0.898,0.516,1.316,0.211 C639.352,874.633,639.445,874.035,639.129,873.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.078,876.758c0.25-0.188,0.301-0.535,0.121-0.789c-0.18-0.246-0.531-0.297-0.785-0.117 c-0.25,0.188-0.301,0.531-0.121,0.777C638.473,876.879,638.828,876.934,639.078,876.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M640.852,873.785c-0.117-0.164-0.34-0.199-0.508-0.078c-0.156,0.113-0.184,0.34-0.07,0.504 c0.121,0.16,0.34,0.188,0.5,0.07C640.93,874.164,640.969,873.941,640.852,873.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M645.539,881.563c0.23-0.481,0.027-1.043-0.438-1.273c-0.473-0.231-1.043-0.027-1.273,0.445 c-0.227,0.465-0.035,1.031,0.445,1.266C644.746,882.223,645.309,882.027,645.539,881.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M643.488,882.719c0.137-0.281,0.016-0.605-0.258-0.742 c-0.285-0.137-0.613-0.016-0.758,0.258c-0.129,0.281-0.008,0.617,0.27,0.75 C643.019,883.113,643.348,883.004,643.488,882.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M646.203,883.16c0.082-0.18,0.004-0.395-0.176-0.488c-0.176-0.078-0.391-0.012-0.473,0.172 c-0.086,0.176-0.016,0.387,0.168,0.477C645.898,883.402,646.113,883.328,646.203,883.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.391,894.867c-0.234,0.473-0.035,1.047,0.438,1.277 c0.477,0.227,1.043,0.027,1.273-0.445c0.227-0.477,0.027-1.043-0.441-1.27C640.18,894.199,639.613,894.398,639.391,894.867 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M638.035,896.383c-0.133,0.277-0.008,0.609,0.258,0.746 c0.285,0.129,0.621,0.012,0.758-0.262c0.125-0.281,0.012-0.617-0.262-0.75 C638.508,895.981,638.172,896.098,638.035,896.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M641.598,896.82c-0.184-0.086-0.398-0.012-0.488,0.16c-0.082,0.188-0.008,0.394,0.176,0.484 c0.172,0.086,0.379,0.008,0.477-0.168C641.836,897.117,641.769,896.906,641.598,896.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M650.387,893.352c0.731,0.457,1.691,0.234,2.137-0.488c0.461-0.727,0.234-1.68-0.496-2.133 c-0.715-0.453-1.672-0.234-2.125,0.492C649.445,891.938,649.676,892.902,650.387,893.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M648.582,888.578c-0.262,0.422-0.133,0.984,0.301,1.25c0.418,0.258,0.977,0.133,1.242-0.285 c0.262-0.43,0.141-0.992-0.289-1.258C649.41,888.019,648.844,888.148,648.582,888.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.691,894.133c0.285,0.172,0.641,0.086,0.805-0.184c0.172-0.27,0.086-0.629-0.18-0.801 c-0.277-0.172-0.633-0.09-0.809,0.184C647.34,893.606,647.426,893.965,647.691,894.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.57,895.164c-0.824,0.199-1.34,1.043-1.137,1.871c0.129,0.492,0.469,0.855,0.898,1.051 h1.219c0.68-0.297,1.082-1.043,0.891-1.785C649.23,895.473,648.402,894.961,647.57,895.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M644.285,895.027c-0.492,0.121-0.793,0.613-0.664,1.102 c0.113,0.492,0.613,0.793,1.098,0.672c0.488-0.121,0.781-0.609,0.676-1.102 C645.266,895.211,644.773,894.914,644.285,895.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M654.223,895.789c-0.723,0.453-0.945,1.406-0.488,2.129 c0.039,0.063,0.086,0.117,0.129,0.168h2.363c0.422-0.5,0.5-1.227,0.133-1.813 C655.902,895.555,654.953,895.336,654.223,895.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M655.164,894.371c0.07-0.051,0.129-0.105,0.188-0.164c-0.141,0.031-0.301,0.008-0.434-0.074 c-0.277-0.168-0.356-0.527-0.188-0.801c0.164-0.242,0.453-0.328,0.715-0.215l0,0c-0.266-0.422-0.816-0.559-1.242-0.293 c-0.43,0.273-0.563,0.836-0.293,1.258C654.184,894.512,654.738,894.633,655.164,894.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M651.949,896.828c-0.168-0.27-0.523-0.359-0.797-0.188c-0.269,0.18-0.352,0.531-0.188,0.797 c0.168,0.277,0.539,0.356,0.805,0.191C652.039,897.453,652.125,897.098,651.949,896.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M655.269,886.082c-0.055-0.625-0.609-1.09-1.23-1.031c-0.633,0.051-1.094,0.602-1.035,1.23 c0.059,0.629,0.609,1.094,1.238,1.039C654.863,887.262,655.32,886.711,655.269,886.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M651.769,885.926c0.379-0.035,0.649-0.363,0.613-0.73c-0.031-0.363-0.359-0.645-0.727-0.609 c-0.367,0.039-0.633,0.356-0.602,0.727C651.082,885.68,651.414,885.957,651.769,885.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M652.992,888.965c0.238-0.008,0.414-0.211,0.391-0.453 c-0.012-0.238-0.231-0.414-0.453-0.395c-0.242,0.027-0.414,0.234-0.395,0.469 C652.555,888.82,652.758,888.996,652.992,888.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M656.246,872.109c-0.059-0.625-0.613-1.086-1.231-1.031 c-0.629,0.055-1.094,0.605-1.039,1.234c0.055,0.625,0.609,1.086,1.234,1.035 C655.844,873.293,656.301,872.727,656.246,872.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M652.754,871.949c0.367-0.031,0.637-0.348,0.609-0.723c-0.039-0.375-0.359-0.637-0.73-0.609 c-0.375,0.031-0.637,0.363-0.609,0.727C652.051,871.715,652.383,871.984,652.754,871.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M653.894,874.156c-0.234,0.008-0.406,0.223-0.387,0.469 c0.027,0.223,0.227,0.394,0.461,0.379c0.242-0.02,0.418-0.231,0.387-0.465 C654.344,874.301,654.137,874.125,653.894,874.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.832,876.762c-0.625,0.051-1.086,0.609-1.035,1.234c0.051,0.629,0.609,1.086,1.23,1.031 c0.633-0.055,1.09-0.609,1.035-1.238C663.012,877.168,662.453,876.699,661.832,876.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M660.184,876.902c-0.043-0.371-0.363-0.641-0.731-0.602 c-0.375,0.027-0.644,0.348-0.609,0.719c0.031,0.371,0.355,0.641,0.73,0.606 C659.941,877.594,660.215,877.269,660.184,876.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.18,880.215c-0.016-0.234-0.231-0.406-0.465-0.383c-0.234,0.02-0.414,0.223-0.391,0.461 c0.027,0.23,0.231,0.414,0.473,0.391C661.027,880.664,661.207,880.453,661.18,880.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M653.641,877.613c-0.629,0.055-1.098,0.609-1.031,1.238c0.059,0.625,0.609,1.082,1.23,1.023 c0.633-0.047,1.086-0.598,1.035-1.227C654.82,878.019,654.269,877.555,653.641,877.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M650.656,877.879c0.027,0.363,0.359,0.641,0.73,0.609c0.363-0.035,0.637-0.355,0.609-0.727 c-0.039-0.371-0.359-0.645-0.734-0.606C650.894,877.191,650.625,877.508,650.656,877.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M652.535,880.684c-0.25,0.023-0.41,0.234-0.395,0.469c0.02,0.234,0.231,0.41,0.461,0.391 c0.234-0.027,0.41-0.234,0.387-0.469C652.973,880.84,652.758,880.664,652.535,880.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M656.676,882.574c0.231-0.477,0.031-1.043-0.449-1.277c-0.473-0.223-1.043-0.027-1.27,0.449 c-0.227,0.461-0.031,1.043,0.453,1.266C655.883,883.242,656.438,883.043,656.676,882.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M653.871,883.996c0.273,0.133,0.609,0.016,0.758-0.262c0.129-0.273,0.012-0.609-0.273-0.746 c-0.27-0.137-0.602-0.02-0.742,0.258C653.48,883.527,653.594,883.859,653.871,883.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M657.164,883.691c-0.176-0.086-0.395-0.012-0.477,0.16c-0.09,0.184-0.012,0.394,0.164,0.488 c0.184,0.082,0.395,0,0.477-0.172C657.418,883.988,657.34,883.773,657.164,883.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M659.746,892.863c0.449-0.727,0.234-1.68-0.488-2.133c-0.731-0.453-1.684-0.234-2.133,0.492 c-0.457,0.715-0.238,1.68,0.488,2.129C658.344,893.809,659.289,893.586,659.746,892.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M657.344,889.543c0.269-0.43,0.141-0.992-0.289-1.258c-0.422-0.266-0.977-0.137-1.254,0.293 c-0.266,0.422-0.129,0.984,0.289,1.25C656.519,890.086,657.082,889.961,657.344,889.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M654.73,893.332c-0.168,0.274-0.09,0.633,0.188,0.801c0.133,0.082,0.293,0.105,0.434,0.074 c0.145-0.031,0.277-0.121,0.359-0.258c0.176-0.27,0.09-0.629-0.184-0.801c-0.023-0.019-0.055-0.019-0.082-0.031 C655.184,893.004,654.894,893.09,654.73,893.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M663.578,896.273c-0.457-0.719-1.414-0.938-2.129-0.484 c-0.73,0.453-0.949,1.406-0.492,2.129c0.039,0.063,0.078,0.117,0.117,0.168h2.375 C663.867,897.586,663.945,896.859,663.578,896.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M662.672,893.117c-0.262-0.422-0.832-0.559-1.25-0.293 c-0.434,0.273-0.566,0.836-0.293,1.258c0.269,0.43,0.824,0.551,1.254,0.289 C662.809,894.102,662.934,893.547,662.672,893.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M658.184,897.438c0.18,0.277,0.539,0.356,0.801,0.191c0.273-0.176,0.363-0.531,0.191-0.801 c-0.176-0.27-0.527-0.359-0.805-0.188C658.098,896.82,658.012,897.172,658.184,897.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.258,885.051c-0.625,0.051-1.094,0.602-1.035,1.23c0.051,0.629,0.605,1.094,1.234,1.039 c0.629-0.059,1.09-0.609,1.035-1.238C662.43,885.457,661.883,884.992,661.258,885.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M659.605,885.195c-0.031-0.363-0.355-0.645-0.73-0.609 c-0.367,0.039-0.637,0.356-0.606,0.727c0.035,0.367,0.359,0.644,0.727,0.613 C659.367,885.891,659.633,885.563,659.605,885.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M660.609,888.512c-0.027-0.238-0.23-0.414-0.469-0.395 c-0.234,0.027-0.406,0.234-0.387,0.469c0.027,0.234,0.227,0.41,0.469,0.379 C660.457,888.957,660.633,888.754,660.609,888.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M664.262,860.883c-0.047-0.629-0.609-1.082-1.227-1.031 c-0.625,0.059-1.094,0.609-1.039,1.23c0.059,0.629,0.609,1.098,1.227,1.039 C663.859,862.066,664.316,861.512,664.262,860.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M660.043,860.117c0.027,0.367,0.355,0.641,0.73,0.609c0.367-0.039,0.645-0.356,0.613-0.723 c-0.043-0.371-0.359-0.641-0.734-0.609C660.281,859.422,660.012,859.75,660.043,860.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.992,863.777c0.234-0.019,0.418-0.223,0.391-0.457c-0.02-0.242-0.231-0.414-0.469-0.391 c-0.234,0.012-0.41,0.227-0.391,0.465C661.547,863.625,661.754,863.801,661.992,863.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M663.449,881.297c-0.477-0.223-1.039-0.027-1.266,0.449 c-0.231,0.461-0.031,1.043,0.438,1.266c0.477,0.23,1.043,0.031,1.277-0.438 C664.121,882.098,663.926,881.531,663.449,881.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.578,882.988c-0.281-0.137-0.609-0.02-0.742,0.258c-0.137,0.281-0.023,0.613,0.25,0.75 c0.285,0.133,0.617,0.016,0.754-0.262C661.973,883.461,661.863,883.125,661.578,882.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M664.551,884.168c0.086-0.18,0.008-0.395-0.168-0.477c-0.168-0.086-0.395-0.012-0.477,0.16 c-0.082,0.184-0.008,0.394,0.164,0.488C664.246,884.422,664.461,884.34,664.551,884.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M646.492,847.125c0.461-0.723,0.238-1.672-0.481-2.129c-0.73-0.453-1.68-0.234-2.133,0.492 c-0.449,0.73-0.231,1.68,0.484,2.133C645.09,848.074,646.039,847.852,646.492,847.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M643.82,842.555c-0.43-0.273-0.996-0.141-1.258,0.281c-0.277,0.43-0.141,0.992,0.285,1.25 c0.426,0.273,0.992,0.145,1.258-0.285C644.363,843.379,644.242,842.816,643.82,842.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M642.469,848.211c0.168-0.266,0.094-0.629-0.184-0.797c-0.27-0.172-0.629-0.086-0.809,0.188 c-0.16,0.269-0.078,0.625,0.188,0.797C641.941,848.57,642.305,848.488,642.469,848.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M651.988,850.172c-0.73-0.453-1.68-0.234-2.137,0.492c-0.461,0.723-0.23,1.68,0.484,2.129 c0.727,0.457,1.684,0.238,2.137-0.488C652.93,851.578,652.707,850.625,651.988,850.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M650.07,848.977c0.266-0.422,0.144-0.984-0.293-1.258c-0.418-0.262-0.973-0.137-1.242,0.289 c-0.27,0.43-0.141,0.992,0.289,1.262C649.242,849.531,649.809,849.406,650.07,848.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.644,853.574c0.266,0.168,0.633,0.086,0.805-0.184c0.168-0.273,0.086-0.637-0.188-0.805 c-0.273-0.168-0.633-0.09-0.809,0.188C647.293,853.039,647.371,853.402,647.644,853.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.039,841.148c0.637-0.055,1.098-0.609,1.039-1.238 c-0.051-0.629-0.609-1.086-1.234-1.027c-0.629,0.047-1.09,0.602-1.031,1.227 C645.871,840.738,646.414,841.207,647.039,841.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M644.469,838.418c-0.363,0.031-0.641,0.355-0.609,0.723 c0.031,0.375,0.355,0.648,0.723,0.609c0.371-0.031,0.648-0.363,0.617-0.723 C645.16,838.656,644.832,838.383,644.469,838.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M646.203,842.34c-0.027-0.238-0.234-0.41-0.473-0.391c-0.234,0.016-0.402,0.23-0.391,0.465 c0.023,0.234,0.227,0.41,0.469,0.391C646.039,842.781,646.215,842.574,646.203,842.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M654.559,842.953c-0.629,0.066-1.09,0.609-1.039,1.238c0.055,0.625,0.617,1.094,1.242,1.035 s1.09-0.606,1.027-1.238C655.73,843.363,655.18,842.902,654.559,842.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M652.18,842.496c-0.371,0.035-0.645,0.359-0.609,0.731c0.035,0.363,0.355,0.644,0.727,0.605 c0.375-0.031,0.637-0.355,0.609-0.726C652.875,842.731,652.543,842.461,652.18,842.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M653.519,846.883c0.234-0.02,0.41-0.227,0.391-0.461c-0.027-0.242-0.238-0.406-0.465-0.387 c-0.242,0.019-0.414,0.227-0.383,0.465C653.074,846.734,653.285,846.902,653.519,846.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M654.289,835.977h-0.809c-0.07,0.019-0.117,0.039-0.172,0.078 c-0.551,0.324-0.727,1.016-0.402,1.555c0.313,0.551,1.012,0.727,1.563,0.41c0.535-0.316,0.715-1.012,0.394-1.555 C654.73,836.227,654.519,836.07,654.289,835.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M653.5,839.965c0.191,0.316,0.598,0.418,0.914,0.231c0.324-0.184,0.43-0.598,0.246-0.914 c-0.188-0.316-0.602-0.426-0.918-0.242C653.422,839.227,653.32,839.641,653.5,839.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M656.894,836.875c-0.117-0.211-0.375-0.273-0.59-0.156 c-0.203,0.121-0.262,0.383-0.145,0.586c0.117,0.203,0.379,0.27,0.586,0.156 C656.949,837.336,657.016,837.074,656.894,836.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M642.117,836.25c0.031,0.629,0.578,1.113,1.191,1.078c0.637-0.035,1.113-0.566,1.086-1.199 c0-0.055-0.019-0.102-0.023-0.152h-2.223C642.117,836.07,642.109,836.16,642.117,836.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M642.207,837.914c-0.371,0.019-0.648,0.324-0.633,0.703 c0.023,0.363,0.328,0.652,0.707,0.625c0.363-0.019,0.652-0.332,0.633-0.707 C642.887,838.172,642.57,837.887,642.207,837.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M645.598,837.879c0.238-0.02,0.418-0.215,0.41-0.449c-0.02-0.234-0.219-0.418-0.453-0.402 c-0.234,0.008-0.422,0.211-0.406,0.445C645.16,837.711,645.359,837.887,645.598,837.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M650.824,843.008c0.231-0.477,0.031-1.047-0.441-1.277c-0.473-0.227-1.043-0.027-1.27,0.445 c-0.23,0.469-0.027,1.043,0.441,1.266C650.031,843.668,650.598,843.477,650.824,843.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M648.516,843.422c-0.281-0.141-0.613-0.02-0.746,0.266 c-0.141,0.269-0.027,0.602,0.258,0.742c0.27,0.133,0.609,0.02,0.75-0.262C648.91,843.891,648.793,843.555,648.516,843.422z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M650.84,844.285c-0.082,0.183-0.012,0.394,0.164,0.477c0.188,0.094,0.402,0.016,0.48-0.16 c0.086-0.18,0.008-0.391-0.168-0.477C651.141,844.031,650.926,844.106,650.84,844.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M658.977,850.949c0.629-0.047,1.09-0.598,1.035-1.227c-0.051-0.629-0.605-1.094-1.234-1.039 c-0.625,0.059-1.086,0.613-1.035,1.242C657.801,850.547,658.363,851.008,658.977,850.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M656.519,849.563c0.367-0.031,0.645-0.363,0.606-0.727 c-0.031-0.371-0.356-0.644-0.727-0.609c-0.355,0.039-0.644,0.363-0.609,0.73 C655.828,849.328,656.148,849.59,656.519,849.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M657.66,851.762c-0.234,0.019-0.402,0.227-0.383,0.461c0.023,0.234,0.227,0.406,0.465,0.387 c0.234-0.02,0.41-0.227,0.387-0.461C658.109,851.914,657.902,851.742,657.66,851.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M658.777,839.254c0.063,0.625,0.609,1.094,1.234,1.035c0.629-0.055,1.09-0.609,1.035-1.231 c-0.051-0.637-0.609-1.09-1.238-1.039C659.184,838.074,658.723,838.629,658.777,839.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M657.438,837.555c-0.371,0.039-0.644,0.363-0.609,0.734 c0.027,0.367,0.356,0.637,0.727,0.605c0.367-0.027,0.637-0.359,0.609-0.73 C658.129,837.801,657.801,837.527,657.438,837.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M658.777,841.945c0.238-0.023,0.406-0.227,0.387-0.469c-0.02-0.231-0.227-0.406-0.465-0.383 c-0.234,0.02-0.41,0.223-0.391,0.457C658.332,841.797,658.539,841.965,658.777,841.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M659.648,843.758c-0.23,0.469-0.031,1.039,0.449,1.273c0.473,0.223,1.031,0.027,1.266-0.449 c0.234-0.469,0.035-1.043-0.445-1.266C660.449,843.086,659.879,843.281,659.648,843.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M659.043,844.996c-0.266-0.125-0.602-0.008-0.738,0.27 c-0.137,0.277-0.016,0.609,0.262,0.742c0.277,0.133,0.609,0.019,0.75-0.258 C659.445,845.465,659.332,845.137,659.043,844.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.371,845.867c-0.082,0.18-0.008,0.395,0.176,0.484c0.176,0.082,0.391,0.004,0.48-0.172 c0.078-0.176,0-0.391-0.172-0.477C661.68,845.613,661.465,845.691,661.371,845.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M664.777,847.758c-0.621,0.09-1.051,0.672-0.965,1.285c0.094,0.625,0.668,1.055,1.297,0.965 c0.621-0.086,1.043-0.676,0.957-1.293C665.98,848.094,665.398,847.668,664.777,847.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.391,846.316c-0.055-0.359-0.398-0.617-0.758-0.566 c-0.371,0.055-0.625,0.391-0.578,0.762c0.07,0.371,0.402,0.613,0.769,0.566 C666.195,847.023,666.441,846.688,666.391,846.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M662.445,847.418c-0.234,0.039-0.391,0.258-0.352,0.488c0.031,0.231,0.25,0.398,0.484,0.359 c0.231-0.035,0.383-0.242,0.356-0.477C662.902,847.543,662.688,847.387,662.445,847.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.871,855.574c-0.094-0.613-0.672-1.055-1.293-0.957 c-0.629,0.09-1.055,0.668-0.965,1.289c0.094,0.625,0.668,1.051,1.293,0.969 C661.523,856.773,661.961,856.195,661.871,855.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M662.195,853.176c-0.051-0.359-0.395-0.617-0.758-0.566 c-0.367,0.059-0.625,0.395-0.563,0.762c0.055,0.367,0.387,0.625,0.75,0.57C661.992,853.887,662.25,853.543,662.195,853.176 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M658.25,854.277c-0.238,0.039-0.398,0.254-0.356,0.488c0.027,0.234,0.242,0.398,0.488,0.359 c0.227-0.027,0.394-0.25,0.355-0.488C658.707,854.414,658.488,854.242,658.25,854.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.047,855.301c0.199-0.488-0.031-1.043-0.523-1.246c-0.477-0.195-1.043,0.031-1.238,0.52 c-0.203,0.484,0.031,1.039,0.508,1.238C665.281,856.016,665.836,855.789,666.047,855.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M664.246,853.527c0.129-0.289-0.012-0.613-0.301-0.727 c-0.281-0.121-0.609,0.016-0.731,0.297c-0.117,0.285,0.008,0.613,0.301,0.73 C663.801,853.945,664.129,853.809,664.246,853.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M663.25,856.566c0.18,0.074,0.383-0.016,0.461-0.203c0.074-0.176-0.008-0.387-0.195-0.457 c-0.18-0.078-0.394,0-0.465,0.188C662.973,856.273,663.059,856.484,663.25,856.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M649.719,870.117c-0.723-0.453-1.68-0.23-2.129,0.492c-0.453,0.727-0.234,1.676,0.488,2.133 c0.727,0.453,1.68,0.234,2.129-0.492C650.664,871.523,650.449,870.574,649.719,870.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.813,868.922c0.266-0.422,0.133-0.984-0.285-1.246c-0.43-0.27-0.996-0.141-1.258,0.289 c-0.262,0.422-0.137,0.981,0.293,1.25C646.98,869.477,647.551,869.352,647.813,868.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M646.176,873.336c0.18-0.266,0.094-0.637-0.18-0.797c-0.273-0.172-0.633-0.094-0.797,0.18 c-0.176,0.266-0.094,0.629,0.184,0.809C645.656,873.699,646.012,873.606,646.176,873.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M644.441,867.91c-0.484-0.703-1.449-0.871-2.148-0.387 c-0.695,0.488-0.875,1.449-0.391,2.148c0.488,0.707,1.457,0.879,2.156,0.391 C644.758,869.582,644.934,868.609,644.441,867.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M643.16,866.066c0.422-0.289,0.516-0.856,0.23-1.27c-0.277-0.41-0.852-0.512-1.266-0.23 c-0.414,0.289-0.52,0.859-0.231,1.266C642.188,866.25,642.75,866.352,643.16,866.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M639.93,869.477c0.258-0.184,0.324-0.543,0.144-0.809c-0.184-0.258-0.547-0.328-0.805-0.145 c-0.269,0.18-0.336,0.547-0.152,0.813C639.309,869.602,639.668,869.664,639.93,869.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M644.582,858.824c-0.625,0.063-1.094,0.609-1.031,1.23c0.051,0.629,0.606,1.094,1.238,1.039 c0.621-0.055,1.09-0.609,1.023-1.227C645.758,859.231,645.207,858.769,644.582,858.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M642.207,858.363c-0.371,0.031-0.644,0.363-0.609,0.727 c0.027,0.371,0.355,0.645,0.727,0.609c0.371-0.035,0.637-0.356,0.609-0.727 C642.887,858.598,642.57,858.332,642.207,858.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M643.938,862.281c-0.027-0.234-0.231-0.402-0.469-0.383c-0.238,0.02-0.41,0.223-0.387,0.457 c0.02,0.242,0.227,0.414,0.469,0.394C643.773,862.727,643.957,862.519,643.938,862.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M653.918,863.328c-0.055-0.633-0.609-1.094-1.231-1.031 c-0.637,0.047-1.09,0.605-1.039,1.227c0.059,0.625,0.609,1.086,1.238,1.035 C653.508,864.504,653.977,863.949,653.918,863.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M650.309,861.828c-0.371,0.035-0.637,0.363-0.609,0.727 c0.031,0.375,0.359,0.645,0.727,0.609c0.371-0.027,0.637-0.359,0.609-0.727C651,862.066,650.668,861.801,650.309,861.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M651.57,865.367c-0.238,0.02-0.41,0.223-0.391,0.465c0.019,0.234,0.234,0.406,0.457,0.387 c0.246-0.023,0.414-0.23,0.391-0.469C652.019,865.512,651.805,865.344,651.57,865.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M652.199,857.969c0.547-0.32,0.731-1.016,0.402-1.563c-0.316-0.531-1.012-0.727-1.547-0.402 c-0.547,0.316-0.731,1.016-0.414,1.559S651.656,858.289,652.199,857.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M652.398,859.223c-0.191-0.317-0.605-0.418-0.922-0.234 c-0.316,0.191-0.422,0.602-0.234,0.922c0.191,0.313,0.598,0.422,0.914,0.234 C652.473,859.957,652.582,859.551,652.398,859.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M653.894,857.254c0.121,0.203,0.379,0.277,0.586,0.152c0.207-0.117,0.277-0.387,0.148-0.586 c-0.121-0.203-0.379-0.273-0.578-0.152C653.84,856.785,653.773,857.055,653.894,857.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M644.394,853.66c0.621-0.055,1.086-0.609,1.027-1.242c-0.059-0.621-0.609-1.082-1.238-1.031 c-0.621,0.051-1.082,0.609-1.031,1.234C643.215,853.25,643.766,853.711,644.394,853.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M642.539,851.539c-0.031-0.375-0.363-0.637-0.73-0.613c-0.367,0.035-0.641,0.359-0.609,0.73 c0.043,0.367,0.359,0.645,0.723,0.606C642.305,852.231,642.566,851.906,642.539,851.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M643.074,854.457c-0.234,0.02-0.406,0.234-0.379,0.465c0.008,0.242,0.223,0.414,0.457,0.395 c0.238-0.02,0.41-0.234,0.391-0.469C643.516,854.613,643.309,854.441,643.074,854.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.355,854.891c-0.477-0.223-1.039-0.023-1.27,0.449 c-0.227,0.469-0.031,1.043,0.441,1.266c0.473,0.234,1.043,0.035,1.273-0.438 C648.027,855.699,647.828,855.125,647.355,854.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M645.488,856.586c-0.281-0.129-0.617-0.019-0.758,0.254 c-0.129,0.289-0.012,0.617,0.273,0.754c0.277,0.133,0.602,0.016,0.746-0.258 C645.879,857.055,645.758,856.719,645.488,856.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M647.813,857.449c-0.082,0.18-0.004,0.391,0.168,0.48c0.18,0.09,0.383,0.008,0.473-0.164 c0.09-0.18,0.016-0.395-0.16-0.477C648.105,857.199,647.898,857.269,647.813,857.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M646.848,862.121c-0.227,0.477-0.023,1.043,0.449,1.273 c0.473,0.223,1.039,0.027,1.266-0.445c0.231-0.473,0.031-1.043-0.445-1.266 C647.644,861.449,647.082,861.652,646.848,862.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M645.5,863.633c-0.137,0.273-0.012,0.602,0.269,0.746c0.27,0.133,0.606,0.012,0.742-0.266 c0.133-0.273,0.016-0.609-0.266-0.746C645.973,863.231,645.637,863.356,645.5,863.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M649.223,864.547c0.086-0.18,0.008-0.391-0.172-0.477c-0.168-0.086-0.383-0.012-0.473,0.164 c-0.086,0.176-0.016,0.391,0.172,0.48C648.926,864.797,649.133,864.727,649.223,864.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M658.293,867.473c-0.055-0.625-0.602-1.09-1.238-1.035 c-0.621,0.051-1.086,0.621-1.031,1.238c0.063,0.629,0.613,1.086,1.242,1.031 C657.883,868.656,658.352,868.098,658.293,867.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M654.688,865.981c-0.375,0.027-0.648,0.359-0.609,0.723 c0.031,0.375,0.356,0.641,0.719,0.613c0.379-0.035,0.648-0.363,0.617-0.727 C655.375,866.219,655.051,865.941,654.688,865.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M655.945,869.516c-0.234,0.02-0.41,0.227-0.391,0.469c0.031,0.234,0.234,0.398,0.469,0.387 c0.234-0.027,0.41-0.23,0.387-0.469C656.391,869.664,656.18,869.492,655.945,869.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M662.055,870.219c-0.629,0.059-1.086,0.613-1.027,1.242 c0.047,0.629,0.609,1.078,1.231,1.027c0.629-0.051,1.09-0.602,1.035-1.23C663.238,870.629,662.68,870.16,662.055,870.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M659.676,869.762c-0.359,0.035-0.633,0.359-0.602,0.73c0.027,0.359,0.356,0.633,0.731,0.606 c0.359-0.039,0.633-0.359,0.594-0.727C660.371,870.004,660.043,869.727,659.676,869.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M661.418,873.688c-0.027-0.242-0.238-0.41-0.473-0.391c-0.234,0.02-0.414,0.23-0.391,0.465 c0.023,0.234,0.223,0.402,0.461,0.394C661.258,874.121,661.426,873.922,661.418,873.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M656.91,853.238c-0.059-0.629-0.605-1.086-1.238-1.035 c-0.629,0.066-1.086,0.617-1.031,1.242c0.055,0.629,0.609,1.086,1.242,1.031C656.5,854.418,656.969,853.867,656.91,853.238 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M652.688,852.481c0.039,0.359,0.363,0.637,0.723,0.601c0.383-0.031,0.645-0.359,0.617-0.723 c-0.035-0.371-0.363-0.645-0.73-0.617C652.93,851.781,652.656,852.109,652.688,852.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M654.641,856.137c0.234-0.02,0.402-0.231,0.383-0.465c-0.019-0.234-0.227-0.41-0.461-0.391 c-0.234,0.02-0.41,0.231-0.379,0.469C654.203,855.984,654.406,856.148,654.641,856.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M657.902,860.035c-0.063-0.621-0.605-1.086-1.242-1.031 c-0.617,0.059-1.086,0.613-1.031,1.238c0.055,0.621,0.605,1.09,1.238,1.035 C657.488,861.215,657.953,860.66,657.902,860.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M655.016,859.148c-0.035-0.363-0.355-0.637-0.727-0.602 c-0.371,0.027-0.648,0.359-0.617,0.723c0.043,0.371,0.367,0.641,0.734,0.609 C654.777,859.84,655.043,859.519,655.016,859.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M655.555,862.074c-0.242,0.023-0.418,0.23-0.391,0.465c0.02,0.234,0.23,0.41,0.465,0.391 c0.234-0.019,0.414-0.227,0.394-0.461C655.988,862.231,655.789,862.055,655.555,862.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M659.258,862.695c-0.477-0.234-1.047-0.031-1.277,0.441 c-0.223,0.469-0.027,1.039,0.445,1.262c0.481,0.231,1.039,0.043,1.266-0.426 C659.93,863.484,659.727,862.922,659.258,862.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M657.383,864.383c-0.277-0.137-0.613-0.02-0.746,0.262 c-0.137,0.274-0.016,0.609,0.258,0.742c0.277,0.129,0.621,0.023,0.746-0.254 C657.773,864.852,657.66,864.519,657.383,864.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M660.355,865.555c0.082-0.168,0.004-0.383-0.16-0.477c-0.188-0.082-0.391-0.008-0.488,0.168 c-0.082,0.184-0.004,0.398,0.172,0.481C660.051,865.816,660.266,865.738,660.355,865.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M664.863,891.266c-0.48,0.223-0.676,0.793-0.445,1.266c0.223,0.469,0.793,0.668,1.266,0.445 c0.469-0.234,0.668-0.793,0.441-1.273C665.894,891.227,665.328,891.031,664.863,891.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M664.07,890.547c-0.133-0.285-0.465-0.406-0.742-0.27c-0.277,0.141-0.394,0.473-0.258,0.746 c0.125,0.281,0.465,0.398,0.742,0.262C664.09,891.152,664.215,890.816,664.07,890.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.789,890.106c-0.09-0.176-0.305-0.254-0.48-0.164c-0.184,0.086-0.258,0.297-0.176,0.477 c0.094,0.18,0.309,0.258,0.488,0.168C666.797,890.496,666.867,890.285,666.789,890.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M671.262,844.863c-0.457-0.73-1.41-0.949-2.141-0.496c-0.711,0.449-0.941,1.41-0.488,2.141 c0.457,0.719,1.406,0.938,2.137,0.484C671.496,846.539,671.711,845.586,671.262,844.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M667.609,847.894c-0.426,0.27-0.566,0.828-0.293,1.254c0.273,0.426,0.824,0.559,1.258,0.285 c0.43-0.262,0.547-0.824,0.285-1.25C668.594,847.758,668.039,847.633,667.609,847.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.246,844.391c0.164,0.273,0.523,0.348,0.797,0.191c0.273-0.176,0.363-0.531,0.187-0.809 c-0.172-0.269-0.531-0.352-0.809-0.184C666.152,843.762,666.074,844.113,666.246,844.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M673.73,854.824c0.633,0.051,1.184-0.41,1.234-1.039c0.059-0.625-0.406-1.176-1.031-1.238 c-0.633-0.051-1.18,0.414-1.238,1.039C672.641,854.211,673.102,854.766,673.73,854.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M672.078,854.672c0.027-0.363-0.238-0.691-0.609-0.727 c-0.363-0.027-0.692,0.238-0.723,0.609c-0.035,0.367,0.234,0.695,0.613,0.727 C671.715,855.309,672.047,855.043,672.078,854.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M673.082,851.359c0.02-0.234-0.152-0.445-0.387-0.465c-0.242-0.019-0.438,0.149-0.469,0.391 c-0.008,0.234,0.156,0.438,0.391,0.457C672.852,851.762,673.063,851.594,673.082,851.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M673.25,859.141c-0.543-0.316-1.246-0.133-1.566,0.41c-0.313,0.539-0.129,1.242,0.414,1.559 c0.543,0.309,1.23,0.141,1.555-0.41C673.973,860.156,673.785,859.461,673.25,859.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M672.523,858.121c0.324,0.184,0.734,0.082,0.926-0.242c0.184-0.316,0.07-0.731-0.246-0.914 c-0.324-0.191-0.727-0.074-0.91,0.234C672.102,857.523,672.207,857.938,672.523,858.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M675.098,860.445c0.203,0.117,0.461,0.051,0.578-0.156c0.129-0.199,0.055-0.469-0.156-0.586 c-0.199-0.113-0.453-0.051-0.582,0.148C674.824,860.055,674.894,860.328,675.098,860.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.684,860.504c0.215,0.477,0.789,0.672,1.266,0.445c0.473-0.231,0.672-0.793,0.445-1.27 c-0.238-0.473-0.805-0.668-1.281-0.441C666.652,859.461,666.441,860.035,666.684,860.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.336,858.516c-0.129-0.281-0.473-0.395-0.738-0.258c-0.281,0.125-0.41,0.469-0.27,0.746 c0.137,0.273,0.465,0.398,0.746,0.258C666.352,859.129,666.469,858.789,666.336,858.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.047,858.082c-0.082-0.176-0.297-0.254-0.477-0.164 c-0.176,0.082-0.254,0.297-0.16,0.476c0.07,0.176,0.289,0.25,0.469,0.172C669.063,858.481,669.129,858.262,669.047,858.082 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.617,854.16c-0.238-0.473-0.801-0.668-1.277-0.442c-0.461,0.227-0.672,0.793-0.441,1.27 c0.227,0.469,0.797,0.672,1.27,0.438C669.637,855.203,669.844,854.633,669.617,854.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M667.555,852.996c-0.125-0.277-0.465-0.394-0.746-0.258 c-0.277,0.137-0.398,0.461-0.258,0.738c0.133,0.289,0.473,0.402,0.746,0.266 C667.578,853.606,667.691,853.273,667.555,852.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.793,852.398c-0.176,0.086-0.254,0.301-0.172,0.477c0.09,0.176,0.309,0.254,0.484,0.164 c0.18-0.078,0.25-0.297,0.164-0.477C670.176,852.383,669.969,852.313,669.793,852.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M665.18,840.023c-0.242-0.473-0.805-0.676-1.281-0.445c-0.469,0.23-0.676,0.793-0.441,1.266 c0.227,0.473,0.801,0.672,1.273,0.445C665.199,841.059,665.398,840.496,665.18,840.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M662.371,838.59c-0.277,0.137-0.398,0.477-0.266,0.75c0.145,0.277,0.473,0.398,0.754,0.258 c0.266-0.133,0.395-0.469,0.258-0.742C662.98,838.578,662.648,838.457,662.371,838.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M665.832,838.422c-0.094-0.184-0.309-0.258-0.484-0.164 c-0.168,0.078-0.246,0.293-0.164,0.473c0.086,0.18,0.301,0.254,0.477,0.172 C665.836,838.813,665.914,838.606,665.832,838.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.594,842.856c-0.449-0.723-1.402-0.941-2.129-0.484 c-0.723,0.445-0.945,1.402-0.488,2.129c0.449,0.727,1.41,0.941,2.129,0.488 C676.828,844.535,677.051,843.578,676.594,842.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M674.195,846.18c-0.262-0.43-0.828-0.555-1.25-0.285c-0.426,0.262-0.555,0.828-0.289,1.25 c0.262,0.43,0.828,0.559,1.254,0.289C674.336,847.168,674.465,846.606,674.195,846.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M672.563,841.766c-0.168-0.273-0.519-0.352-0.793-0.176 c-0.273,0.16-0.359,0.531-0.184,0.793c0.164,0.273,0.52,0.359,0.797,0.191 C672.656,842.402,672.746,842.039,672.563,841.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M673.516,839.418c0.203-0.828-0.305-1.668-1.133-1.867 c-0.828-0.207-1.672,0.309-1.871,1.133c-0.207,0.832,0.305,1.668,1.125,1.875 C672.477,840.758,673.309,840.25,673.516,839.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.461,840.023c0.117-0.492-0.18-0.984-0.668-1.109c-0.492-0.121-0.981,0.188-1.106,0.676 c-0.117,0.484,0.18,0.977,0.668,1.094C668.848,840.801,669.332,840.508,669.461,840.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M670.453,835.977c0.078,0.109,0.191,0.191,0.324,0.219c0.234,0.055,0.473-0.031,0.613-0.219 H670.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.434,839.441c0.445-0.719,0.227-1.68-0.492-2.133c-0.723-0.453-1.684-0.234-2.129,0.492 c-0.461,0.719-0.234,1.676,0.484,2.133C679.019,840.383,679.98,840.168,680.434,839.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M679.519,842.606c0.266-0.426,0.145-0.984-0.285-1.258c-0.43-0.266-0.996-0.137-1.258,0.285 c-0.266,0.426-0.137,0.992,0.293,1.258C678.699,843.156,679.254,843.027,679.519,842.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M675.043,838.277c-0.176,0.273-0.09,0.629,0.187,0.801c0.262,0.176,0.629,0.086,0.793-0.184 c0.176-0.269,0.094-0.633-0.184-0.801C675.57,837.922,675.211,838,675.043,838.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M679.336,849.641c0.063-0.629-0.402-1.184-1.027-1.238c-0.629-0.059-1.184,0.41-1.238,1.031 c-0.059,0.629,0.406,1.18,1.039,1.238C678.73,850.727,679.281,850.262,679.336,849.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.457,850.519c0.027-0.363-0.238-0.695-0.609-0.723 c-0.371-0.031-0.695,0.238-0.723,0.605c-0.031,0.367,0.234,0.699,0.605,0.734 C676.098,851.164,676.418,850.894,676.457,850.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.996,847.602c0.227,0.019,0.441-0.156,0.465-0.395c0.016-0.226-0.156-0.441-0.391-0.457 c-0.242-0.023-0.449,0.152-0.469,0.387C676.582,847.367,676.766,847.574,676.996,847.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.316,863.606c0.059-0.621-0.406-1.176-1.039-1.231 c-0.617-0.059-1.168,0.398-1.227,1.027c-0.055,0.629,0.402,1.18,1.027,1.242 C679.703,864.695,680.258,864.234,680.316,863.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M677.43,864.492c0.031-0.363-0.242-0.691-0.602-0.723c-0.371-0.031-0.703,0.234-0.73,0.598 c-0.035,0.375,0.238,0.703,0.602,0.731C677.07,865.133,677.402,864.863,677.43,864.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M678.434,861.176c0.019-0.234-0.148-0.438-0.383-0.461 c-0.238-0.027-0.445,0.148-0.469,0.387c-0.019,0.234,0.152,0.445,0.387,0.469 C678.211,861.59,678.41,861.41,678.434,861.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M678.953,857.074c0.051-0.625-0.41-1.18-1.043-1.234c-0.625-0.063-1.172,0.406-1.234,1.035 c-0.055,0.629,0.406,1.172,1.035,1.231C678.336,858.16,678.894,857.699,678.953,857.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.063,857.961c0.027-0.371-0.242-0.703-0.609-0.73c-0.371-0.031-0.703,0.242-0.73,0.609 c-0.031,0.375,0.242,0.695,0.609,0.727C675.707,858.594,676.023,858.332,676.063,857.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M677.063,854.648c0.019-0.234-0.148-0.449-0.387-0.465 c-0.234-0.023-0.449,0.152-0.469,0.391c-0.012,0.234,0.164,0.438,0.395,0.465 C676.836,855.059,677.043,854.883,677.063,854.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.746,853.148c-0.227-0.469-0.797-0.668-1.273-0.445 c-0.469,0.234-0.668,0.801-0.438,1.273c0.227,0.473,0.793,0.672,1.27,0.441 C680.773,854.191,680.977,853.621,680.746,853.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M678.699,851.988c-0.141-0.285-0.48-0.406-0.75-0.266c-0.285,0.133-0.402,0.469-0.269,0.746 c0.141,0.285,0.473,0.391,0.754,0.266C678.707,852.59,678.828,852.262,678.699,851.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.926,851.383c-0.18,0.09-0.258,0.301-0.16,0.477c0.063,0.152,0.211,0.215,0.367,0.195 v-0.695C681.055,851.348,680.988,851.356,680.926,851.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M668.438,888.098c-0.723,0.453-0.941,1.406-0.488,2.137c0.449,0.719,1.41,0.938,2.129,0.48 c0.727-0.449,0.941-1.402,0.484-2.125C670.113,887.867,669.16,887.644,668.438,888.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M668.176,891.91c-0.269-0.422-0.828-0.551-1.258-0.289c-0.426,0.27-0.555,0.84-0.293,1.254 c0.273,0.426,0.832,0.559,1.258,0.293C668.313,892.902,668.438,892.34,668.176,891.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.352,888.305c0.273-0.172,0.359-0.527,0.188-0.805c-0.168-0.269-0.523-0.352-0.801-0.18 c-0.273,0.172-0.355,0.527-0.18,0.797C665.73,888.391,666.078,888.481,666.352,888.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.539,883.422c-0.449-0.73-1.406-0.953-2.125-0.496 c-0.723,0.457-0.945,1.414-0.496,2.133c0.457,0.723,1.414,0.945,2.141,0.492 C676.773,885.094,676.996,884.137,676.539,883.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M674.148,886.746c-0.269-0.43-0.828-0.559-1.258-0.289c-0.43,0.262-0.555,0.824-0.289,1.254 c0.27,0.422,0.828,0.555,1.258,0.289C674.285,887.731,674.414,887.168,674.148,886.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M671.711,882.144c-0.273,0.176-0.344,0.527-0.184,0.809c0.168,0.27,0.531,0.348,0.805,0.176 c0.27-0.164,0.356-0.523,0.184-0.797C672.344,882.063,671.984,881.977,671.711,882.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M671.113,894.574c-0.613-0.055-1.176,0.414-1.234,1.031 c-0.055,0.625,0.414,1.188,1.039,1.234c0.633,0.059,1.18-0.406,1.226-1.031 C672.207,895.184,671.742,894.629,671.113,894.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.266,896.695c0.039-0.371-0.242-0.695-0.609-0.734 c-0.363-0.027-0.692,0.246-0.731,0.617c-0.027,0.367,0.25,0.691,0.617,0.723 C668.91,897.336,669.238,897.07,669.266,896.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.805,893.766c0.23,0.023,0.441-0.152,0.465-0.387c0.024-0.231-0.156-0.441-0.391-0.461 c-0.234-0.024-0.449,0.144-0.473,0.383C669.391,893.547,669.566,893.75,669.805,893.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.246,892.344c0.059-0.629-0.398-1.183-1.027-1.238c-0.621-0.051-1.18,0.402-1.231,1.031 c-0.059,0.629,0.398,1.184,1.027,1.238S680.199,892.973,680.246,892.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M677.371,893.227c0.031-0.363-0.246-0.695-0.606-0.719 c-0.379-0.039-0.699,0.234-0.734,0.609c-0.039,0.359,0.246,0.684,0.609,0.723 C677.004,893.871,677.344,893.602,677.371,893.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M677.508,889.832c-0.008,0.246,0.156,0.449,0.391,0.465 c0.238,0.023,0.449-0.145,0.469-0.379c0.019-0.238-0.156-0.449-0.391-0.465 C677.742,889.434,677.539,889.606,677.508,889.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M678.531,897.707c-0.535-0.32-1.219-0.144-1.535,0.379h1.926 C678.828,897.93,678.699,897.793,678.531,897.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M677.813,896.676c0.324,0.191,0.731,0.078,0.918-0.242c0.184-0.316,0.086-0.73-0.242-0.914 c-0.32-0.184-0.727-0.082-0.91,0.238C677.383,896.078,677.488,896.488,677.813,896.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.984,897.18c0.016-0.371-0.262-0.688-0.637-0.707c-0.367-0.02-0.688,0.266-0.703,0.637 c-0.019,0.363,0.258,0.684,0.633,0.703C666.644,897.832,666.961,897.547,666.984,897.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.664,897.844c-0.168-0.012-0.332,0.086-0.402,0.242h0.766 C669.957,897.949,669.824,897.848,669.664,897.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M674.898,892.719c-0.227-0.469-0.793-0.668-1.266-0.445 c-0.469,0.234-0.668,0.797-0.441,1.273c0.227,0.477,0.785,0.66,1.262,0.438 C674.926,893.762,675.125,893.191,674.898,892.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M672.848,891.547c-0.137-0.27-0.473-0.387-0.746-0.258c-0.281,0.133-0.395,0.473-0.262,0.75 c0.133,0.273,0.465,0.394,0.75,0.262C672.859,892.164,672.984,891.832,672.848,891.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M675.082,890.953c-0.184,0.09-0.258,0.305-0.168,0.48c0.082,0.172,0.297,0.246,0.473,0.16 c0.184-0.086,0.258-0.289,0.164-0.469C675.473,890.941,675.258,890.867,675.082,890.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.406,888.957c-0.031,0.371,0.25,0.703,0.609,0.731c0.039,0.004,0.078-0.008,0.117-0.016 v-1.313C680.766,888.328,680.438,888.598,680.406,888.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.012,896.402c-0.031,0.363,0.234,0.688,0.609,0.727 c0.195,0.012,0.375-0.055,0.512-0.184v-0.973c-0.106-0.098-0.242-0.172-0.398-0.184 C680.375,895.754,680.043,896.027,680.012,896.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M674.285,863.465c-0.461-0.719-1.414-0.938-2.141-0.484 c-0.719,0.445-0.941,1.406-0.488,2.121c0.449,0.73,1.41,0.945,2.141,0.5C674.519,865.152,674.73,864.188,674.285,863.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M670.348,867.762c0.254,0.426,0.816,0.551,1.246,0.289c0.426-0.273,0.551-0.832,0.289-1.254 c-0.27-0.426-0.832-0.559-1.254-0.289C670.199,866.769,670.078,867.328,670.348,867.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.449,862.199c-0.277,0.164-0.348,0.527-0.184,0.801 c0.164,0.269,0.531,0.359,0.805,0.184c0.277-0.172,0.355-0.531,0.184-0.801 C670.086,862.106,669.723,862.027,669.449,862.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M668.137,865.652c-0.703-0.48-1.676-0.316-2.156,0.387c-0.484,0.699-0.32,1.664,0.383,2.156 c0.695,0.484,1.676,0.313,2.16-0.387C669.012,867.106,668.832,866.141,668.137,865.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M667.238,869.652c-0.418-0.281-0.984-0.184-1.266,0.231 c-0.297,0.41-0.188,0.973,0.223,1.269c0.414,0.285,0.98,0.184,1.269-0.23C667.746,870.508,667.648,869.941,667.238,869.652 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M664,866.238c-0.266-0.18-0.625-0.117-0.805,0.145c-0.184,0.269-0.125,0.621,0.141,0.816 c0.27,0.18,0.625,0.117,0.82-0.141C664.32,866.789,664.262,866.43,664,866.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M668.855,874.625c-0.633-0.055-1.18,0.402-1.227,1.035c-0.07,0.629,0.398,1.18,1.023,1.234 c0.629,0.059,1.184-0.41,1.238-1.039C669.941,875.231,669.48,874.68,668.855,874.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M667,876.746c0.039-0.363-0.234-0.695-0.609-0.73c-0.363-0.027-0.691,0.246-0.719,0.613 c-0.039,0.371,0.242,0.688,0.602,0.723C666.644,877.391,666.973,877.113,667,876.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M667.535,873.82c0.238,0.023,0.445-0.152,0.469-0.387c0.023-0.238-0.152-0.449-0.387-0.469 c-0.242-0.019-0.441,0.152-0.465,0.391C667.133,873.59,667.301,873.801,667.535,873.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.957,871.152c-0.633-0.047-1.184,0.418-1.234,1.039 c-0.055,0.629,0.402,1.18,1.031,1.238c0.625,0.055,1.176-0.406,1.242-1.039 C678.051,871.769,677.582,871.219,676.957,871.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M675.102,873.277c0.031-0.363-0.234-0.688-0.602-0.73c-0.367-0.027-0.695,0.246-0.727,0.609 c-0.035,0.375,0.234,0.703,0.602,0.731C674.742,873.922,675.074,873.648,675.102,873.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.105,869.977c0.02-0.25-0.156-0.449-0.383-0.469c-0.234-0.031-0.441,0.144-0.465,0.379 c-0.027,0.238,0.152,0.449,0.387,0.473C675.879,870.375,676.086,870.199,676.105,869.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.277,877.75c-0.547-0.316-1.246-0.137-1.57,0.406c-0.313,0.543-0.129,1.242,0.414,1.563 c0.535,0.317,1.238,0.133,1.555-0.41C676.996,878.773,676.816,878.074,676.277,877.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M676.227,875.574c-0.316-0.191-0.727-0.082-0.914,0.234 c-0.188,0.324-0.082,0.734,0.238,0.926c0.313,0.18,0.731,0.07,0.926-0.25C676.656,876.172,676.543,875.754,676.227,875.574 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M678.113,879.051c0.203,0.117,0.473,0.051,0.594-0.148c0.113-0.211,0.051-0.469-0.16-0.586 c-0.199-0.125-0.461-0.059-0.578,0.144C677.852,878.672,677.91,878.934,678.113,879.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M667.219,883.09c-0.047,0.629,0.414,1.18,1.043,1.238c0.625,0.059,1.168-0.402,1.234-1.039 c0.051-0.621-0.406-1.172-1.035-1.227S667.277,882.469,667.219,883.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M666.605,884.188c0.039-0.371-0.234-0.695-0.613-0.731 c-0.359-0.035-0.684,0.238-0.711,0.602c-0.043,0.371,0.234,0.699,0.602,0.738 C666.25,884.832,666.582,884.551,666.605,884.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M667.609,880.867c0.023-0.23-0.152-0.441-0.391-0.465c-0.234-0.019-0.438,0.148-0.461,0.391 c-0.027,0.238,0.148,0.445,0.383,0.465C667.375,881.277,667.59,881.102,667.609,880.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M671.871,879.555c-0.234-0.473-0.793-0.672-1.27-0.445c-0.469,0.23-0.672,0.797-0.449,1.273 c0.234,0.469,0.801,0.668,1.273,0.438C671.898,880.59,672.102,880.027,671.871,879.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M668.813,878.871c0.133,0.277,0.469,0.398,0.746,0.258c0.277-0.129,0.394-0.461,0.262-0.738 c-0.137-0.289-0.473-0.395-0.75-0.266C668.793,878.258,668.68,878.594,668.813,878.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M672.359,878.434c0.176-0.082,0.254-0.297,0.164-0.477c-0.082-0.176-0.297-0.25-0.477-0.172 c-0.176,0.094-0.246,0.308-0.164,0.477C671.965,878.441,672.176,878.519,672.359,878.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M672.633,872.773c-0.231-0.48-0.793-0.684-1.266-0.449 c-0.473,0.234-0.676,0.797-0.445,1.277c0.23,0.473,0.793,0.664,1.277,0.438 C672.668,873.813,672.859,873.238,672.633,872.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M669.578,872.09c0.133,0.277,0.461,0.395,0.746,0.262c0.277-0.137,0.395-0.465,0.258-0.75 c-0.137-0.277-0.469-0.391-0.746-0.262C669.559,871.477,669.441,871.813,669.578,872.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M672.813,871.004c-0.172,0.086-0.25,0.301-0.164,0.48c0.086,0.176,0.297,0.25,0.477,0.168 c0.176-0.09,0.254-0.309,0.168-0.48C673.203,870.992,672.992,870.922,672.813,871.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.102,868.039c-0.059,0.629,0.398,1.18,1.031,1.234v-2.269 C680.59,867.063,680.144,867.484,680.102,868.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M679.484,869.133c0.027-0.375-0.234-0.691-0.609-0.723 c-0.371-0.043-0.695,0.238-0.727,0.602c-0.035,0.367,0.238,0.699,0.609,0.73 C679.125,869.769,679.445,869.508,679.484,869.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.484,865.816c0.016-0.234-0.152-0.441-0.383-0.461 c-0.242-0.024-0.449,0.148-0.465,0.383c-0.031,0.242,0.145,0.453,0.375,0.465 C680.246,866.223,680.461,866.047,680.484,865.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M681.074,882.019c-0.019,0.156,0.008,0.313,0.059,0.457v-0.723 C681.105,881.84,681.082,881.922,681.074,882.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.457,883.094c0.027-0.363-0.242-0.691-0.609-0.719 c-0.375-0.031-0.691,0.238-0.723,0.609c-0.039,0.363,0.234,0.695,0.602,0.727 C680.102,883.738,680.418,883.473,680.457,883.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M681.066,879.324c-0.231-0.023-0.445,0.152-0.465,0.387 c-0.012,0.234,0.164,0.445,0.395,0.465c0.051,0.012,0.09-0.008,0.137-0.02v-0.816 C681.109,879.336,681.094,879.324,681.066,879.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.934,874.449c-0.629-0.059-1.18,0.406-1.231,1.027c-0.051,0.629,0.414,1.18,1.027,1.242 c0.145,0.008,0.277-0.012,0.402-0.039v-2.199C681.066,874.469,681.008,874.453,680.934,874.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M679.086,876.563c0.031-0.367-0.242-0.688-0.613-0.723c-0.363-0.031-0.68,0.246-0.711,0.613 c-0.043,0.363,0.234,0.695,0.594,0.723C678.727,877.211,679.055,876.934,679.086,876.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.082,873.258c0.027-0.242-0.152-0.445-0.387-0.465c-0.231-0.02-0.441,0.144-0.461,0.379 c-0.016,0.238,0.145,0.449,0.391,0.473C679.859,873.668,680.07,873.484,680.082,873.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006F7E"
    },
    d: "M680.707,871.078c0.086,0.172,0.242,0.266,0.426,0.301v-1.086 c-0.051,0.008-0.117,0.008-0.164,0.039C680.691,870.461,680.578,870.797,680.707,871.078z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 619.121,
    y: 874.68,
    style: {
      fill: "#C94757"
    },
    width: 184.27,
    height: 23.406
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.121,
    y: 874.68,
    style: {
      fill: "#B22E3C"
    },
    width: 184.27,
    height: 6.359
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E35163"
    },
    d: "M623.023,896.801c0-1.965,39.68-7.66,88.504-7.66c48.82,0,87.957,6.977,87.957,8.945 c0,1.949-37.543-0.168-86.359-0.168C664.313,897.918,623.023,898.754,623.023,896.801z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.289,
    y: 888.359,
    style: {
      fill: "#E35163"
    },
    width: 55.941,
    height: 17.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.289,
    y: 888.359,
    style: {
      fill: "#C94757"
    },
    width: 55.941,
    height: 9.726
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B22E3C"
    },
    d: "M695.16,906.34h32.191c3.594,0,6.492-2.914,6.492-6.488h-45.172 C688.672,903.426,691.57,906.34,695.16,906.34z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.539,
    y: 906.34,
    style: {
      fill: "#B22E3C"
    },
    width: 27.434,
    height: 14.723
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.172,
    y: 1180.004,
    style: {
      fill: "#B22E3C"
    },
    width: 24.168,
    height: 7.363
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAC52F"
    },
    points: "812.699,1100.547 734.43,1092.824 734.43,1033.617 812.699,1023.313  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC52F"
    },
    d: "M734.43,1033.617c0,0-7.633-24.828-37.887-24.242c-30.25,0.574-29.57,68.707-20.793,78.977 c8.781,10.266,28.773,21.852,58.68,4.473C764.328,1075.449,734.43,1033.617,734.43,1033.617z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.8854d7ddf588b3e086efc448e9c04497.svg";
export { ForwardRef as ReactComponent };